/**
 * Custom.js - Логика перестановки элементов на страницах, создаваемых приложением Loop
 * Этот файл содержит всю логику для перестановки элементов, которая применяется после загрузки HTML
 */

(function () {
  'use strict';

  /**
   * Перестановка #1: Переместить loop-bundle-size-selector-new-wrapper под loop-selected-bundle-info
   */
  function moveSizeSelectorUnderBundleInfo() {
    const sizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
    const bundleInfo = document.querySelector('.loop-selected-bundle-info');

    if (sizeSelector && bundleInfo && sizeSelector.parentNode && bundleInfo.parentNode) {
      // Проверяем, не находится ли уже элемент в нужном месте
      if (sizeSelector.parentNode !== bundleInfo) {
        try {
          bundleInfo.appendChild(sizeSelector);
        } catch (e) {
          console.warn('[custom.js] Перестановка #1: Ошибка при перемещении элемента:', e);
        }
      }
    }
  }

  /**
   * Перестановка #2: Переместить loop-bundle-select-product-title-new-container под loop-bundle-size-selector-new-wrapper
   */
  function moveProductTitleUnderSizeSelector() {
    const productTitle = document.querySelector('.loop-bundle-select-product-title-new-container');
    const sizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');

    if (productTitle && sizeSelector && productTitle.parentNode && sizeSelector.parentNode) {
      // Проверяем, не находится ли уже элемент в нужном месте (productTitle должен быть сразу после sizeSelector)
      const isAlreadyInPlace = productTitle.parentNode === sizeSelector.parentNode &&
        productTitle.previousSibling === sizeSelector;

      if (!isAlreadyInPlace) {
        try {
          // Вставляем productTitle после sizeSelector
          if (sizeSelector.nextSibling) {
            sizeSelector.parentNode.insertBefore(productTitle, sizeSelector.nextSibling);
          } else {
            sizeSelector.parentNode.appendChild(productTitle);
          }
        } catch (e) {
          console.warn('[custom.js] Перестановка #2: Ошибка при перемещении элемента:', e);
        }
      }
    }
  }

  /**
   * Перестановка #3: Создать элемент p с текстом "How often would you like us to send them to you? Get extra 26% on subscriptions" под loop-bundle-select-product-title-new-container
   */
  function createFrequencyQuestion() {
    const productTitle = document.querySelector('.loop-bundle-select-product-title-new-container');
    const questionId = 'loop-frequency-question';

    // Проверяем, не создан ли уже этот элемент
    if (document.getElementById(questionId)) {
      return;
    }

    if (productTitle && productTitle.parentNode) {
      const questionP = document.createElement('p');
      questionP.id = questionId;
      questionP.className = 'loop-question-label';
      questionP.innerHTML = 'How often would you like us to send them to you? <b>Get extra 26%</b> on subscriptions!';

      // Вставляем после productTitle
      try {
        if (productTitle.nextSibling) {
          productTitle.parentNode.insertBefore(questionP, productTitle.nextSibling);
        } else {
          productTitle.parentNode.appendChild(questionP);
        }
      } catch (e) {
        console.warn('[custom.js] Перестановка #3: Ошибка при вставке элемента:', e);
      }
    }
  }

  /**
   * Перестановка #4: Переместить loop-bundle-widget-container под loop-frequency-question и применить стили
   */
  function moveWidgetContainerAndApplyStyles() {
    const frequencyQuestion = document.getElementById('loop-frequency-question');
    const widgetContainer = document.querySelector('.loop-bundle-widget-container');

    if (!frequencyQuestion || !widgetContainer) {
      return;
    }

    // Проверяем, не перемещен ли уже контейнер (должен быть сразу после frequencyQuestion)
    const isAlreadyMoved = widgetContainer.parentNode === frequencyQuestion.parentNode &&
      widgetContainer.previousSibling === frequencyQuestion;

    if (!isAlreadyMoved && frequencyQuestion.parentNode && widgetContainer.parentNode) {
      // Перемещаем контейнер под вопрос
      try {
        if (frequencyQuestion.nextSibling) {
          frequencyQuestion.parentNode.insertBefore(widgetContainer, frequencyQuestion.nextSibling);
        } else {
          frequencyQuestion.parentNode.appendChild(widgetContainer);
        }
      } catch (e) {
        console.warn('[custom.js] Перестановка #4: Ошибка при перемещении элемента:', e);
      }
    }

    // Применяем стили к элементам с классом loop-bundle-widget-selling-plan-container
    const sellingPlanContainers = widgetContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');

    sellingPlanContainers.forEach(function (container) {
      // Проверяем, не применены ли уже стили (чтобы не перезаписывать при каждом вызове)
      if (container.hasAttribute('data-styles-applied')) {
        return;
      }

      // Определяем активное состояние и применяем цвет фона
      const isActive = container.classList.contains('active') ||
        container.hasAttribute('data-active') ||
        container.classList.contains('selected') ||
        container.getAttribute('aria-pressed') === 'true';

      if (isActive) {
        container.style.backgroundColor = '#A9FA63';
      } else {
        container.style.backgroundColor = 'transparent';
      }

      // Отслеживаем изменения активного состояния через MutationObserver
      const containerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' &&
            (mutation.attributeName === 'class' ||
              mutation.attributeName === 'data-active' ||
              mutation.attributeName === 'aria-pressed')) {

            const isNowActive = container.classList.contains('active') ||
              container.hasAttribute('data-active') ||
              container.classList.contains('selected') ||
              container.getAttribute('aria-pressed') === 'true';

            container.style.backgroundColor = isNowActive ? '#A9FA63' : 'transparent';
          }
        });
      });

      containerObserver.observe(container, {
        attributes: true,
        attributeFilter: ['class', 'data-active', 'aria-pressed']
      });

      // Помечаем, что стили применены
      container.setAttribute('data-styles-applied', 'true');
    });

  }

  /**
   * Перестановка #5: Управление классом selected для loop-bundle-product-wrapper
   * Добавляет класс selected, когда появляется loop-bundle-product-quantity-controls
   * Удаляет класс selected, когда появляется loop-add-product-btn
   */
  function manageProductWrapperSelectedClass() {
    const productWrappers = document.querySelectorAll('.loop-bundle-product-wrapper');

    productWrappers.forEach(function (wrapper) {
      // Проверяем, не отслеживается ли уже этот wrapper
      if (wrapper.hasAttribute('data-selected-class-managed')) {
        return;
      }

      const cardFooter = wrapper.querySelector('.loop-card-footer');
      if (!cardFooter) {
        return;
      }

      // Функция для проверки и обновления класса selected
      function updateSelectedClass() {
        const hasQuantityControls = cardFooter.querySelector('.loop-bundle-product-quantity-controls') !== null;
        const hasAddButton = cardFooter.querySelector('.loop-add-product-btn') !== null;

        if (hasQuantityControls && !hasAddButton) {
          // Селектор количества присутствует - добавляем класс selected
          wrapper.classList.add('selected');
        } else if (hasAddButton && !hasQuantityControls) {
          // Кнопка добавления присутствует - удаляем класс selected
          wrapper.classList.remove('selected');
        }
      }

      // Применяем сразу для существующих элементов
      updateSelectedClass();

      // Отслеживаем изменения в loop-card-footer
      const footerObserver = new MutationObserver(function (mutations) {
        let shouldUpdate = false;

        mutations.forEach(function (mutation) {
          // Отслеживаем добавление/удаление дочерних элементов
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1 && (
                node.classList.contains('loop-bundle-product-quantity-controls') ||
                node.classList.contains('loop-add-product-btn') ||
                node.querySelector('.loop-bundle-product-quantity-controls') ||
                node.querySelector('.loop-add-product-btn')
              )) {
                shouldUpdate = true;
              }
            });

            mutation.removedNodes.forEach(function (node) {
              if (node.nodeType === 1 && (
                node.classList.contains('loop-bundle-product-quantity-controls') ||
                node.classList.contains('loop-add-product-btn') ||
                node.querySelector('.loop-bundle-product-quantity-controls') ||
                node.querySelector('.loop-add-product-btn')
              )) {
                shouldUpdate = true;
              }
            });
          }
        });

        if (shouldUpdate) {
          // Применяем немедленно, без задержки
          updateSelectedClass();

          // Также применяем стили к кнопкам немедленно при их появлении
          requestAnimationFrame(function () {
            const addButtons = cardFooter.querySelectorAll('.loop-add-product-btn, .loop-btn-add-product');
            addButtons.forEach(function (btn) {
              // Принудительно применяем стили немедленно
              btn.style.display = '';
              btn.style.visibility = '';
              btn.style.opacity = '';
            });
          });
        }
      });

      // Начинаем наблюдение за изменениями в cardFooter
      footerObserver.observe(cardFooter, {
        childList: true,
        subtree: true
      });

      // Помечаем wrapper как управляемый
      wrapper.setAttribute('data-selected-class-managed', 'true');
    });
  }

  /**
   * Перестановка #6: Создать абзац с текстом "How many pots total would you like?" под loop-h2.loop-bundle-size-selector-label
   */
  function createPotsTotalQuestion() {
    const sizeSelectorLabel = document.querySelector('.loop-h2.loop-bundle-size-selector-label');
    const questionId = 'loop-pots-total-question';

    // Проверяем, не создан ли уже этот элемент
    if (document.getElementById(questionId)) {
      return;
    }

    if (sizeSelectorLabel && sizeSelectorLabel.parentNode) {
      const questionP = document.createElement('p');
      questionP.id = questionId;
      questionP.className = 'loop-question-label';
      questionP.textContent = 'How many pots total would you like?';

      // Вставляем после sizeSelectorLabel
      try {
        if (sizeSelectorLabel.nextSibling) {
          sizeSelectorLabel.parentNode.insertBefore(questionP, sizeSelectorLabel.nextSibling);
        } else {
          sizeSelectorLabel.parentNode.appendChild(questionP);
        }
      } catch (e) {
        console.warn('[custom.js] Перестановка #6: Ошибка при вставке элемента:', e);
      }
    }
  }

  /**
   * Перестановка #7: Создать заголовок и вопрос перед loop-selected-bundle-items
   */
  function createSelectedBundleItemsHeader() {
    const selectedBundleItems = document.querySelector('.loop-selected-bundle-items');
    const headerId = 'loop-selected-bundle-items-header';

    // Проверяем, не создан ли уже этот элемент
    if (document.getElementById(headerId)) {
      return;
    }

    if (selectedBundleItems && selectedBundleItems.parentNode) {
      // Создаем контейнер для заголовка и вопроса
      const headerContainer = document.createElement('div');
      headerContainer.id = headerId;

      // Создаем заголовок
      const titleDiv = document.createElement('div');
      titleDiv.className = 'loop-h2 loop-selected-bundle-items-title';
      titleDiv.textContent = 'SELECT POTS';

      // Создаем вопрос
      const questionP = document.createElement('p');
      questionP.className = 'loop-question-label';
      questionP.textContent = 'Which pots would you like to choose?';

      // Добавляем заголовок и вопрос в контейнер
      headerContainer.appendChild(titleDiv);
      headerContainer.appendChild(questionP);

      // Вставляем контейнер перед selectedBundleItems
      try {
        selectedBundleItems.parentNode.insertBefore(headerContainer, selectedBundleItems);
      } catch (e) {
        console.warn('[custom.js] Перестановка #7: Ошибка при вставке элемента:', e);
      }
    }
  }

  /**
   * Перестановка #8: Реорганизация элементов в loop-bundle-widget-add-to-cart-container и создание per-meal badge
   */
  function reorganizeAddToCartContainer() {
    const addToCartContainer = document.querySelector('.loop-bundle-widget-add-to-cart-container');
    if (!addToCartContainer) {
      return;
    }

    // Проверяем, не реорганизован ли уже контейнер
    if (addToCartContainer.hasAttribute('data-reorganized')) {
      updatePerMealBadge();
      return;
    }

    // Создаем контейнер для цены и кнопки
    const totalPriceButtonContainer = document.createElement('div');
    totalPriceButtonContainer.className = 'loop-bundle-widget-total-price-button-container';

    // Создаем p с текстом "TOTAL:"
    const totalP = document.createElement('h2');
    totalP.textContent = 'TOTAL:';
    totalPriceButtonContainer.appendChild(totalP);

    // Создаем новый price-button-container (не перемещаем оригинальный!)
    const priceButtonContainer = document.createElement('div');
    priceButtonContainer.className = 'loop-bundle-widget-selling-plan-price-button-container';

    // Создаем элементы для цен
    const discountPriceP = document.createElement('p');
    discountPriceP.className = 'loop-text-p5 m-0 loop-bundle-widget-selling-plan-discount-price';
    discountPriceP.textContent = '';

    const actualPriceP = document.createElement('p');
    actualPriceP.className = 'loop-text-p5 m-0 loop-bundle-widget-selling-plan-actual-price';
    actualPriceP.textContent = '';

    // Добавляем элементы в контейнер
    priceButtonContainer.appendChild(discountPriceP);
    priceButtonContainer.appendChild(actualPriceP);

    // Добавляем контейнер в totalPriceButtonContainer
    totalPriceButtonContainer.appendChild(priceButtonContainer);

    // Вставляем totalPriceButtonContainer первым элементом в addToCartContainer
    if (addToCartContainer.firstChild) {
      addToCartContainer.insertBefore(totalPriceButtonContainer, addToCartContainer.firstChild);
    } else {
      addToCartContainer.appendChild(totalPriceButtonContainer);
    }

    // Создаем per-meal badge
    const perMealBadge = document.createElement('div');
    perMealBadge.className = 'loop-bundle-widget-per-meal-badge';
    perMealBadge.id = 'loop-bundle-widget-per-meal-badge';
    perMealBadge.style.display = 'none'; // По умолчанию скрыт

    // Вставляем per-meal badge после totalPriceButtonContainer
    if (totalPriceButtonContainer.nextSibling) {
      addToCartContainer.insertBefore(perMealBadge, totalPriceButtonContainer.nextSibling);
    } else {
      addToCartContainer.appendChild(perMealBadge);
    }

    // Помечаем контейнер как реорганизованный
    addToCartContainer.setAttribute('data-reorganized', 'true');

    // Используем глобальную функцию updatePerMealBadge

    // Отслеживаем изменения класса disabled и атрибута disabled у кнопки add-to-cart
    let addToCartObserverTimeout = null;
    const addToCartObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' &&
          (mutation.attributeName === 'class' || mutation.attributeName === 'disabled')) {
          // Debounce для предотвращения бесконечных циклов
          if (addToCartObserverTimeout) {
            clearTimeout(addToCartObserverTimeout);
          }
          addToCartObserverTimeout = setTimeout(function () {
            updatePerMealBadge();
          }, 200);
        }
      });
    });

    if (addToCartContainer.querySelector('.loop-btn-add-to-cart')) {
      addToCartObserver.observe(addToCartContainer.querySelector('.loop-btn-add-to-cart'), {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    // Изменения цен отслеживаются через startPriceUpdateObserver() в selectedObserver

    // Отслеживаем изменения в выбранной кнопке размера
    let sizeButtonsObserverTimeout = null;
    const sizeButtonsObserver = new MutationObserver(function () {
      // Debounce для предотвращения бесконечных циклов
      if (sizeButtonsObserverTimeout) {
        clearTimeout(sizeButtonsObserverTimeout);
      }
      sizeButtonsObserverTimeout = setTimeout(function () {
        updatePerMealBadge();
      }, 200);
    });

    const sizeButtonsContainer = document.querySelector('.loop-bundle-size-selector-new-wrapper');
    if (sizeButtonsContainer) {
      sizeButtonsObserver.observe(sizeButtonsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // Отслеживаем изменения класса selected на кнопках размера для обновления заголовка
      let sizeButtonTitleObserverTimeout = null;
      const sizeButtonTitleObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Debounce для предотвращения бесконечных циклов
            if (sizeButtonTitleObserverTimeout) {
              clearTimeout(sizeButtonTitleObserverTimeout);
            }
            sizeButtonTitleObserverTimeout = setTimeout(function () {
              updateBundleTitleFromSelectedSize();
            }, 200);
          }
        });
      });

      // Наблюдаем за всеми кнопками размера
      const sizeButtons = sizeButtonsContainer.querySelectorAll('.loop-bundle-size-selector-btn');
      sizeButtons.forEach(function (btn) {
        sizeButtonTitleObserver.observe(btn, {
          attributes: true,
          attributeFilter: ['class']
        });
      });

      // Также наблюдаем за контейнером для отслеживания новых кнопок
      sizeButtonTitleObserver.observe(sizeButtonsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Вызываем сразу для установки начального состояния
    updatePerMealBadge();
    updateDuplicatePriceContainer(); // Обновляем цены в обоих контейнерах при инициализации

    // Отслеживаем изменения класса selected в loop-bundle-widget-selling-plan-container
    let selectedObserverTimeout = null;
    const selectedObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Debounce для предотвращения бесконечных циклов
          if (selectedObserverTimeout) {
            clearTimeout(selectedObserverTimeout);
          }
          selectedObserverTimeout = setTimeout(function () {
            updateDuplicatePriceContainer();
            // Перезапускаем observer для цен, так как selected элемент мог измениться
            startPriceUpdateObserver();
          }, 200);
        }
      });
    });

    // Наблюдаем за изменениями в widget-container для отслеживания класса selected
    const widgetContainerForSelected = document.querySelector('.loop-bundle-widget-container');
    if (widgetContainerForSelected) {
      // Наблюдаем за widget-container для отслеживания новых элементов
      selectedObserver.observe(widgetContainerForSelected, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // Также наблюдаем за существующими элементами
      const sellingPlanContainers = widgetContainerForSelected.querySelectorAll('.loop-bundle-widget-selling-plan-container');
      sellingPlanContainers.forEach(function (container) {
        selectedObserver.observe(container, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }

    // Функция для отслеживания изменений цен в выбранном элементе
    let priceUpdateObserver = null;
    function startPriceUpdateObserver() {
      // Отключаем предыдущий observer, если он есть
      if (priceUpdateObserver) {
        priceUpdateObserver.disconnect();
      }

      // Находим элемент с классом selected
      const selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');
      if (!selectedContainer) {
        return;
      }

      // Находим элементы с ценами в выбранном контейнере
      const actualPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const discountPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (!actualPriceEl || !discountPriceEl) {
        return;
      }

      // Создаем observer для отслеживания изменений цен
      let priceObserverTimeout = null;
      priceUpdateObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // Debounce для предотвращения бесконечных циклов
            if (priceObserverTimeout) {
              clearTimeout(priceObserverTimeout);
            }
            priceObserverTimeout = setTimeout(function () {
              updateDuplicatePriceContainer();
              updatePerMealBadge(); // Также обновляем badge при изменении цен
            }, 200);
          }
        });
      });

      // Наблюдаем за изменениями в элементах с ценами
      priceUpdateObserver.observe(actualPriceEl, {
        childList: true,
        subtree: true,
        characterData: true
      });
      priceUpdateObserver.observe(discountPriceEl, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Запускаем observer для цен при инициализации
    startPriceUpdateObserver();

  }

  /**
   * Обновляет per-meal badge (вызывается отдельно для существующих элементов)
   */
  /**
   * Перестановка #9: Создать дубликат loop-bundle-widget-total-price-button-container и loop-bundle-widget-per-meal-badge перед loop-bundle-size-selector-new-wrapper
   */
  function createDuplicatePriceContainerBeforeSizeSelector() {
    const sizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
    if (!sizeSelector || !sizeSelector.parentNode) {
      return;
    }

    // Проверяем, не создан ли уже дубликат
    const existingDuplicate = document.getElementById('loop-bundle-widget-total-price-button-container-duplicate');
    if (existingDuplicate) {
      return; // Дубликат уже создан, не нужно обновлять
    }

    // Находим оригинальные элементы
    const originalTotalPriceContainer = document.querySelector('.loop-bundle-widget-total-price-button-container');
    const originalPerMealBadge = document.getElementById('loop-bundle-widget-per-meal-badge');

    if (!originalTotalPriceContainer) {
      return; // Оригинальный контейнер еще не создан
    }

    // Создаем новый контейнер (не клонируем, чтобы не было проблем с перемещенными элементами)
    const duplicateTotalPriceContainer = document.createElement('div');
    duplicateTotalPriceContainer.className = 'loop-bundle-widget-total-price-button-container';
    duplicateTotalPriceContainer.id = 'loop-bundle-widget-total-price-button-container-duplicate';

    // Создаем h2 с текстом "TOTAL:"
    const duplicateTotalP = document.createElement('h2');
    duplicateTotalP.textContent = 'TOTAL:';
    duplicateTotalPriceContainer.appendChild(duplicateTotalP);

    // Создаем новый price-button-container для дубликата
    const duplicatePriceButtonContainer = document.createElement('div');
    duplicatePriceButtonContainer.className = 'loop-bundle-widget-selling-plan-price-button-container';

    // Создаем элементы для цен в дубликате
    const duplicateDiscountPriceP = document.createElement('p');
    duplicateDiscountPriceP.className = 'loop-text-p5 m-0 loop-bundle-widget-selling-plan-discount-price';
    duplicateDiscountPriceP.textContent = '';

    const duplicateActualPriceP = document.createElement('p');
    duplicateActualPriceP.className = 'loop-text-p5 m-0 loop-bundle-widget-selling-plan-actual-price';
    duplicateActualPriceP.textContent = '';

    // Добавляем элементы в контейнер дубликата
    duplicatePriceButtonContainer.appendChild(duplicateDiscountPriceP);
    duplicatePriceButtonContainer.appendChild(duplicateActualPriceP);

    // Добавляем контейнер в duplicateTotalPriceContainer
    duplicateTotalPriceContainer.appendChild(duplicatePriceButtonContainer);

    // Создаем дубликат per-meal badge
    const duplicatePerMealBadge = document.createElement('div');
    duplicatePerMealBadge.className = 'loop-bundle-widget-per-meal-badge';
    duplicatePerMealBadge.id = 'loop-bundle-widget-per-meal-badge-duplicate';
    duplicatePerMealBadge.style.display = 'none';

    // Вставляем перед sizeSelector
    try {
      sizeSelector.parentNode.insertBefore(duplicateTotalPriceContainer, sizeSelector);
      sizeSelector.parentNode.insertBefore(duplicatePerMealBadge, sizeSelector);

      // Обновляем цены сразу после создания
      setTimeout(function () {
        updateDuplicatePriceContainer();
      }, 100);
    } catch (e) {
      console.warn('[custom.js] Перестановка #9: Ошибка при создании дубликата:', e);
    }
  }


  /**
   * Обновляет per-meal badge и управляет классом show-tick
   */
  function updatePerMealBadge() {
    const addToCartContainer = document.querySelector('.loop-bundle-widget-add-to-cart-container');
    if (!addToCartContainer) {
      return;
    }

    const badge = document.getElementById('loop-bundle-widget-per-meal-badge');
    const addToCartBtn = addToCartContainer.querySelector('.loop-btn-add-to-cart');

    if (!badge || !addToCartBtn) {
      return;
    }

    // Проверяем, есть ли выбранные продукты (проверяем наличие quantity controls)
    const quantityControls = document.querySelectorAll('.loop-bundle-product-quantity-controls');
    const hasSelectedProducts = quantityControls.length > 0;

    // Проверяем, есть ли класс disabled или атрибут disabled у кнопки
    const isDisabled = !hasSelectedProducts || addToCartBtn.classList.contains('disabled') || addToCartBtn.hasAttribute('disabled');

    // Управляем классом show-tick у loop-selected-bundle-items-title
    const selectedBundleItemsTitle = document.querySelector('.loop-selected-bundle-items-title');
    if (selectedBundleItemsTitle) {
      if (isDisabled) {
        selectedBundleItemsTitle.classList.remove('show-tick');
      } else {
        selectedBundleItemsTitle.classList.add('show-tick');
      }
    }

    if (isDisabled) {
      badge.style.display = 'none';
      // Обновляем дубликат badge
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    // Находим цену из элемента с классом selected (как в updateDuplicatePriceContainer)
    const selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');
    if (!selectedContainer) {
      badge.style.display = 'none';
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    const priceElement = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
    if (!priceElement) {
      badge.style.display = 'none';
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    // Извлекаем цену из текста
    const priceText = priceElement.textContent.trim();
    const priceMatch = priceText.match(/[\d.]+/);
    if (!priceMatch) {
      badge.style.display = 'none';
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    const totalPrice = parseFloat(priceMatch[0]);

    // Находим выбранную кнопку размера
    const selectedSizeBtn = document.querySelector('.loop-bundle-size-selector-btn.loop-btn-selected');
    if (!selectedSizeBtn) {
      badge.style.display = 'none';
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    // Извлекаем количество
    let quantity = 1;
    const btnText = selectedSizeBtn.textContent.trim();
    const quantityMatch = btnText.match(/\d+/);
    if (quantityMatch) {
      quantity = parseInt(quantityMatch[0], 10);
    } else if (selectedSizeBtn.hasAttribute('data-quantity')) {
      quantity = parseInt(selectedSizeBtn.getAttribute('data-quantity'), 10);
    }

    if (quantity <= 0) {
      badge.style.display = 'none';
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
      return;
    }

    // Вычисляем цену за meal
    const pricePerMeal = totalPrice / quantity;
    const formattedPrice = pricePerMeal.toFixed(2);

    // Обновляем текст badge
    badge.textContent = `£${formattedPrice} per meal`;
    badge.style.display = 'block';

    // Обновляем дубликат badge, если он существует
    const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
    if (duplicateBadge) {
      duplicateBadge.textContent = badge.textContent;
      duplicateBadge.style.display = badge.style.display;
    }

    // updateDuplicatePriceContainer вызывается отдельно при изменении класса selected
  }

  /**
   * Обновляет цены в обоих price container из элемента с классом selected
   */
  function updateDuplicatePriceContainer() {
    // Находим оригинальный контейнер (без id, чтобы не найти дубликат)
    const allContainers = document.querySelectorAll('.loop-bundle-widget-total-price-button-container');
    let originalTotalPriceContainer = null;
    for (let i = 0; i < allContainers.length; i++) {
      if (allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-duplicate') {
        originalTotalPriceContainer = allContainers[i];
        break;
      }
    }

    const duplicateTotalPriceContainer = document.getElementById('loop-bundle-widget-total-price-button-container-duplicate');

    if (!originalTotalPriceContainer || !duplicateTotalPriceContainer) {
      return;
    }

    try {
      // Находим элемент loop-bundle-widget-selling-plan-container с классом selected
      const selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');

      if (!selectedContainer) {
        // Нет выбранного элемента - скрываем h2 "TOTAL:"
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2) {
          totalH2.style.display = 'none';
        }
        return;
      }

      // Находим цены в выбранном элементе
      const selectedActualPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const selectedDiscountPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (!selectedActualPriceEl || !selectedDiscountPriceEl) {
        return; // Цены не найдены
      }

      const actualPriceText = selectedActualPriceEl.textContent.trim();
      const discountPriceText = selectedDiscountPriceEl.textContent.trim();

      // Находим price-button-container в обоих контейнерах TOTAL
      const originalPriceButtonContainer = originalTotalPriceContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      const duplicatePriceButtonContainer = duplicateTotalPriceContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');

      if (!originalPriceButtonContainer || !duplicatePriceButtonContainer) {
        return;
      }

      // Обновляем цены в обоих контейнерах
      const originalActualPrice = originalPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const originalDiscountPrice = originalPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
      const duplicateActualPrice = duplicatePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const duplicateDiscountPrice = duplicatePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      // Обновляем оригинальный контейнер (всегда, без проверки)
      if (originalActualPrice) {
        originalActualPrice.textContent = actualPriceText;
      }
      if (originalDiscountPrice) {
        originalDiscountPrice.textContent = discountPriceText;
      }

      // Обновляем клонированный контейнер (всегда, без проверки)
      if (duplicateActualPrice) {
        duplicateActualPrice.textContent = actualPriceText;
      }
      if (duplicateDiscountPrice) {
        duplicateDiscountPrice.textContent = discountPriceText;
      }

      // Также обновляем мобильный контейнер и footer контейнер
      updateMobileTotalContainer();
      updateFooterTotalContainer();
    } catch (e) {
      console.warn('[custom.js] Перестановка #9: Ошибка при обновлении цен в дубликате:', e);
    }
  }

  /**
   * Создает клонированный тотал в footer и управляет его видимостью
   */
  function createFooterTotalContainer() {
    const footerContainer = document.querySelector('.loop-bottom-sheet-footer-container');
    if (!footerContainer) {
      return;
    }

    // Проверяем, не создан ли уже контейнер
    const existingFooterContainer = document.getElementById('loop-bundle-widget-total-price-button-container-footer');
    if (existingFooterContainer) {
      // Обновляем видимость и цены
      updateFooterTotalContainer();
      return;
    }

    // Находим оригинальный контейнер (верхний тотал в body)
    const upperTotalContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (!upperTotalContainer) {
      // Если верхний тотал еще не создан, пробуем найти оригинальный
      const allContainers = document.querySelectorAll('.loop-bundle-widget-total-price-button-container');
      let originalContainer = null;
      for (let i = 0; i < allContainers.length; i++) {
        if (allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-duplicate' &&
          allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-mobile' &&
          allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-footer') {
          originalContainer = allContainers[i];
          break;
        }
      }
      if (!originalContainer) {
        return;
      }
      // Клонируем оригинальный контейнер
      const footerTotalContainer = originalContainer.cloneNode(true);
      footerTotalContainer.id = 'loop-bundle-widget-total-price-button-container-footer';

      // Вставляем первым элементом в footer
      if (footerContainer.firstChild) {
        footerContainer.insertBefore(footerTotalContainer, footerContainer.firstChild);
      } else {
        footerContainer.appendChild(footerTotalContainer);
      }

      // Проверяем, есть ли цены при создании, и скрываем h2, если их нет
      const priceButtonContainer = footerTotalContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      if (priceButtonContainer) {
        const actualPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
        const discountPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
        const actualPriceText = actualPrice ? actualPrice.textContent.trim() : '';
        const discountPriceText = discountPrice ? discountPrice.textContent.trim() : '';
        const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
        const totalH2 = footerTotalContainer.querySelector('h2');
        if (totalH2 && !hasPrices) {
          totalH2.style.display = 'none';
        }
      }

      // Обновляем видимость
      updateFooterTotalContainer();
    } else {
      // Клонируем верхний тотал
      const footerTotalContainer = upperTotalContainer.cloneNode(true);
      footerTotalContainer.id = 'loop-bundle-widget-total-price-button-container-footer';

      // Вставляем первым элементом в footer
      if (footerContainer.firstChild) {
        footerContainer.insertBefore(footerTotalContainer, footerContainer.firstChild);
      } else {
        footerContainer.appendChild(footerTotalContainer);
      }

      // Проверяем, есть ли цены при создании, и скрываем h2, если их нет
      const priceButtonContainer = footerTotalContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      if (priceButtonContainer) {
        const actualPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
        const discountPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
        const actualPriceText = actualPrice ? actualPrice.textContent.trim() : '';
        const discountPriceText = discountPrice ? discountPrice.textContent.trim() : '';
        const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
        const totalH2 = footerTotalContainer.querySelector('h2');
        if (totalH2 && !hasPrices) {
          totalH2.style.display = 'none';
        }
      }

      // Обновляем видимость
      updateFooterTotalContainer();
    }
  }

  /**
   * Обновляет видимость и цены в footer тотале
   */
  function updateFooterTotalContainer() {
    const footerTotalContainer = document.getElementById('loop-bundle-widget-total-price-button-container-footer');
    if (!footerTotalContainer) {
      return;
    }

    // Проверяем, имеет ли react-modal-sheet-container класс expanded
    const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
    const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');

    // Показываем/скрываем контейнер
    if (isExpanded) {
      footerTotalContainer.style.display = '';
    } else {
      footerTotalContainer.style.display = 'none';
    }

    // Синхронизируем цены с верхним тоталом
    const upperTotalContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (!upperTotalContainer) {
      return;
    }

    try {
      // Находим price-button-container в обоих контейнерах
      const upperPriceButtonContainer = upperTotalContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      const footerPriceButtonContainer = footerTotalContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');

      if (!upperPriceButtonContainer || !footerPriceButtonContainer) {
        return;
      }

      // Находим цены в верхнем контейнере
      const upperActualPrice = upperPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const upperDiscountPrice = upperPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (!upperActualPrice || !upperDiscountPrice) {
        return;
      }

      const actualPriceText = upperActualPrice.textContent.trim();
      const discountPriceText = upperDiscountPrice.textContent.trim();

      // Обновляем цены в footer контейнере
      const footerActualPrice = footerPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const footerDiscountPrice = footerPriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (footerActualPrice) {
        footerActualPrice.textContent = actualPriceText;
      }
      if (footerDiscountPrice) {
        footerDiscountPrice.textContent = discountPriceText;
      }

      // Проверяем, пустые ли цены, и скрываем/показываем h2 "TOTAL:"
      const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
      const totalH2 = footerTotalContainer.querySelector('h2');
      if (totalH2) {
        if (hasPrices) {
          totalH2.style.display = '';
        } else {
          totalH2.style.display = 'none';
        }
      }
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Перестановка #10: Создать элемент loop-selected-bundle-title-new и копировать текст из выбранной кнопки размера
   */
  function updateBundleTitleFromSelectedSize() {
    const bundleTitle = document.querySelector('.loop-selected-bundle-title');
    const selectedSizeBtn = document.querySelector('.loop-bundle-size-selector-btn.loop-btn-selected');

    if (!bundleTitle || !selectedSizeBtn) {
      return;
    }

    // Проверяем, существует ли уже элемент loop-selected-bundle-title-new
    let titleNew = document.querySelector('.loop-selected-bundle-title-new');

    if (!titleNew) {
      // Создаем новый элемент
      titleNew = document.createElement('h2');
      titleNew.className = 'loop-selected-bundle-title-new';

      // Вставляем рядом с bundleTitle (после него)
      try {
        if (bundleTitle.nextSibling) {
          bundleTitle.parentNode.insertBefore(titleNew, bundleTitle.nextSibling);
        } else {
          bundleTitle.parentNode.appendChild(titleNew);
        }
      } catch (e) {
        console.warn('[custom.js] Перестановка #10: Ошибка при создании элемента:', e);
        return;
      }
    }

    // Копируем текст из выбранной кнопки в новый элемент
    const btnText = selectedSizeBtn.textContent.trim();
    if (btnText && titleNew.textContent.trim() !== btnText) {
      titleNew.textContent = btnText;
    }
  }

  /**
   * Перестановка #15: Обновлять тоталы при добавлении продукта и изменении количества
   */
  function setupTotalsUpdateOnProductActions() {
    // Проверяем, не установлены ли уже обработчики
    if (window.__totalsUpdateHandlersSetup) {
      return;
    }
    window.__totalsUpdateHandlersSetup = true;

    // Функция для проверки наличия выбранных продуктов
    function hasSelectedProducts() {
      // Проверяем наличие элементов с quantity controls (это означает, что продукт выбран)
      const quantityControls = document.querySelectorAll('.loop-bundle-product-quantity-controls');
      return quantityControls.length > 0;
    }

    // Функция для очистки тоталов, когда нет продуктов
    function clearTotals() {
      // Находим оба контейнера с ценами
      const allContainers = document.querySelectorAll('.loop-bundle-widget-total-price-button-container');
      const duplicateTotalPriceContainer = document.getElementById('loop-bundle-widget-total-price-button-container-duplicate');

      // Очищаем цены во всех контейнерах
      allContainers.forEach(function (container) {
        const priceButtonContainer = container.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
        if (priceButtonContainer) {
          const actualPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
          const discountPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
          if (actualPrice) {
            actualPrice.textContent = '';
          }
          if (discountPrice) {
            discountPrice.textContent = '';
          }
        }
      });

      // Также очищаем мобильный контейнер
      const mobileContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
      if (mobileContainer) {
        const mobilePriceButtonContainer = mobileContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
        if (mobilePriceButtonContainer) {
          const mobileActualPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
          const mobileDiscountPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
          if (mobileActualPrice) {
            mobileActualPrice.textContent = '';
          }
          if (mobileDiscountPrice) {
            mobileDiscountPrice.textContent = '';
          }
        }
        // Скрываем h2 "TOTAL:" когда цены пустые
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2) {
          totalH2.style.display = 'none';
        }
      }

      // Также скрываем h2 в footer тотале
      const footerContainer = document.getElementById('loop-bundle-widget-total-price-button-container-footer');
      if (footerContainer) {
        const footerTotalH2 = footerContainer.querySelector('h2');
        if (footerTotalH2) {
          footerTotalH2.style.display = 'none';
        }
      }

      // Скрываем badge
      const badge = document.getElementById('loop-bundle-widget-per-meal-badge');
      const duplicateBadge = document.getElementById('loop-bundle-widget-per-meal-badge-duplicate');
      if (badge) {
        badge.style.display = 'none';
      }
      if (duplicateBadge) {
        duplicateBadge.style.display = 'none';
      }
    }

    // Функция для обновления тоталов с задержкой (чтобы дать Loop время обновить DOM)
    function updateTotalsDelayed() {
      setTimeout(function () {
        // Сначала проверяем, есть ли выбранные продукты
        if (!hasSelectedProducts()) {
          // Если нет выбранных продуктов, очищаем тоталы
          clearTotals();
          return;
        }

        // Проверяем, есть ли выбранный selling plan container
        let selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');

        if (!selectedContainer) {
          // Если нет выбранного контейнера, но есть хотя бы один контейнер, выбираем первый
          const firstContainer = document.querySelector('.loop-bundle-widget-selling-plan-container');
          if (firstContainer) {
            // Выбираем первый контейнер автоматически
            firstContainer.classList.add('selected');
            // Убираем selected у других
            const allContainers = document.querySelectorAll('.loop-bundle-widget-selling-plan-container');
            allContainers.forEach(function (container) {
              if (container !== firstContainer) {
                container.classList.remove('selected');
              }
            });
            selectedContainer = firstContainer;
          }
        }

        // Если есть выбранный контейнер, обновляем тоталы
        if (selectedContainer) {
          // Даем еще немного времени для обновления цен в контейнере
          setTimeout(function () {
            updateDuplicatePriceContainer();
            updatePerMealBadge();
          }, 200);
        }
      }, 300);
    }

    // Обработчик для кнопок добавления продукта
    function handleAddProductClick(e) {
      const target = e.target;
      // Проверяем различные варианты селекторов для кнопок добавления
      const addButton = target.closest('.loop-btn-add-product, .loop-add-product-btn, button[class*="add-product"], button[class*="addProduct"], [class*="loop-btn-add"]');
      if (addButton) {
        updateTotalsDelayed();
      }
    }

    // Обработчик для кнопок изменения количества
    function handleQuantityChange(e) {
      const target = e.target;
      // Проверяем, что клик был на кнопке внутри quantity controls
      const quantityControls = target.closest('.loop-bundle-product-quantity-controls');
      if (quantityControls) {
        const quantityButton = target.closest('button');
        if (quantityButton && (quantityButton.textContent.includes('+') || quantityButton.textContent.includes('-') || quantityButton.textContent.includes('−') || quantityButton.getAttribute('aria-label'))) {
          updateTotalsDelayed();
        }
      }
    }

    // Обработчик для кнопок изменения количества в мобильном модальном окне
    function handleMobileVariantActionsClick(e) {
      const target = e.target;
      // Проверяем, что модальное окно открыто (имеет класс expanded)
      const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
      const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');

      if (!isExpanded) {
        return; // Модальное окно не открыто, не обрабатываем
      }

      // Проверяем, что клик был на кнопке внутри loop-selected-variant-actions
      const variantActions = target.closest('.loop-selected-variant-actions');
      if (variantActions) {
        const actionButton = target.closest('button');
        if (actionButton) {
          // Обновляем тоталы с небольшой задержкой, чтобы дать Loop время обновить количество
          updateTotalsDelayed();
        }
      }
    }

    // Добавляем обработчики событий
    document.addEventListener('click', handleAddProductClick, true);
    document.addEventListener('click', handleQuantityChange, true);
    document.addEventListener('click', handleMobileVariantActionsClick, true);

    // Также отслеживаем изменения через MutationObserver для кнопок количества
    // Проверяем, не создан ли уже observer
    if (!window.__quantityObserver) {
      const quantityObserver = new MutationObserver(function (mutations) {
        let shouldUpdate = false;
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            // Проверяем, изменилось ли количество продуктов
            const quantityControls = document.querySelectorAll('.loop-bundle-product-quantity-controls');
            if (quantityControls.length > 0) {
              shouldUpdate = true;
            }
          }
        });
        if (shouldUpdate) {
          updateTotalsDelayed();
        }
      });

      // Наблюдаем за изменениями в bundle products wrapper
      const bundleProductsWrapper = document.querySelector('.loop-bundle-products-wrapper');
      if (bundleProductsWrapper) {
        quantityObserver.observe(bundleProductsWrapper, {
          childList: true,
          subtree: true,
          attributes: true
        });
        window.__quantityObserver = quantityObserver;
        window.__quantityObserverTarget = bundleProductsWrapper;
      }

      // Также наблюдаем за изменениями в мобильном модальном окне
      const productsContainer = document.querySelector('.loop-bottom-sheet-body-products-container-expanded');
      if (productsContainer && window.__quantityObserver) {
        window.__quantityObserver.observe(productsContainer, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }
    } else {
      // Если observer уже существует, обновляем его target, если нужно
      const bundleProductsWrapper = document.querySelector('.loop-bundle-products-wrapper');
      if (bundleProductsWrapper && window.__quantityObserverTarget !== bundleProductsWrapper) {
        // Отключаем старый observer
        if (window.__quantityObserverTarget) {
          window.__quantityObserver.disconnect();
        }
        // Подключаем к новому target
        window.__quantityObserver.observe(bundleProductsWrapper, {
          childList: true,
          subtree: true,
          attributes: true
        });
        window.__quantityObserverTarget = bundleProductsWrapper;
      }
    }

  }

  /**
   * Перестановка #14: Создать декоративный бейдж "More info"
   */
  function createMoreInfoBadge() {
    const cardHeaders = document.querySelectorAll('.loop-card-header');

    cardHeaders.forEach(function (header) {
      // Проверяем, не обработан ли уже этот header
      if (header.hasAttribute('data-more-info-badge-added')) {
        return;
      }

      // Создаем декоративный бейдж "More info"
      const badge = document.createElement('div');
      badge.className = 'loop-more-info-badge';
      badge.textContent = 'More info';
      badge.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        font-weight: 600;
        font-size: 12px;
        line-height: 1;
        letter-spacing: -0.02em;
        padding: 3px 9px;
        color: black;
        background-color: #F9FAE7;
        border-radius: 100px;
        margin: 3px 0 0 3px;
        z-index: 10;
        pointer-events: none;
      `;

      // Устанавливаем position: relative для header, если его нет
      if (getComputedStyle(header).position === 'static') {
        header.style.position = 'relative';
      }

      // Вставляем бейдж в начало header
      try {
        if (header.firstChild) {
          header.insertBefore(badge, header.firstChild);
        } else {
          header.appendChild(badge);
        }
        header.setAttribute('data-more-info-badge-added', 'true');
      } catch (e) {
      }
    });
  }

  /**
   * Перестановка #17: Создать элемент loop-product-metafields с информацией из метафилдов продукта
   */
  function createProductMetafieldsElement() {
    const footerWrappers = document.querySelectorAll('.loop-body-footer-wrapper');

    footerWrappers.forEach(function (footerWrapper) {
      // Проверяем, не создан ли уже этот элемент
      if (footerWrapper.hasAttribute('data-metafields-added')) {
        return;
      }

      // Находим родительский элемент с информацией о продукте
      // Ищем вверх по DOM дереву
      let productCard = footerWrapper.closest('.loop-product-card, .loop-bundle-product-wrapper, [data-product-handle]');

      // Если не нашли, пробуем найти через loop-card-header или другие элементы
      if (!productCard) {
        const cardHeader = footerWrapper.closest('.loop-bundle-product-wrapper')?.querySelector('.loop-card-header');
        if (cardHeader) {
          productCard = cardHeader.closest('.loop-bundle-product-wrapper');
        }
      }

      if (!productCard) {
        return;
      }

      // Пробуем получить handle продукта из различных источников
      let productHandle = productCard.getAttribute('data-product-handle') ||
        productCard.getAttribute('data-handle') ||
        productCard.querySelector('[data-product-handle]')?.getAttribute('data-product-handle');

      // Если не нашли handle, пробуем из ссылки на продукт
      if (!productHandle) {
        const productLink = productCard.querySelector('a[href*="/products/"]');
        if (productLink) {
          const href = productLink.getAttribute('href');
          const match = href.match(/\/products\/([^\/\?]+)/);
          if (match) {
            productHandle = match[1];
          }
        }
      }

      if (!productHandle) {
        return;
      }

      // Функция для получения метафилдов продукта
      async function fetchProductMetafields(handle) {
        try {
          // Пробуем получить через HTML страницу продукта (более надежный способ)
          const htmlResponse = await fetch(`/products/${handle}`);
          if (htmlResponse.ok) {
            const html = await htmlResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Ищем fp-macros-wrap на странице продукта
            const macrosWrap = doc.querySelector('.fp-macros-wrap');
            if (macrosWrap) {
              const macroItems = macrosWrap.querySelectorAll('.fp-macros__item');
              let calories = '';
              let protein = '';
              let fats = '';

              // Первый элемент - calories (без "g")
              if (macroItems[0]) {
                const caloriesEl = macroItems[0].querySelector('h3');
                if (caloriesEl) {
                  calories = caloriesEl.textContent.trim();
                }
              }
              // Второй элемент - protein (с "g")
              if (macroItems[1]) {
                const proteinEl = macroItems[1].querySelector('h3');
                if (proteinEl) {
                  protein = proteinEl.textContent.trim().replace('g', '').trim();
                }
              }
              // Четвертый элемент - fats (с "g")
              if (macroItems[3]) {
                const fatsEl = macroItems[3].querySelector('h3');
                if (fatsEl) {
                  fats = fatsEl.textContent.trim().replace('g', '').trim();
                }
              }

              if (calories || protein || fats) {
                return { calories, protein, fats };
              }
            }
          }

          // Если не нашли через HTML, пробуем JSON API
          const jsonResponse = await fetch(`/products/${handle}.js`);
          if (jsonResponse.ok) {
            const product = await jsonResponse.json();

            let calories = '';
            let protein = '';
            let fats = '';

            if (product.metafields && Array.isArray(product.metafields)) {
              product.metafields.forEach(function (metafield) {
                if (metafield.namespace === 'custom' && metafield.key === 'calories') {
                  calories = metafield.value || '';
                }
                if (metafield.namespace === 'custom' && metafield.key === 'protein') {
                  protein = metafield.value || '';
                }
                if (metafield.namespace === 'custom' && metafield.key === 'fats') {
                  fats = metafield.value || '';
                }
              });

              if (calories || protein || fats) {
                return { calories, protein, fats };
              }
            }
          }

          return null;
        } catch (e) {
          return null;
        }
      }

      // Сначала проверяем, есть ли уже data-атрибуты с метафилдами на productCard
      let calories = productCard.getAttribute('data-calories') ||
        productCard.querySelector('[data-calories]')?.getAttribute('data-calories');
      let protein = productCard.getAttribute('data-protein') ||
        productCard.querySelector('[data-protein]')?.getAttribute('data-protein');
      let fats = productCard.getAttribute('data-fats') ||
        productCard.querySelector('[data-fats]')?.getAttribute('data-fats');

      // Создаем элемент метафилдов
      const metafieldsElement = document.createElement('div');
      metafieldsElement.className = 'loop-product-metafields';
      metafieldsElement.style.color = '#560059';

      // Функция для обновления текста элемента метафилдов
      function updateMetafieldsElement(cal, prot, fat) {
        const parts = [];
        if (cal) {
          parts.push(`Kcal: ${cal}`);
        }
        if (prot) {
          parts.push(`Protein: ${prot}g`);
        }
        if (fat) {
          parts.push(`Fat: ${fat}g`);
        }

        if (parts.length > 0) {
          metafieldsElement.textContent = parts.join(' | ');
        } else {
          metafieldsElement.style.display = 'none';
        }
      }

      // Если нашли в data-атрибутах, используем их сразу
      if (calories || protein || fats) {
        updateMetafieldsElement(calories, protein, fats);
      } else {
        // Если не нашли в data-атрибутах, получаем через API
        fetchProductMetafields(productHandle).then(function (metafields) {
          if (!metafields) {
            metafieldsElement.style.display = 'none';
            return;
          }

          updateMetafieldsElement(metafields.calories, metafields.protein, metafields.fats);

          // Сохраняем метафилды в data-атрибуты для будущего использования
          if (productCard) {
            if (metafields.calories) {
              productCard.setAttribute('data-calories', metafields.calories);
            }
            if (metafields.protein) {
              productCard.setAttribute('data-protein', metafields.protein);
            }
            if (metafields.fats) {
              productCard.setAttribute('data-fats', metafields.fats);
            }
          }
        }).catch(function (error) {
          metafieldsElement.style.display = 'none';
        });
      }

      // Добавляем элемент сразу (он будет обновлен асинхронно, если нужно)
      if (!footerWrapper.querySelector('.loop-product-metafields')) {
        if (footerWrapper.firstChild) {
          footerWrapper.insertBefore(metafieldsElement, footerWrapper.firstChild);
        } else {
          footerWrapper.appendChild(metafieldsElement);
        }
        footerWrapper.setAttribute('data-metafields-added', 'true');
      }
    });
  }

  /**
   * Перестановка #16: Перенести все loop-display-product-price в начало соответствующих элементов loop-body-footer-wrapper
   */
  function movePriceToFooterWrapperStart() {
    const footerWrappers = document.querySelectorAll('.loop-body-footer-wrapper');

    footerWrappers.forEach(function (footerWrapper) {
      // Проверяем, не обработан ли уже этот wrapper
      if (footerWrapper.hasAttribute('data-price-moved')) {
        return;
      }

      // Находим элемент loop-display-product-price внутри этого wrapper или его родителя
      const priceElement = footerWrapper.querySelector('.loop-display-product-price') ||
        footerWrapper.parentElement?.querySelector('.loop-display-product-price');

      if (!priceElement) {
        return;
      }

      // Проверяем, не находится ли уже элемент в начале wrapper
      if (priceElement.parentNode === footerWrapper &&
        footerWrapper.firstChild === priceElement) {
        footerWrapper.setAttribute('data-price-moved', 'true');
        return;
      }

      try {
        // Перемещаем priceElement в начало footerWrapper
        if (footerWrapper.firstChild) {
          footerWrapper.insertBefore(priceElement, footerWrapper.firstChild);
        } else {
          footerWrapper.appendChild(priceElement);
        }
        footerWrapper.setAttribute('data-price-moved', 'true');
      } catch (e) {
      }
    });
  }

  /**
   * Перестановка #18: Создать мобильный контейнер тотала в loop-bottom-sheet-body-container
   */
  function createMobileTotalContainer() {
    const bottomSheetContainer = document.querySelector('.loop-bottom-sheet-body-container');
    if (!bottomSheetContainer) {
      return;
    }

    // Проверяем, не создан ли уже мобильный контейнер
    const existingMobileContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (existingMobileContainer) {
      // Обновляем цены в существующем контейнере
      updateMobileTotalContainer();
      return;
    }

    // Находим оригинальный контейнер для клонирования
    const allContainers = document.querySelectorAll('.loop-bundle-widget-total-price-button-container');
    let originalContainer = null;
    for (let i = 0; i < allContainers.length; i++) {
      if (allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-duplicate' &&
        allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-mobile') {
        originalContainer = allContainers[i];
        break;
      }
    }

    if (!originalContainer) {
      return;
    }

    try {
      // Клонируем контейнер
      const mobileContainer = originalContainer.cloneNode(true);
      mobileContainer.id = 'loop-bundle-widget-total-price-button-container-mobile';

      // Применяем стили для мобильной версии
      mobileContainer.style.marginLeft = 'auto';

      // Добавляем в конец loop-bottom-sheet-body-container
      bottomSheetContainer.appendChild(mobileContainer);

      // Проверяем, есть ли цены при создании, и скрываем h2, если их нет
      const priceButtonContainer = mobileContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      if (priceButtonContainer) {
        const actualPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
        const discountPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
        const actualPriceText = actualPrice ? actualPrice.textContent.trim() : '';
        const discountPriceText = discountPrice ? discountPrice.textContent.trim() : '';
        const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2 && !hasPrices) {
          totalH2.style.display = 'none';
        }
      }

      // Обновляем цены в мобильном контейнере
      updateMobileTotalContainer();
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Обновляет цены в мобильном контейнере тотала
   */
  function updateMobileTotalContainer() {
    const mobileContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (!mobileContainer) {
      return;
    }

    try {
      // Находим элемент loop-bundle-widget-selling-plan-container с классом selected
      const selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');

      if (!selectedContainer) {
        // Нет выбранного элемента - скрываем h2 "TOTAL:"
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2) {
          totalH2.style.display = 'none';
        }
        return;
      }

      // Находим цены в выбранном элементе
      const selectedActualPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const selectedDiscountPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (!selectedActualPriceEl || !selectedDiscountPriceEl) {
        return; // Цены не найдены
      }

      const actualPriceText = selectedActualPriceEl.textContent.trim();
      const discountPriceText = selectedDiscountPriceEl.textContent.trim();

      // Находим price-button-container в мобильном контейнере
      const mobilePriceButtonContainer = mobileContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');

      if (!mobilePriceButtonContainer) {
        return;
      }

      // Обновляем цены в мобильном контейнере
      const mobileActualPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const mobileDiscountPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (mobileActualPrice) {
        mobileActualPrice.textContent = actualPriceText;
      }
      if (mobileDiscountPrice) {
        mobileDiscountPrice.textContent = discountPriceText;
      }

      // Проверяем, пустые ли цены, и скрываем/показываем h2 "TOTAL:"
      const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
      const totalH2 = mobileContainer.querySelector('h2');
      if (totalH2) {
        if (hasPrices) {
          totalH2.style.display = '';
        } else {
          totalH2.style.display = 'none';
        }
      }

      // Также обновляем footer контейнер
      updateFooterTotalContainer();
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Перестановка #18: Создать мобильный контейнер тотала в loop-bottom-sheet-body-container
   */
  function createMobileTotalContainer() {
    const bottomSheetContainer = document.querySelector('.loop-bottom-sheet-body-container');
    if (!bottomSheetContainer) {
      return;
    }

    // Проверяем, не создан ли уже мобильный контейнер
    const existingMobileContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (existingMobileContainer) {
      // Обновляем цены в существующем контейнере
      updateMobileTotalContainer();
      return;
    }

    // Находим оригинальный контейнер для клонирования
    const allContainers = document.querySelectorAll('.loop-bundle-widget-total-price-button-container');
    let originalContainer = null;
    for (let i = 0; i < allContainers.length; i++) {
      if (allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-duplicate' &&
        allContainers[i].id !== 'loop-bundle-widget-total-price-button-container-mobile') {
        originalContainer = allContainers[i];
        break;
      }
    }

    if (!originalContainer) {
      return;
    }

    try {
      // Клонируем контейнер
      const mobileContainer = originalContainer.cloneNode(true);
      mobileContainer.id = 'loop-bundle-widget-total-price-button-container-mobile';

      // Применяем стили для мобильной версии
      mobileContainer.style.marginLeft = 'auto';

      // Добавляем в конец loop-bottom-sheet-body-container
      bottomSheetContainer.appendChild(mobileContainer);

      // Проверяем, есть ли цены при создании, и скрываем h2, если их нет
      const priceButtonContainer = mobileContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');
      if (priceButtonContainer) {
        const actualPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
        const discountPrice = priceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');
        const actualPriceText = actualPrice ? actualPrice.textContent.trim() : '';
        const discountPriceText = discountPrice ? discountPrice.textContent.trim() : '';
        const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2 && !hasPrices) {
          totalH2.style.display = 'none';
        }
      }

      // Обновляем цены в мобильном контейнере
      updateMobileTotalContainer();
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Обновляет цены в мобильном контейнере тотала
   */
  function updateMobileTotalContainer() {
    const mobileContainer = document.getElementById('loop-bundle-widget-total-price-button-container-mobile');
    if (!mobileContainer) {
      return;
    }

    try {
      // Находим элемент loop-bundle-widget-selling-plan-container с классом selected
      const selectedContainer = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');

      if (!selectedContainer) {
        // Нет выбранного элемента - скрываем h2 "TOTAL:"
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2) {
          totalH2.style.display = 'none';
        }
        return;
      }

      // Находим цены в выбранном элементе
      const selectedActualPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const selectedDiscountPriceEl = selectedContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (!selectedActualPriceEl || !selectedDiscountPriceEl) {
        // Цены не найдены - скрываем h2 "TOTAL:"
        const totalH2 = mobileContainer.querySelector('h2');
        if (totalH2) {
          totalH2.style.display = 'none';
        }
        return;
      }

      const actualPriceText = selectedActualPriceEl.textContent.trim();
      const discountPriceText = selectedDiscountPriceEl.textContent.trim();

      // Находим price-button-container в мобильном контейнере
      const mobilePriceButtonContainer = mobileContainer.querySelector('.loop-bundle-widget-selling-plan-price-button-container');

      if (!mobilePriceButtonContainer) {
        return;
      }

      // Обновляем цены в мобильном контейнере
      const mobileActualPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-actual-price');
      const mobileDiscountPrice = mobilePriceButtonContainer.querySelector('.loop-bundle-widget-selling-plan-discount-price');

      if (mobileActualPrice) {
        mobileActualPrice.textContent = actualPriceText;
      }
      if (mobileDiscountPrice) {
        mobileDiscountPrice.textContent = discountPriceText;
      }

      // Проверяем, пустые ли цены, и скрываем/показываем h2 "TOTAL:"
      const hasPrices = (actualPriceText && actualPriceText.length > 0) || (discountPriceText && discountPriceText.length > 0);
      const totalH2 = mobileContainer.querySelector('h2');
      if (totalH2) {
        if (hasPrices) {
          totalH2.style.display = '';
        } else {
          totalH2.style.display = 'none';
        }
      }

      // Также обновляем footer контейнер
      updateFooterTotalContainer();
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Перестановка #17: Копировать loop-selected-bundle-title-new первым элементом в loop-bottom-sheet-body-container
   */
  function moveBundleTitleToBottomSheetStart() {
    const titleElement = document.querySelector('.loop-selected-bundle-title-new');
    const container = document.querySelector('.loop-bottom-sheet-body-container');

    if (!titleElement || !container) {
      return;
    }

    // Проверяем, не добавлена ли уже копия в контейнер
    if (container.hasAttribute('data-title-copied')) {
      // Проверяем, существует ли еще копия
      const existingCopy = container.querySelector('.loop-selected-bundle-title-new-copy');
      if (existingCopy) {
        // Обновляем текст копии, если оригинал изменился
        const originalText = titleElement.textContent.trim();
        if (existingCopy.textContent.trim() !== originalText) {
          existingCopy.textContent = originalText;
        }
        return;
      } else {
        // Копия была удалена, сбрасываем флаг
        container.removeAttribute('data-title-copied');
      }
    }

    try {
      // Копируем элемент
      const titleCopy = titleElement.cloneNode(true);
      titleCopy.classList.add('loop-selected-bundle-title-new-copy');

      // Применяем стили к копии
      titleCopy.style.fontFamily = 'roc-grotesk-condensed';
      titleCopy.style.fontSize = '24px';
      titleCopy.style.fontWeight = '700';
      titleCopy.style.lineHeight = '1';
      titleCopy.style.color = '#000';

      // Вставляем копию в начало container
      if (container.firstChild) {
        container.insertBefore(titleCopy, container.firstChild);
      } else {
        container.appendChild(titleCopy);
      }
      container.setAttribute('data-title-copied', 'true');

      // Настраиваем observer для обновления копии при изменении оригинала
      if (!titleElement._titleCopyObserver) {
        const observer = new MutationObserver(function () {
          const copy = container.querySelector('.loop-selected-bundle-title-new-copy');
          if (copy) {
            copy.textContent = titleElement.textContent.trim();
          }
        });
        observer.observe(titleElement, {
          childList: true,
          subtree: true,
          characterData: true
        });
        titleElement._titleCopyObserver = observer;
      }
    } catch (e) {
      // Игнорируем ошибки
    }
  }

  /**
   * Создает кнопку "Select Bundle" с дропдауном после loop-bottom-sheet-body-container
   * когда модальное окно закрыто (нет класса expanded)
   */
  function createClosedModalBundleDropdown() {
    // Проверяем, не выполняется ли уже создание (защита от множественных вызовов)
    if (window.__creatingClosedModalDropdowns) {
      return;
    }

    const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
    if (!modalSheetContainer) {
      return;
    }

    const isExpanded = modalSheetContainer.classList.contains('expanded');

    // Если модальное окно открыто, удаляем созданный контейнер
    if (isExpanded) {
      const existingContainer = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
      if (existingContainer && existingContainer.parentNode) {
        try {
          existingContainer.parentNode.removeChild(existingContainer);
        } catch (e) {
          // Игнорируем ошибки
        }
      }
      return;
    }

    // Проверяем, не создан ли уже контейнер
    const existingContainer = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
    if (existingContainer && existingContainer.parentNode) {
      // Проверяем, не выполняется ли уже обновление (защита от рекурсии)
      if (existingContainer.dataset.updating === 'true') {
        return;
      }

      // Контейнер уже существует, обновляем содержимое и обработчики
      const bundleContainer = existingContainer.querySelector('.loop-closed-modal-bundle-container');
      const frequencyContainer = existingContainer.querySelector('.loop-closed-modal-frequency-container');
      const existingBundleDropdown = bundleContainer ? bundleContainer.querySelector('.loop-closed-modal-bundle-dropdown') : null;
      const existingFrequencyDropdown = frequencyContainer ? frequencyContainer.querySelector('.loop-closed-modal-frequency-dropdown') : null;
      const originalSizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
      const originalWidgetContainer = document.querySelector('.loop-bundle-widget-container');

      // Обновляем Bundle dropdown
      if (existingBundleDropdown && originalSizeSelector) {
        // Функция для обновления содержимого дропдауна
        // Вызывается только при первой загрузке (когда skeleton исчезает)
        function updateExistingBundleDropdownContent() {
          if (!originalSizeSelector || !existingBundleDropdown) {
            return;
          }

          // Проверяем, не добавлены ли уже обработчики (чтобы не обновлять повторно)
          if (existingBundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn[data-click-handler-added="true"]').length > 0) {
            return;
          }

          // Устанавливаем флаг обновления
          existingContainer.dataset.updating = 'true';

          existingBundleDropdown.innerHTML = originalSizeSelector.innerHTML;

          // Обновляем обработчики - клонируем кнопки для полного сброса listeners
          const bundleSizeButtons = existingBundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
          bundleSizeButtons.forEach(function (clonedButton) {
            // Клонируем кнопку для удаления всех старых listeners
            const newButton = clonedButton.cloneNode(true);
            const oldStyles = clonedButton.style.cssText;
            clonedButton.parentNode.replaceChild(newButton, clonedButton);
            newButton.style.cssText = oldStyles;

            newButton.removeAttribute('data-click-handler-added');
            newButton.dataset.clickHandlerAdded = 'true';

            const buttonText = newButton.textContent.trim();

            // Добавляем стили для улучшения кликабельности на iOS
            newButton.style.cssText = (newButton.style.cssText || '') +
              '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';

            // Функция для обработки клика/тапа
            function handleButtonClick(e) {
              // Не используем preventDefault, чтобы не блокировать нативные тапы на iOS
              e.stopPropagation();

              // Добавляем класс loop-btn-selected к кликнутой кнопке в dropdown
              const allButtons = existingBundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
              allButtons.forEach(function (btn) {
                if (btn.textContent.trim() === buttonText) {
                  btn.classList.add('loop-btn-selected');
                } else {
                  btn.classList.remove('loop-btn-selected');
                }
              });

              const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
              originalButtons.forEach(function (originalButton) {
                if (originalButton.textContent.trim() === buttonText) {
                  originalButton.click();
                  // Классы уже синхронизированы вручную выше, observer будет следить за дальнейшими изменениями

                  // Обновляем текст кнопки после выбора
                  updateBundleButtonText(buttonText);
                }
              });
            }

            // Флаг для предотвращения двойного вызова на iOS
            let isHandlingTouch = false;
            let lastTouchTime = 0;

            // Обработчик touchend для iOS
            const touchendHandler = function (e) {
              const now = Date.now();
              // Предотвращаем двойной вызов
              if (isHandlingTouch || (now - lastTouchTime) < 300) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }

              isHandlingTouch = true;
              lastTouchTime = now;

              // Не используем preventDefault здесь, чтобы не блокировать нативные события
              e.stopPropagation();
              handleButtonClick(e);

              // Сбрасываем флаг через небольшую задержку
              setTimeout(function () {
                isHandlingTouch = false;
              }, 300);
            };

            // Обработчик click (для десктопа и как fallback)
            const clickHandlerWrapper = function (e) {
              // Если touchend уже обработал событие, игнорируем click
              if (isHandlingTouch) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              handleButtonClick(e);
            };

            // Добавляем обработчики для click и touchend (для iOS)
            newButton.addEventListener('click', clickHandlerWrapper);
            newButton.addEventListener('touchend', touchendHandler, { passive: true });

            // Сохраняем ссылки на handlers для возможного удаления
            newButton._clickHandler = clickHandlerWrapper;
            newButton._touchendHandler = touchendHandler;
          });

          syncBundleSizeButtonClasses(originalSizeSelector, existingBundleDropdown);
          observeBundleSizeButtonClasses(originalSizeSelector, existingBundleDropdown);

          // Снимаем флаг обновления
          existingContainer.removeAttribute('data-updating');
        }

        // Проверяем, загружен ли контент в оригинале
        const hasSkeleton = originalSizeSelector.querySelector('.loop-skeleton');
        const dropdownHasSkeleton = existingBundleDropdown.querySelector('.loop-skeleton');

        // Если в оригинале нет skeleton, но в дропдауне есть, обновляем содержимое
        if (!hasSkeleton && dropdownHasSkeleton) {
          updateExistingBundleDropdownContent();
        } else if (hasSkeleton) {
          // Контент еще не загружен, наблюдаем за изменениями
          // Проверяем, не добавлен ли уже observer для этого контейнера
          if (!bundleContainer.dataset.contentObserverAdded) {
            bundleContainer.dataset.contentObserverAdded = 'true';

            const contentObserver = new MutationObserver(function (mutations) {
              const stillHasSkeleton = originalSizeSelector.querySelector('.loop-skeleton');
              if (!stillHasSkeleton) {
                // Контент загрузился, обновляем дропдаун
                updateExistingBundleDropdownContent();
                contentObserver.disconnect();
                bundleContainer.removeAttribute('data-content-observer-added');
              }
            });

            contentObserver.observe(originalSizeSelector, {
              childList: true,
              subtree: true,
              attributes: true
            });

            // Также периодически проверяем, загрузился ли контент (на случай, если observer пропустит)
            const checkInterval = setInterval(function () {
              const stillHasSkeleton = originalSizeSelector.querySelector('.loop-skeleton');
              if (!stillHasSkeleton) {
                updateExistingBundleDropdownContent();
                clearInterval(checkInterval);
                contentObserver.disconnect();
                bundleContainer.removeAttribute('data-content-observer-added');
              }
            }, 500);

            // Останавливаем проверку через 10 секунд, чтобы не проверять бесконечно
            setTimeout(function () {
              clearInterval(checkInterval);
            }, 10000);
          }
        } else if (!hasSkeleton && !dropdownHasSkeleton) {
          // Контент уже загружен в обоих местах
          // В закрытом модале оригинал не меняется, поэтому не проверяем содержимое
          // Обновляем только если обработчики не добавлены (первое создание)
          const hasHandlers = existingBundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn[data-click-handler-added="true"]').length > 0;
          if (!hasHandlers) {
            updateExistingBundleDropdownContent();
          } else {
            // Обработчики уже есть, просто синхронизируем классы (на случай если они изменились после клика)
            syncBundleSizeButtonClasses(originalSizeSelector, existingBundleDropdown);
            observeBundleSizeButtonClasses(originalSizeSelector, existingBundleDropdown);
            // Снимаем флаг обновления
            existingContainer.removeAttribute('data-updating');
          }
        }
      } else {
        // Если bundle dropdown не обновлялся, снимаем флаг (если он был установлен)
        existingContainer.removeAttribute('data-updating');
      }

      // Обновляем Frequency dropdown
      if (existingFrequencyDropdown && originalWidgetContainer) {
        // Функция для обновления содержимого frequency dropdown
        // Вызывается только при первой загрузке (когда skeleton исчезает)
        function updateExistingFrequencyDropdownContent() {
          if (!originalWidgetContainer || !existingFrequencyDropdown) {
            return;
          }

          // Проверяем, не добавлен ли уже обработчик (чтобы не обновлять повторно)
          if (existingFrequencyDropdown.dataset.handlerAdded === 'true') {
            return;
          }

          // Устанавливаем флаг обновления
          existingContainer.dataset.updating = 'true';

          // Временно отключаем observer, чтобы избежать рекурсии
          if (window.__expandedObserver) {
            window.__expandedObserver.disconnect();
          }

          // Обновляем содержимое frequency dropdown
          existingFrequencyDropdown.innerHTML = originalWidgetContainer.innerHTML;

          // Удаляем старые обработчики, если они есть (клонируем элемент для сброса)
          const newFrequencyDropdown = existingFrequencyDropdown.cloneNode(true);
          const oldStyles = existingFrequencyDropdown.style.cssText;
          existingFrequencyDropdown.parentNode.replaceChild(newFrequencyDropdown, existingFrequencyDropdown);
          newFrequencyDropdown.style.cssText = oldStyles;

          // Добавляем текст после клонирования
          addFrequencyDropdownText(newFrequencyDropdown);

          // Проверяем и устанавливаем max-height для loop-bundle-widget-frequency-selling-plans-button-container
          const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
          if (sellingPlansButtonContainer) {
            const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
            const hasSelectedIntervalButton = Array.from(allIntervalButtons).some(function (btn) {
              return btn.classList.contains('selected');
            });
            if (!hasSelectedIntervalButton) {
              sellingPlansButtonContainer.style.maxHeight = '0px';
            }
          }

          // Добавляем стили для улучшения кликабельности интерактивных элементов на iOS
          const interactiveElements = newFrequencyDropdown.querySelectorAll(
            '.loop-bundle-widget-selling-plan-container, .loop-bundle-widget-frequency-interval-button, button, [role="button"]'
          );
          interactiveElements.forEach(function (element) {
            element.style.cssText = (element.style.cssText || '') +
              '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';
          });

          // Функция для обработки клика/тапа на интерактивных элементах
          function handleFrequencyClick(e) {
            const target = e.target;

            // Игнорируем клики на сам dropdown и его прямые дочерние элементы-обертки
            if (target === newFrequencyDropdown || target.classList.contains('loop-mobile-frequency-dropdown-text')) {
              return;
            }

            // Находим ближайший интерактивный элемент
            let interactiveElement = target.closest('.loop-bundle-widget-selling-plan-container');
            if (!interactiveElement) {
              interactiveElement = target.closest('.loop-bundle-widget-frequency-interval-button');
            }
            if (!interactiveElement) {
              interactiveElement = target.closest('button');
            }
            if (!interactiveElement) {
              interactiveElement = target.closest('[role="button"]');
            }

            // Проверяем, что элемент находится внутри closed modal frequency dropdown
            const isInClosedModalDropdown = interactiveElement && (
              interactiveElement.closest('.loop-closed-modal-frequency-dropdown') ||
              newFrequencyDropdown && newFrequencyDropdown.contains(interactiveElement)
            );

            if (!interactiveElement || !isInClosedModalDropdown) {
              return;
            }

            // Останавливаем всплытие (но не preventDefault, чтобы не блокировать на мобильных)
            e.stopPropagation();

            // Добавляем класс selected к кликнутому элементу в dropdown
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              // Убираем selected у всех selling plan containers
              const allSellingPlans = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              allSellingPlans.forEach(function (plan) {
                plan.classList.remove('selected');
                plan.style.backgroundColor = 'transparent';
              });
              // Убираем selected у всех interval buttons
              const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              allIntervalButtons.forEach(function (btn) {
                btn.classList.remove('selected');
              });
              // Добавляем selected к кликнутому
              interactiveElement.classList.add('selected');
              interactiveElement.style.backgroundColor = '#A9FA63';

              // Проверяем, является ли кликнутый элемент вторым по счету
              const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
              const isSecondPlan = clickedIndex === 1;
              const isFirstPlan = clickedIndex === 0;

              // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
              const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
              if (sellingPlansButtonContainer) {
                if (isSecondPlan) {
                  sellingPlansButtonContainer.style.maxHeight = '1000px';
                  // Добавляем selected к первому interval button внутри sellingPlansButtonContainer
                  const firstIntervalButton = sellingPlansButtonContainer.querySelector('.loop-bundle-widget-frequency-interval-button');
                  if (firstIntervalButton) {
                    // Убираем selected у всех interval buttons
                    const allIntervalButtonsInContainer = sellingPlansButtonContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
                    allIntervalButtonsInContainer.forEach(function (btn) {
                      btn.classList.remove('selected');
                    });
                    // Добавляем selected к первому
                    firstIntervalButton.classList.add('selected');
                  }
                } else {
                  sellingPlansButtonContainer.style.maxHeight = '0px';
                }
              }

              // Если выбран первый элемент, сохраняем HTML loop-bundle-widget-frequency-selling-plans-button-container
              if (isFirstPlan) {

                const buttonLayout = newFrequencyDropdown.querySelector('.loop-widet-button-layout');

                if (buttonLayout) {
                  const existingSellingPlansContainer = buttonLayout.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');

                  if (existingSellingPlansContainer) {
                    // Клонируем элемент
                    const clonedContainer = existingSellingPlansContainer.cloneNode(true);
                    // Убираем selected у всех кнопок в клоне
                    const allIntervalButtonsInClone = clonedContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');

                    allIntervalButtonsInClone.forEach(function (btn) {
                      btn.classList.remove('selected');
                    });
                    // Сохраняем HTML в переменную
                    window.__firstPlanSelectedFrequencyContainerHTML = clonedContainer.outerHTML;

                  } else {

                  }
                } else {

                }
              } else {

              }
            } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              // Убираем selected у всех interval buttons
              const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              allIntervalButtons.forEach(function (btn) {
                btn.classList.remove('selected');
              });
              // Добавляем selected к кликнутому
              interactiveElement.classList.add('selected');
              // Убираем selected у первого по счету элемента loop-bundle-widget-selling-plan-container
              const allSellingPlans = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              if (allSellingPlans.length > 0) {
                const firstSellingPlan = allSellingPlans[0];
                firstSellingPlan.classList.remove('selected');
                firstSellingPlan.style.backgroundColor = 'transparent';
                // Также добавляем selected к последнему по счету элементу loop-bundle-widget-selling-plan-container
                const lastSellingPlan = allSellingPlans[allSellingPlans.length - 1];
                lastSellingPlan.classList.add('selected');
                lastSellingPlan.style.backgroundColor = '#A9FA63';

                // Проверяем, является ли последний элемент вторым по счету (индекс 1)
                const lastIndex = Array.from(allSellingPlans).indexOf(lastSellingPlan);
                const isSecondPlan = lastIndex === 1;

                // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
                const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
                if (sellingPlansButtonContainer) {
                  if (isSecondPlan) {
                    sellingPlansButtonContainer.style.maxHeight = '1000px';
                  } else {
                    sellingPlansButtonContainer.style.maxHeight = '0px';
                  }
                }
              }
            }

            // Сразу закрываем дропдаун при клике на interval button (для более быстрой реакции)
            if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              if (newFrequencyDropdown) {
                newFrequencyDropdown.style.maxHeight = '0px';
                newFrequencyDropdown.style.opacity = '0';
                newFrequencyDropdown.style.visibility = 'hidden';
              }
              let selectFrequencyBtn = null;
              if (frequencyContainer) {
                selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
              }
              if (!selectFrequencyBtn && newFrequencyDropdown) {
                const wrapper = newFrequencyDropdown.closest('.loop-closed-modal-dropdowns-wrapper');
                if (wrapper) {
                  const container = wrapper.querySelector('.loop-closed-modal-frequency-container');
                  if (container) {
                    selectFrequencyBtn = container.querySelector('[data-dropdown="frequency-closed"]');
                  }
                }
              }
              if (selectFrequencyBtn) {
                selectFrequencyBtn.style.backgroundColor = 'transparent';
              }
            }

            // Находим соответствующий элемент в оригинале
            const clonedText = interactiveElement.textContent.trim();
            let originalElement = null;

            // Пробуем найти по классу и тексту
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              const originalContainers = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              for (let i = 0; i < originalContainers.length; i++) {
                if (originalContainers[i].textContent.trim() === clonedText) {
                  originalElement = originalContainers[i];
                  break;
                }
              }
            } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              const originalButtons = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              for (let i = 0; i < originalButtons.length; i++) {
                if (originalButtons[i].textContent.trim() === clonedText) {
                  originalElement = originalButtons[i];
                  break;
                }
              }
            } else {
              // Для других элементов пытаемся найти по селектору
              const elementClasses = Array.from(interactiveElement.classList).filter(c => c && !c.startsWith('loop-closed-modal'));
              if (elementClasses.length > 0) {
                const selector = '.' + elementClasses.join('.');
                const candidates = originalWidgetContainer.querySelectorAll(selector);
                for (let i = 0; i < candidates.length; i++) {
                  if (candidates[i].textContent.trim() === clonedText) {
                    originalElement = candidates[i];
                    break;
                  }
                }
              }
            }

            // Если нашли соответствующий элемент, кликаем по нему
            if (originalElement) {
              // Используем setTimeout, чтобы убедиться, что событие обработано
              setTimeout(function () {
                originalElement.click();
              }, 0);
            }

            // Сохраняем состояние в sessionStorage и закрываем дропдаун (вне зависимости от того, найден ли originalElement)
            setTimeout(function () {
              // Явно сохраняем состояние в sessionStorage после клика
              // Это важно для closed modal, где document.querySelector может не найти элементы
              // Сохраняем interval button, если это он
              if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
                const buttonText = interactiveElement.textContent.trim();
                sessionStorage.setItem('loop_selected_interval_button', buttonText);
                // При сохранении interval button, автоматически сохраняем "Claim an extra 26%" в selling plan
                sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
              }
              // Сохраняем selling plan, если это он
              if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
                const planText = interactiveElement.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
                sessionStorage.setItem('loop_selected_selling_plan', planText);
              }

              // Проверяем, является ли кликнутый элемент вторым selling plan container
              // Если да, то не закрываем дропдаун
              let shouldCloseDropdown = true;
              if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
                const allSellingPlans = newFrequencyDropdown ? newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
                const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
                const isSecondPlan = clickedIndex === 1;
                if (isSecondPlan) {
                  shouldCloseDropdown = false;
                }
              }



              // Закрываем дропдаун после выбора (только если это не второй selling plan container)
              if (shouldCloseDropdown) {

                // Ищем элементы более широко, на случай если frequencyContainer не найден
                let selectFrequencyBtn = null;
                if (frequencyContainer) {
                  selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
                }
                if (!selectFrequencyBtn) {
                  // Пробуем найти через wrapper
                  const wrapper = newFrequencyDropdown ? newFrequencyDropdown.closest('.loop-closed-modal-dropdowns-wrapper') : null;
                  if (wrapper) {
                    const container = wrapper.querySelector('.loop-closed-modal-frequency-container');
                    if (container) {
                      selectFrequencyBtn = container.querySelector('[data-dropdown="frequency-closed"]');
                    }
                  }
                }

                if (newFrequencyDropdown) {
                  newFrequencyDropdown.style.maxHeight = '0px';
                  newFrequencyDropdown.style.opacity = '0';
                  newFrequencyDropdown.style.visibility = 'hidden';
                  if (selectFrequencyBtn) {
                    selectFrequencyBtn.style.backgroundColor = 'transparent';
                  }
                }
              }
            }, 150);
          }

          // Удаляем старые обработчики, если они есть
          if (newFrequencyDropdown._clickHandler) {
            newFrequencyDropdown.removeEventListener('click', newFrequencyDropdown._clickHandler, true);
          }
          if (newFrequencyDropdown._touchendHandler) {
            newFrequencyDropdown.removeEventListener('touchend', newFrequencyDropdown._touchendHandler, { passive: false, capture: true });
          }

          // Используем делегирование событий для обработки всех кликов внутри frequency dropdown
          newFrequencyDropdown.addEventListener('click', handleFrequencyClick, true);
          newFrequencyDropdown._clickHandler = handleFrequencyClick;

          // Добавляем поддержку touch событий для лучшей отзывчивости на iOS
          const touchendHandler = function (e) {
            // Для touch событий используем touchend для лучшей отзывчивости на iOS
            e.preventDefault(); // Только для touch, чтобы предотвратить двойной вызов (click после touchend)
            handleFrequencyClick(e);
          };
          newFrequencyDropdown.addEventListener('touchend', touchendHandler, { passive: false, capture: true });
          newFrequencyDropdown._touchendHandler = touchendHandler;

          // Помечаем, что обработчик добавлен
          newFrequencyDropdown.dataset.handlerAdded = 'true';

          // Восстанавливаем observer после небольшой задержки
          setTimeout(function () {
            if (window.__expandedObserver && modalSheetContainer) {
              window.__expandedObserver.observe(modalSheetContainer, {
                attributes: true,
                attributeFilter: ['class']
              });
            }
            // Снимаем флаг обновления
            existingContainer.removeAttribute('data-updating');
          }, 100);
        }

        // Проверяем, загружен ли контент в оригинале
        const hasSkeleton = originalWidgetContainer.querySelector('.loop-skeleton');
        const dropdownHasSkeleton = existingFrequencyDropdown.querySelector('.loop-skeleton');

        // Если в оригинале нет skeleton, но в дропдауне есть, обновляем содержимое
        if (!hasSkeleton && dropdownHasSkeleton) {
          updateExistingFrequencyDropdownContent();
        } else if (hasSkeleton) {
          // Контент еще не загружен, наблюдаем за изменениями
          // Проверяем, не добавлен ли уже observer для этого контейнера
          if (!frequencyContainer.dataset.contentObserverAdded) {
            frequencyContainer.dataset.contentObserverAdded = 'true';

            const contentObserver = new MutationObserver(function (mutations) {
              const stillHasSkeleton = originalWidgetContainer.querySelector('.loop-skeleton');
              if (!stillHasSkeleton) {
                // Контент загрузился, обновляем дропдаун
                updateExistingFrequencyDropdownContent();
                contentObserver.disconnect();
                frequencyContainer.removeAttribute('data-content-observer-added');
              }
            });

            contentObserver.observe(originalWidgetContainer, {
              childList: true,
              subtree: true,
              attributes: true
            });

            // Также периодически проверяем, загрузился ли контент (на случай, если observer пропустит)
            const checkInterval = setInterval(function () {
              const stillHasSkeleton = originalWidgetContainer.querySelector('.loop-skeleton');
              if (!stillHasSkeleton) {
                updateExistingFrequencyDropdownContent();
                clearInterval(checkInterval);
                contentObserver.disconnect();
                frequencyContainer.removeAttribute('data-content-observer-added');
              }
            }, 500);

            // Останавливаем проверку через 10 секунд, чтобы не проверять бесконечно
            setTimeout(function () {
              clearInterval(checkInterval);
            }, 10000);
          }
        } else if (!hasSkeleton && !dropdownHasSkeleton) {
          // Контент уже загружен в обоих местах
          // В закрытом модале оригинал не меняется, поэтому не проверяем содержимое
          // Обновляем только если обработчик не добавлен (первое создание)
          if (existingFrequencyDropdown.dataset.handlerAdded === 'true') {
            // Обработчик уже есть, не обновляем содержимое
            // Снимаем флаг обновления
            existingContainer.removeAttribute('data-updating');
          } else {
            // Обработчик не добавлен, обновляем содержимое
            updateExistingFrequencyDropdownContent();
          }
        }
      } else {
        // Если frequency dropdown не существует, снимаем флаг (если он был установлен)
        existingContainer.removeAttribute('data-updating');
      }

      setupClosedModalBundleDropdownHandlers(bundleContainer);
      if (frequencyContainer) {
        setupClosedModalFrequencyDropdownHandlers(frequencyContainer);
      }
      return;
    }

    const bodyContainer = document.querySelector('.loop-bottom-sheet-body-container');
    if (!bodyContainer || !bodyContainer.parentNode) {
      return;
    }

    // Проверяем еще раз, не создан ли уже контейнер (на случай race condition)
    const doubleCheckContainer = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
    if (doubleCheckContainer && doubleCheckContainer.parentNode) {
      return;
    }

    // Устанавливаем флаг, что создание началось
    window.__creatingClosedModalDropdowns = true;

    try {
      // Создаем общий wrapper для обоих дропдаунов
      const wrapper = document.createElement('div');
      wrapper.className = 'loop-closed-modal-dropdowns-wrapper';
      wrapper.style.cssText = `
      width: 100%;
      display: flex;
      flex-direction: row;
      gap: 15px;
      padding: 30px 16px 0;
      background-color: #F9FAE7;
    `;

      // Создаем контейнер для кнопки Bundle и дропдауна
      const bundleContainer = document.createElement('div');
      bundleContainer.className = 'loop-closed-modal-bundle-container';
      bundleContainer.style.cssText = `
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      position: relative;
    `;

      // Создаем кнопку "Select Bundle"
      const selectBundleBtn = document.createElement('button');
      selectBundleBtn.className = 'loop-mobile-dropdown-btn loop-closed-modal-bundle-btn';
      selectBundleBtn.setAttribute('data-dropdown', 'bundle-closed');
      selectBundleBtn.textContent = 'Select Bundle';
      selectBundleBtn.style.cssText = `
      width: 100%;
      height: 40px;
      padding: 10px 11px;
      color: #000;
      border: 2px solid #A9FA63;
      border-radius: 10px;
      font-weight: 700;
      cursor: pointer;
      transition: background-color 0.2s;
      background-color: transparent;
      line-height: 1;
      -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3);
      touch-action: manipulation;
      user-select: none;
    `;
      bundleContainer.appendChild(selectBundleBtn);

      // Клонируем loop-bundle-size-selector-new-wrapper для дропдауна
      const originalSizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
      if (originalSizeSelector) {
        // Проверяем, загружен ли контент (нет ли skeleton loaders)
        const hasSkeleton = originalSizeSelector.querySelector('.loop-skeleton');

        const bundleDropdown = originalSizeSelector.cloneNode(true);
        bundleDropdown.classList.add('loop-mobile-bundle-dropdown');
        bundleDropdown.classList.add('loop-closed-modal-bundle-dropdown');
        bundleDropdown.style.cssText = `
        width: 100%;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
        margin-bottom: 5px;
        margin-left: 0px;
        opacity: 0;
        visibility: hidden;
        border: 2px solid #A9FA63;
        border-radius: 10px;
        background-color: white;
        padding-top: 7px !important;
        display: block !important;
        position: absolute;
        bottom: 100%;
        box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
      `;
        bundleContainer.appendChild(bundleDropdown);

        // Функция для добавления элемента loop-pots-total-question, если он отсутствует
        function ensurePotsTotalQuestion() {
          const originalQuestion = originalSizeSelector.querySelector('#loop-pots-total-question');
          const dropdownQuestion = bundleDropdown.querySelector('#loop-pots-total-question');
          if (originalQuestion && !dropdownQuestion) {
            // Клонируем элемент из оригинала
            const clonedQuestion = originalQuestion.cloneNode(true);
            const sizeSelectorLabel = bundleDropdown.querySelector('.loop-h2.loop-bundle-size-selector-label');
            if (sizeSelectorLabel) {
              if (sizeSelectorLabel.nextSibling) {
                sizeSelectorLabel.parentNode.insertBefore(clonedQuestion, sizeSelectorLabel.nextSibling);
              } else {
                sizeSelectorLabel.parentNode.appendChild(clonedQuestion);
              }
            }
            return true; // Элемент добавлен
          }
          return false; // Элемент не добавлен
        }

        // Проверяем сразу, если элемент уже есть
        if (!ensurePotsTotalQuestion()) {
          // Если элемента еще нет, периодически проверяем его появление
          let checkCount = 0;
          const maxChecks = 15; // Проверяем 25 раз (5 секунд при интервале 200ms)
          const checkInterval = setInterval(function () {
            checkCount++;
            if (ensurePotsTotalQuestion() || checkCount >= maxChecks) {
              clearInterval(checkInterval);
            }
          }, 200);
        }

        // Функция для обновления содержимого дропдауна и обработчиков
        function updateDropdownContent() {
          if (!originalSizeSelector || !bundleDropdown) {
            return;
          }

          // Обновляем содержимое дропдауна
          bundleDropdown.innerHTML = originalSizeSelector.innerHTML;

          // Добавляем обработчики кликов для кнопок размера в клонированном дропдауне
          const bundleSizeButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
          bundleSizeButtons.forEach(function (clonedButton) {
            // Кнопки уже клонированы через cloneNode, поэтому listeners сброшены
            clonedButton.removeAttribute('data-click-handler-added');
            clonedButton.dataset.clickHandlerAdded = 'true';

            const buttonText = clonedButton.textContent.trim();

            // Добавляем стили для улучшения кликабельности на iOS
            clonedButton.style.cssText = (clonedButton.style.cssText || '') +
              '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';

            // Функция для обработки клика/тапа
            function handleButtonClick(e) {
              // Не используем preventDefault, чтобы не блокировать нативные тапы на iOS
              e.stopPropagation();

              // Добавляем класс loop-btn-selected к кликнутой кнопке в dropdown
              const allButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
              allButtons.forEach(function (btn) {
                if (btn.textContent.trim() === buttonText) {
                  btn.classList.add('loop-btn-selected');
                } else {
                  btn.classList.remove('loop-btn-selected');
                }
              });

              const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
              originalButtons.forEach(function (originalButton) {
                if (originalButton.textContent.trim() === buttonText) {
                  originalButton.click();
                  // Классы уже синхронизированы вручную выше, observer будет следить за дальнейшими изменениями

                  // Обновляем текст кнопки после выбора
                  updateBundleButtonText(buttonText);
                }
              });
            }

            // Флаг для предотвращения двойного вызова на iOS
            let isHandlingTouch = false;
            let lastTouchTime = 0;

            // Обработчик touchend для iOS
            const touchendHandler = function (e) {
              const now = Date.now();
              // Предотвращаем двойной вызов
              if (isHandlingTouch || (now - lastTouchTime) < 300) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }

              isHandlingTouch = true;
              lastTouchTime = now;

              // Не используем preventDefault здесь, чтобы не блокировать нативные события
              e.stopPropagation();
              handleButtonClick(e);

              // Сбрасываем флаг через небольшую задержку
              setTimeout(function () {
                isHandlingTouch = false;
              }, 300);
            };

            // Обработчик click (для десктопа и как fallback)
            const clickHandlerWrapper = function (e) {
              // Если touchend уже обработал событие, игнорируем click
              if (isHandlingTouch) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              handleButtonClick(e);
            };

            // Добавляем обработчики для click и touchend (для iOS)
            clonedButton.addEventListener('click', clickHandlerWrapper);
            clonedButton.addEventListener('touchend', touchendHandler, { passive: true });

            // Сохраняем ссылки на handlers
            clonedButton._clickHandler = handleButtonClick;
            clonedButton._touchendHandler = touchendHandler;
          });

          // Синхронизируем начальное состояние классов
          syncBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);

          // Наблюдаем за изменениями классов на оригинальных кнопках
          observeBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);
        }

        // Если контент еще не загружен, наблюдаем за изменениями
        if (hasSkeleton) {
          const contentObserver = new MutationObserver(function (mutations) {
            const stillHasSkeleton = originalSizeSelector.querySelector('.loop-skeleton');
            if (!stillHasSkeleton) {
              // Контент загрузился, обновляем дропдаун
              updateDropdownContent();
              contentObserver.disconnect();
            }
          });

          contentObserver.observe(originalSizeSelector, {
            childList: true,
            subtree: true,
            attributes: true
          });
        } else {
          // Контент уже загружен, сразу обновляем обработчики
          updateDropdownContent();
        }
      }

      // Создаем контейнер для кнопки Frequency и дропдауна
      const frequencyContainer = document.createElement('div');
      frequencyContainer.className = 'loop-closed-modal-frequency-container';
      frequencyContainer.style.cssText = `
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      position: relative;
    `;

      // Создаем кнопку "Select Frequency"
      const selectFrequencyBtn = document.createElement('button');
      selectFrequencyBtn.className = 'loop-mobile-dropdown-btn loop-closed-modal-frequency-btn';
      selectFrequencyBtn.setAttribute('data-dropdown', 'frequency-closed');
      selectFrequencyBtn.textContent = 'Select Frequency';
      selectFrequencyBtn.style.cssText = `
      width: 100%;
      height: 40px;
      padding: 10px 11px;
      color: #000;
      border: 2px solid #A9FA63;
      border-radius: 10px;
      font-weight: 700;
      cursor: pointer;
      transition: background-color 0.2s;
      background-color: transparent;
      line-height: 1;
      -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3);
      touch-action: manipulation;
      user-select: none;
    `;
      frequencyContainer.appendChild(selectFrequencyBtn);

      // Клонируем loop-bundle-widget-container для дропдауна Frequency
      const originalWidgetContainer = document.querySelector('.loop-bundle-widget-container');
      if (originalWidgetContainer) {
        // Проверяем, загружен ли контент (нет ли skeleton loaders)
        const hasSkeleton = originalWidgetContainer.querySelector('.loop-skeleton');

        const frequencyDropdown = originalWidgetContainer.cloneNode(true);
        frequencyDropdown.classList.add('loop-mobile-frequency-dropdown');
        frequencyDropdown.classList.add('loop-closed-modal-frequency-dropdown');
        frequencyDropdown.style.cssText = `
        width: 100%;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
        margin-bottom: 5px;
        margin-left: 0px;
        opacity: 0;
        visibility: hidden;
        border: 2px solid #A9FA63;
        border-radius: 10px;
        background-color: white;
        padding-top: 7px !important;
        display: block !important;
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
      `;
        frequencyContainer.appendChild(frequencyDropdown);

        // Добавляем текст над содержимым дропдауна
        addFrequencyDropdownText(frequencyDropdown);

        // Проверяем и устанавливаем max-height для loop-bundle-widget-frequency-selling-plans-button-container
        const sellingPlansButtonContainer = frequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
        if (sellingPlansButtonContainer) {
          const allIntervalButtons = frequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
          const hasSelectedIntervalButton = Array.from(allIntervalButtons).some(function (btn) {
            return btn.classList.contains('selected');
          });
          if (!hasSelectedIntervalButton) {
            sellingPlansButtonContainer.style.maxHeight = '0px';
          }
        }

        // Добавляем стили для улучшения кликабельности интерактивных элементов на iOS
        const interactiveElements = frequencyDropdown.querySelectorAll(
          '.loop-bundle-widget-selling-plan-container, .loop-bundle-widget-frequency-interval-button, button, [role="button"]'
        );
        interactiveElements.forEach(function (element) {
          element.style.cssText = (element.style.cssText || '') +
            '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';
        });

        // Функция для обработки клика/тапа на интерактивных элементах
        function handleFrequencyClick(e) {
          const target = e.target;

          // Игнорируем клики на сам dropdown и его прямые дочерние элементы-обертки
          if (target === frequencyDropdown || target.classList.contains('loop-mobile-frequency-dropdown-text')) {
            return;
          }

          // Находим ближайший интерактивный элемент
          let interactiveElement = target.closest('.loop-bundle-widget-selling-plan-container');
          if (!interactiveElement) {
            interactiveElement = target.closest('.loop-bundle-widget-frequency-interval-button');
          }
          if (!interactiveElement) {
            interactiveElement = target.closest('button');
          }
          if (!interactiveElement) {
            interactiveElement = target.closest('[role="button"]');
          }

          // Проверяем, что элемент находится внутри closed modal frequency dropdown
          const isInClosedModalDropdown = interactiveElement && (
            interactiveElement.closest('.loop-closed-modal-frequency-dropdown') ||
            frequencyDropdown && frequencyDropdown.contains(interactiveElement)
          );

          if (!interactiveElement || !isInClosedModalDropdown) {
            return;
          }

          // Останавливаем всплытие (но не preventDefault, чтобы не блокировать на мобильных)
          e.stopPropagation();

          // Добавляем класс selected к кликнутому элементу в dropdown
          if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
            // Убираем selected у всех selling plan containers
            const allSellingPlans = frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
            allSellingPlans.forEach(function (plan) {
              plan.classList.remove('selected');
              plan.style.backgroundColor = 'transparent';
            });
            // Убираем selected у всех interval buttons
            const allIntervalButtons = frequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
            allIntervalButtons.forEach(function (btn) {
              btn.classList.remove('selected');
            });
            // Добавляем selected к кликнутому
            interactiveElement.classList.add('selected');
            interactiveElement.style.backgroundColor = '#A9FA63';

            // Проверяем, является ли кликнутый элемент вторым по счету
            const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
            const isSecondPlan = clickedIndex === 1;
            const isFirstPlan = clickedIndex === 0;

            // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
            const sellingPlansButtonContainer = frequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
            if (sellingPlansButtonContainer) {
              if (isSecondPlan) {
                sellingPlansButtonContainer.style.maxHeight = '1000px';
                // Добавляем selected к первому interval button внутри sellingPlansButtonContainer
                const firstIntervalButton = sellingPlansButtonContainer.querySelector('.loop-bundle-widget-frequency-interval-button');
                if (firstIntervalButton) {
                  // Убираем selected у всех interval buttons
                  const allIntervalButtonsInContainer = sellingPlansButtonContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
                  allIntervalButtonsInContainer.forEach(function (btn) {
                    btn.classList.remove('selected');
                  });
                  // Добавляем selected к первому
                  firstIntervalButton.classList.add('selected');
                  const intervalText = firstIntervalButton.textContent.trim();
                  sessionStorage.setItem('loop_selected_interval_button', intervalText);
                }
              } else {
                // Проверяем, есть ли selected interval buttons
                const hasSelectedIntervalButton = Array.from(allIntervalButtons).some(function (btn) {
                  return btn.classList.contains('selected');
                });
                if (!hasSelectedIntervalButton) {
                  sellingPlansButtonContainer.style.maxHeight = '0px';
                } else {
                  sellingPlansButtonContainer.style.maxHeight = '0px';
                }
              }
            }

            // Если выбран первый элемент, сохраняем HTML loop-bundle-widget-frequency-selling-plans-button-container
            if (isFirstPlan) {

              const buttonLayout = frequencyDropdown.querySelector('.loop-widet-button-layout');

              if (buttonLayout) {
                const existingSellingPlansContainer = buttonLayout.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');

                if (existingSellingPlansContainer) {
                  // Клонируем элемент
                  const clonedContainer = existingSellingPlansContainer.cloneNode(true);
                  // Убираем selected у всех кнопок в клоне
                  const allIntervalButtonsInClone = clonedContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');

                  allIntervalButtonsInClone.forEach(function (btn) {
                    btn.classList.remove('selected');
                  });
                  // Сохраняем HTML в переменную
                  window.__firstPlanSelectedFrequencyContainerHTML = clonedContainer.outerHTML;

                } else {

                }
              } else {

              }
            } else {

            }
          } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
            // Убираем selected у всех interval buttons
            const allIntervalButtons = frequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
            allIntervalButtons.forEach(function (btn) {
              btn.classList.remove('selected');
            });
            // Добавляем selected к кликнутому
            interactiveElement.classList.add('selected');
            // Убираем selected у первого по счету элемента loop-bundle-widget-selling-plan-container
            const allSellingPlans = frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
            if (allSellingPlans.length > 0) {
              const firstSellingPlan = allSellingPlans[0];
              firstSellingPlan.classList.remove('selected');
              firstSellingPlan.style.backgroundColor = 'transparent';
              // Также добавляем selected к последнему по счету элементу loop-bundle-widget-selling-plan-container
              const lastSellingPlan = allSellingPlans[allSellingPlans.length - 1];
              lastSellingPlan.classList.add('selected');
              lastSellingPlan.style.backgroundColor = '#A9FA63';

              // Проверяем, является ли последний элемент вторым по счету (индекс 1)
              const lastIndex = Array.from(allSellingPlans).indexOf(lastSellingPlan);
              const isSecondPlan = lastIndex === 1;

              // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
              const sellingPlansButtonContainer = frequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
              if (sellingPlansButtonContainer) {
                if (isSecondPlan) {
                  sellingPlansButtonContainer.style.maxHeight = '1000px';
                } else {
                  sellingPlansButtonContainer.style.maxHeight = '0px';
                }
              }
            }
          }

          // Сразу закрываем дропдаун при клике на interval button (для более быстрой реакции)
          if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
            if (frequencyDropdown) {
              frequencyDropdown.style.maxHeight = '0px';
              frequencyDropdown.style.opacity = '0';
              frequencyDropdown.style.visibility = 'hidden';
            }
            let selectFrequencyBtn = null;
            if (frequencyContainer) {
              selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
            }
            if (!selectFrequencyBtn && frequencyDropdown) {
              const wrapper = frequencyDropdown.closest('.loop-closed-modal-dropdowns-wrapper');
              if (wrapper) {
                const container = wrapper.querySelector('.loop-closed-modal-frequency-container');
                if (container) {
                  selectFrequencyBtn = container.querySelector('[data-dropdown="frequency-closed"]');
                }
              }
            }
            if (selectFrequencyBtn) {
              selectFrequencyBtn.style.backgroundColor = 'transparent';
            }
          }

          // Находим соответствующий элемент в оригинале
          const clonedText = interactiveElement.textContent.trim();
          let originalElement = null;

          // Пробуем найти по классу и тексту
          if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
            const originalContainers = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
            for (let i = 0; i < originalContainers.length; i++) {
              if (originalContainers[i].textContent.trim() === clonedText) {
                originalElement = originalContainers[i];
                break;
              }
            }
          } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
            const originalButtons = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
            for (let i = 0; i < originalButtons.length; i++) {
              if (originalButtons[i].textContent.trim() === clonedText) {
                originalElement = originalButtons[i];
                break;
              }
            }
          } else {
            // Для других элементов пытаемся найти по селектору
            const elementClasses = Array.from(interactiveElement.classList).filter(c => c && !c.startsWith('loop-closed-modal'));
            if (elementClasses.length > 0) {
              const selector = '.' + elementClasses.join('.');
              const candidates = originalWidgetContainer.querySelectorAll(selector);
              for (let i = 0; i < candidates.length; i++) {
                if (candidates[i].textContent.trim() === clonedText) {
                  originalElement = candidates[i];
                  break;
                }
              }
            }
          }

          // Если нашли соответствующий элемент, кликаем по нему
          if (originalElement) {
            // Используем setTimeout, чтобы убедиться, что событие обработано
            setTimeout(function () {
              originalElement.click();
            }, 0);
          }

          // Сохраняем состояние в sessionStorage и закрываем дропдаун (вне зависимости от того, найден ли originalElement)
          setTimeout(function () {
            // Явно сохраняем состояние в sessionStorage после клика
            // Это важно для closed modal, где document.querySelector может не найти элементы
            // Сохраняем interval button, если это он
            if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              const buttonText = interactiveElement.textContent.trim();
              sessionStorage.setItem('loop_selected_interval_button', buttonText);
              // При сохранении interval button, автоматически сохраняем "Claim an extra 26%" в selling plan
              sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
              // Обновляем текст кнопки Frequency
              updateFrequencyButtonText(buttonText);
            }
            // Сохраняем selling plan, если это он
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              const planText = interactiveElement.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
              sessionStorage.setItem('loop_selected_selling_plan', planText);

              // Проверяем, является ли это второй элемент (индекс 1)
              const allSellingPlans = frequencyDropdown ? frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
              const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
              const isSecondPlan = clickedIndex === 1;

              // Если это второй элемент, используем текст первого interval button
              if (isSecondPlan) {
                const firstIntervalButton = document.querySelector('.loop-bundle-widget-frequency-interval-button');
                if (firstIntervalButton) {
                  const intervalText = firstIntervalButton.textContent.trim();
                  updateFrequencyButtonText(intervalText);
                }
              } else {
                // Обновляем текст кнопки Frequency
                updateFrequencyButtonText(planText);
              }
            }

            // Проверяем, является ли кликнутый элемент вторым selling plan container
            // Если да, то не закрываем дропдаун
            let shouldCloseDropdown = true;
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              const allSellingPlans = frequencyDropdown ? frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
              const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
              const isSecondPlan = clickedIndex === 1;
              if (isSecondPlan) {
                shouldCloseDropdown = false;
              }
            }



            // Закрываем дропдаун после выбора (только если это не второй selling plan container)
            if (shouldCloseDropdown) {

              // Ищем элементы более широко, на случай если frequencyContainer не найден
              let selectFrequencyBtn = null;
              if (frequencyContainer) {
                selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
              }
              if (!selectFrequencyBtn && frequencyDropdown) {
                // Пробуем найти через wrapper
                const wrapper = frequencyDropdown.closest('.loop-closed-modal-dropdowns-wrapper');
                if (wrapper) {
                  const container = wrapper.querySelector('.loop-closed-modal-frequency-container');
                  if (container) {
                    selectFrequencyBtn = container.querySelector('[data-dropdown="frequency-closed"]');
                  }
                }
              }

              if (frequencyDropdown) {
                frequencyDropdown.style.maxHeight = '0px';
                frequencyDropdown.style.opacity = '0';
                frequencyDropdown.style.visibility = 'hidden';
                if (selectFrequencyBtn) {
                  selectFrequencyBtn.style.backgroundColor = 'transparent';
                }
              }
            }
          }, 150);
        }

        // Удаляем старые обработчики, если они есть
        if (frequencyDropdown._clickHandler) {
          frequencyDropdown.removeEventListener('click', frequencyDropdown._clickHandler, true);
        }
        if (frequencyDropdown._touchendHandler) {
          frequencyDropdown.removeEventListener('touchend', frequencyDropdown._touchendHandler, { passive: false, capture: true });
        }

        // Используем делегирование событий для обработки всех кликов внутри frequency dropdown
        frequencyDropdown.addEventListener('click', handleFrequencyClick, true);
        frequencyDropdown._clickHandler = handleFrequencyClick;

        // Добавляем поддержку touch событий для лучшей отзывчивости на iOS
        const touchendHandler = function (e) {
          // Для touch событий используем touchend для лучшей отзывчивости на iOS
          e.preventDefault(); // Только для touch, чтобы предотвратить двойной вызов (click после touchend)
          handleFrequencyClick(e);
        };
        frequencyDropdown.addEventListener('touchend', touchendHandler, { passive: false, capture: true });
        frequencyDropdown._touchendHandler = touchendHandler;

        // Помечаем, что обработчик добавлен
        frequencyDropdown.dataset.handlerAdded = 'true';

        // Функция для обновления содержимого дропдауна
        function updateFrequencyDropdownContent() {
          if (!originalWidgetContainer || !frequencyDropdown) {
            return;
          }

          // Обновляем содержимое дропдауна
          frequencyDropdown.innerHTML = originalWidgetContainer.innerHTML;
          addFrequencyDropdownText(frequencyDropdown);

          // Обновляем обработчики - клонируем элемент для сброса listeners
          const newFrequencyDropdown = frequencyDropdown.cloneNode(true);
          const oldStyles = frequencyDropdown.style.cssText;
          frequencyDropdown.parentNode.replaceChild(newFrequencyDropdown, frequencyDropdown);
          newFrequencyDropdown.style.cssText = oldStyles;

          // Проверяем и устанавливаем max-height для loop-bundle-widget-frequency-selling-plans-button-container
          const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
          if (sellingPlansButtonContainer) {
            const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
            const hasSelectedIntervalButton = Array.from(allIntervalButtons).some(function (btn) {
              return btn.classList.contains('selected');
            });
            if (!hasSelectedIntervalButton) {
              sellingPlansButtonContainer.style.maxHeight = '0px';
            }
          }

          // Добавляем стили для улучшения кликабельности интерактивных элементов на iOS
          const interactiveElements = newFrequencyDropdown.querySelectorAll(
            '.loop-bundle-widget-selling-plan-container, .loop-bundle-widget-frequency-interval-button, button, [role="button"]'
          );
          interactiveElements.forEach(function (element) {
            element.style.cssText = (element.style.cssText || '') +
              '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';
          });

          // Переопределяем handleFrequencyClick для нового элемента
          function handleFrequencyClickUpdated(e) {
            const target = e.target;

            // Игнорируем клики на сам dropdown и его прямые дочерние элементы-обертки
            if (target === newFrequencyDropdown || target.classList.contains('loop-mobile-frequency-dropdown-text')) {
              return;
            }

            // Находим ближайший интерактивный элемент
            let interactiveElement = target.closest('.loop-bundle-widget-selling-plan-container');
            if (!interactiveElement) {
              interactiveElement = target.closest('.loop-bundle-widget-frequency-interval-button');
            }
            if (!interactiveElement) {
              interactiveElement = target.closest('button');
            }
            if (!interactiveElement) {
              interactiveElement = target.closest('[role="button"]');
            }

            // Проверяем, что элемент находится внутри closed modal frequency dropdown
            const isInClosedModalDropdown = interactiveElement && (
              interactiveElement.closest('.loop-closed-modal-frequency-dropdown') ||
              newFrequencyDropdown && newFrequencyDropdown.contains(interactiveElement)
            );

            if (!interactiveElement || !isInClosedModalDropdown) {
              return;
            }

            // Останавливаем всплытие (но не preventDefault, чтобы не блокировать на мобильных)
            e.stopPropagation();

            // Добавляем класс selected к кликнутому элементу в dropdown
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              // Убираем selected у всех selling plan containers
              const allSellingPlans = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              allSellingPlans.forEach(function (plan) {
                plan.classList.remove('selected');
                plan.style.backgroundColor = 'transparent';
              });
              // Убираем selected у всех interval buttons
              const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              allIntervalButtons.forEach(function (btn) {
                btn.classList.remove('selected');
              });
              // Добавляем selected к кликнутому
              interactiveElement.classList.add('selected');
              interactiveElement.style.backgroundColor = '#A9FA63';

              // Проверяем, является ли кликнутый элемент вторым по счету
              const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
              const isSecondPlan = clickedIndex === 1;

              // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
              const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
              if (sellingPlansButtonContainer) {
                if (isSecondPlan) {
                  sellingPlansButtonContainer.style.maxHeight = '1000px';
                  // Добавляем selected к первому interval button внутри sellingPlansButtonContainer
                  const firstIntervalButton = sellingPlansButtonContainer.querySelector('.loop-bundle-widget-frequency-interval-button');
                  if (firstIntervalButton) {
                    // Убираем selected у всех interval buttons
                    const allIntervalButtonsInContainer = sellingPlansButtonContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
                    allIntervalButtonsInContainer.forEach(function (btn) {
                      btn.classList.remove('selected');
                    });
                    // Добавляем selected к первому
                    firstIntervalButton.classList.add('selected');
                    const intervalText = firstIntervalButton.textContent.trim();
                    sessionStorage.setItem('loop_selected_interval_button', intervalText);
                  }
                } else {
                  sellingPlansButtonContainer.style.maxHeight = '0px';
                }
              }
            } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              // Убираем selected у всех interval buttons
              const allIntervalButtons = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              allIntervalButtons.forEach(function (btn) {
                btn.classList.remove('selected');
              });
              // Добавляем selected к кликнутому
              interactiveElement.classList.add('selected');
              // Убираем selected у первого по счету элемента loop-bundle-widget-selling-plan-container
              const allSellingPlans = newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              if (allSellingPlans.length > 0) {
                const firstSellingPlan = allSellingPlans[0];
                firstSellingPlan.classList.remove('selected');
                firstSellingPlan.style.backgroundColor = 'transparent';
                // Также добавляем selected к последнему по счету элементу loop-bundle-widget-selling-plan-container
                const lastSellingPlan = allSellingPlans[allSellingPlans.length - 1];
                lastSellingPlan.classList.add('selected');
                lastSellingPlan.style.backgroundColor = '#A9FA63';

                // Проверяем, является ли последний элемент вторым по счету (индекс 1)
                const lastIndex = Array.from(allSellingPlans).indexOf(lastSellingPlan);
                const isSecondPlan = lastIndex === 1;

                // Управляем max-height для loop-bundle-widget-frequency-selling-plans-button-container
                const sellingPlansButtonContainer = newFrequencyDropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
                if (sellingPlansButtonContainer) {
                  if (isSecondPlan) {
                    sellingPlansButtonContainer.style.maxHeight = '1000px';
                  } else {
                    sellingPlansButtonContainer.style.maxHeight = '0px';
                  }
                }
              }
            }

            // Сразу закрываем дропдаун при клике на interval button (для более быстрой реакции)
            if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              if (newFrequencyDropdown) {
                newFrequencyDropdown.style.maxHeight = '0px';
                newFrequencyDropdown.style.opacity = '0';
                newFrequencyDropdown.style.visibility = 'hidden';
              }
              let selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
              if (selectFrequencyBtn) {
                selectFrequencyBtn.style.backgroundColor = 'transparent';
              }
            }

            // Находим соответствующий элемент в оригинале
            const clonedText = interactiveElement.textContent.trim();
            let originalElement = null;

            // Пробуем найти по классу и тексту
            if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
              const originalContainers = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
              for (let i = 0; i < originalContainers.length; i++) {
                if (originalContainers[i].textContent.trim() === clonedText) {
                  originalElement = originalContainers[i];
                  break;
                }
              }
            } else if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
              const originalButtons = originalWidgetContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
              for (let i = 0; i < originalButtons.length; i++) {
                if (originalButtons[i].textContent.trim() === clonedText) {
                  originalElement = originalButtons[i];
                  break;
                }
              }
            }

            // Если нашли соответствующий элемент, кликаем по нему
            if (originalElement) {
              setTimeout(function () {
                originalElement.click();
              }, 0);
            }

            // Сохраняем состояние в sessionStorage и закрываем дропдаун
            setTimeout(function () {
              if (interactiveElement.classList.contains('loop-bundle-widget-frequency-interval-button')) {
                const buttonText = interactiveElement.textContent.trim();
                sessionStorage.setItem('loop_selected_interval_button', buttonText);
                sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
                // Обновляем текст кнопки Frequency
                updateFrequencyButtonText(buttonText);
              }
              if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
                const planText = interactiveElement.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
                sessionStorage.setItem('loop_selected_selling_plan', planText);

                // Проверяем, является ли это второй элемент (индекс 1)
                const allSellingPlans = newFrequencyDropdown ? newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
                const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
                const isSecondPlan = clickedIndex === 1;

                // Если это второй элемент, используем текст первого interval button
                if (isSecondPlan) {
                  const firstIntervalButton = document.querySelector('.loop-bundle-widget-frequency-interval-button');
                  if (firstIntervalButton) {
                    const intervalText = firstIntervalButton.textContent.trim();
                    updateFrequencyButtonText(intervalText);
                  }
                } else {
                  // Обновляем текст кнопки Frequency
                  updateFrequencyButtonText(planText);
                }
              }

              // Проверяем, является ли кликнутый элемент вторым selling plan container
              // Если да, то не закрываем дропдаун
              let shouldCloseDropdown = true;
              if (interactiveElement.classList.contains('loop-bundle-widget-selling-plan-container')) {
                const allSellingPlans = newFrequencyDropdown ? newFrequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
                const clickedIndex = Array.from(allSellingPlans).indexOf(interactiveElement);
                const isSecondPlan = clickedIndex === 1;
                if (isSecondPlan) {
                  shouldCloseDropdown = false;
                }
              }



              // Закрываем дропдаун после выбора (только если это не второй selling plan container)
              if (shouldCloseDropdown && newFrequencyDropdown) {

                newFrequencyDropdown.style.maxHeight = '0px';
                newFrequencyDropdown.style.opacity = '0';
                newFrequencyDropdown.style.visibility = 'hidden';
                const selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
                if (selectFrequencyBtn) {
                  selectFrequencyBtn.style.backgroundColor = 'transparent';
                }
              }
            }, 150);
          }

          // Удаляем старые обработчики, если они есть
          if (newFrequencyDropdown._clickHandler) {
            newFrequencyDropdown.removeEventListener('click', newFrequencyDropdown._clickHandler, true);
          }
          if (newFrequencyDropdown._touchendHandler) {
            newFrequencyDropdown.removeEventListener('touchend', newFrequencyDropdown._touchendHandler, { passive: false, capture: true });
          }

          // Используем делегирование событий для обработки всех кликов внутри frequency dropdown
          newFrequencyDropdown.addEventListener('click', handleFrequencyClickUpdated, true);
          newFrequencyDropdown._clickHandler = handleFrequencyClickUpdated;

          // Добавляем поддержку touch событий для лучшей отзывчивости на iOS
          const touchendHandler = function (e) {
            e.preventDefault();
            handleFrequencyClickUpdated(e);
          };
          newFrequencyDropdown.addEventListener('touchend', touchendHandler, { passive: false, capture: true });
          newFrequencyDropdown._touchendHandler = touchendHandler;

          // Помечаем, что обработчик добавлен
          newFrequencyDropdown.dataset.handlerAdded = 'true';
        }

        // Если контент еще не загружен, наблюдаем за изменениями
        if (hasSkeleton) {
          const contentObserver = new MutationObserver(function (mutations) {
            const stillHasSkeleton = originalWidgetContainer.querySelector('.loop-skeleton');
            if (!stillHasSkeleton) {
              // Контент загрузился, обновляем дропдаун
              updateFrequencyDropdownContent();
              contentObserver.disconnect();
            }
          });

          contentObserver.observe(originalWidgetContainer, {
            childList: true,
            subtree: true,
            attributes: true
          });
        } else {
          // Контент уже загружен, сразу обновляем обработчики (если нужно)
          // Но обработчики уже добавлены выше, так что ничего не делаем
        }
      }

      // Добавляем оба контейнера в wrapper
      wrapper.appendChild(bundleContainer);
      wrapper.appendChild(frequencyContainer);

      // Вставляем wrapper после loop-bottom-sheet-body-container
      if (bodyContainer.nextSibling) {
        bodyContainer.parentNode.insertBefore(wrapper, bodyContainer.nextSibling);
      } else {
        bodyContainer.parentNode.appendChild(wrapper);
      }

      // Настраиваем обработчики
      setupClosedModalBundleDropdownHandlers(bundleContainer);
      setupClosedModalFrequencyDropdownHandlers(frequencyContainer);

      // Восстанавливаем текст кнопок на основе текущего выбора
      // Используем большую задержку, чтобы элементы успели загрузиться
      setTimeout(function () {
        restoreButtonTexts();
      }, 200);
    } catch (e) {
      console.warn('[custom.js] Ошибка при создании closed modal dropdowns:', e);
    } finally {
      // Снимаем флаг после завершения создания (в любом случае)
      window.__creatingClosedModalDropdowns = false;
    }
  }

  /**
   * Устанавливает обработчики для дропдауна "Select Bundle" в закрытом модальном окне
   */
  function setupClosedModalBundleDropdownHandlers(container) {
    const selectBundleBtn = container.querySelector('[data-dropdown="bundle-closed"]');
    const bundleDropdown = container.querySelector('.loop-closed-modal-bundle-dropdown');
    const wrapper = container.closest('.loop-closed-modal-dropdowns-wrapper');
    const frequencyContainer = wrapper ? wrapper.querySelector('.loop-closed-modal-frequency-container') : null;
    const frequencyDropdown = frequencyContainer ? frequencyContainer.querySelector('.loop-closed-modal-frequency-dropdown') : null;

    if (!selectBundleBtn || !bundleDropdown) {
      return;
    }

    // Удаляем старые обработчики, если они есть
    if (selectBundleBtn._clickHandler) {
      selectBundleBtn.removeEventListener('click', selectBundleBtn._clickHandler, { passive: true });
    }
    if (selectBundleBtn._touchendHandler) {
      selectBundleBtn.removeEventListener('touchend', selectBundleBtn._touchendHandler, { passive: false });
    }

    // Функция для открытия/закрытия bundle dropdown
    function toggleBundleDropdown(e) {
      if (e) {
        // Не используем preventDefault, чтобы не блокировать нормальную работу на мобильных
        e.stopPropagation();
      }

      const isOpen = bundleDropdown.style.maxHeight && bundleDropdown.style.maxHeight !== '0px';

      // Закрываем frequency dropdown, если он открыт
      if (frequencyDropdown && frequencyDropdown.style.maxHeight && frequencyDropdown.style.maxHeight !== '0px') {
        frequencyDropdown.style.maxHeight = '0px';
        frequencyDropdown.style.opacity = '0';
        frequencyDropdown.style.visibility = 'hidden';
        const frequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
        if (frequencyBtn) {
          frequencyBtn.style.backgroundColor = 'transparent';
        }
      }

      if (isOpen) {
        // Закрываем дропдаун
        bundleDropdown.style.maxHeight = '0px';
        bundleDropdown.style.opacity = '0';
        bundleDropdown.style.visibility = 'hidden';
        selectBundleBtn.style.backgroundColor = 'transparent';
      } else {
        // Открываем дропдаун
        const scrollHeight = bundleDropdown.scrollHeight;
        bundleDropdown.style.maxHeight = scrollHeight + 'px';
        bundleDropdown.style.opacity = '1';
        bundleDropdown.style.visibility = 'visible';
        selectBundleBtn.style.backgroundColor = '#A9FA63';
      }
    }

    // Флаг для предотвращения двойного вызова (touchend + click на iOS)
    let isHandlingTouch = false;
    let lastTouchTime = 0;

    // Обработчик touchend для iOS
    const touchendHandler = function (e) {
      const now = Date.now();
      // Предотвращаем двойной вызов, если click уже обработал событие
      if (isHandlingTouch || (now - lastTouchTime) < 300) {
        return;
      }

      isHandlingTouch = true;
      lastTouchTime = now;

      // Не используем preventDefault, чтобы не блокировать нативные события
      e.stopPropagation();
      toggleBundleDropdown(e);

      // Сбрасываем флаг через небольшую задержку
      setTimeout(function () {
        isHandlingTouch = false;
      }, 300);
    };

    // Обработчик click (для десктопа и как fallback)
    const clickHandler = function (e) {
      // Если touchend уже обработал событие, игнорируем click
      if (isHandlingTouch) {
        e.stopPropagation();
        return;
      }
      toggleBundleDropdown(e);
    };

    // Добавляем обработчики для click и touchend (для iOS)
    selectBundleBtn.addEventListener('click', clickHandler, { passive: true });
    selectBundleBtn.addEventListener('touchend', touchendHandler, { passive: true });

    // Сохраняем ссылки для возможного удаления
    selectBundleBtn._clickHandler = clickHandler;
    selectBundleBtn._touchendHandler = touchendHandler;

    // Удаляем старый outside click handler, если он есть
    if (container._outsideClickHandler) {
      document.removeEventListener('click', container._outsideClickHandler, { passive: true });
    }

    // Закрываем дропдаун при клике вне его
    const outsideClickHandler = function (e) {
      if (!container.contains(e.target) && bundleDropdown.style.maxHeight !== '0px') {
        bundleDropdown.style.maxHeight = '0px';
        bundleDropdown.style.opacity = '0';
        bundleDropdown.style.visibility = 'hidden';
        selectBundleBtn.style.backgroundColor = 'transparent';
      }
    };
    document.addEventListener('click', outsideClickHandler, { passive: true });
    container._outsideClickHandler = outsideClickHandler;

    // Помечаем, что обработчик добавлен
    selectBundleBtn.dataset.handlerAdded = 'true';
  }

  /**
   * Устанавливает обработчики для дропдауна "Select Frequency" в закрытом модальном окне
   */
  function setupClosedModalFrequencyDropdownHandlers(container) {
    const selectFrequencyBtn = container.querySelector('[data-dropdown="frequency-closed"]');
    const frequencyDropdown = container.querySelector('.loop-closed-modal-frequency-dropdown');
    const wrapper = container.closest('.loop-closed-modal-dropdowns-wrapper');
    const bundleContainer = wrapper ? wrapper.querySelector('.loop-closed-modal-bundle-container') : null;
    const bundleDropdown = bundleContainer ? bundleContainer.querySelector('.loop-closed-modal-bundle-dropdown') : null;

    if (!selectFrequencyBtn || !frequencyDropdown) {
      return;
    }

    // Удаляем старые обработчики, если они есть
    if (selectFrequencyBtn._clickHandler) {
      selectFrequencyBtn.removeEventListener('click', selectFrequencyBtn._clickHandler, { passive: true });
    }
    if (selectFrequencyBtn._touchendHandler) {
      selectFrequencyBtn.removeEventListener('touchend', selectFrequencyBtn._touchendHandler, { passive: false });
    }

    // Функция для открытия/закрытия frequency dropdown
    function toggleFrequencyDropdown(e) {
      if (e) {
        // Не используем preventDefault, чтобы не блокировать нормальную работу на мобильных
        e.stopPropagation();
      }

      const isOpen = frequencyDropdown.style.maxHeight && frequencyDropdown.style.maxHeight !== '0px';

      // Закрываем bundle dropdown, если он открыт
      if (bundleDropdown && bundleDropdown.style.maxHeight && bundleDropdown.style.maxHeight !== '0px') {
        bundleDropdown.style.maxHeight = '0px';
        bundleDropdown.style.opacity = '0';
        bundleDropdown.style.visibility = 'hidden';
        const bundleBtn = bundleContainer.querySelector('[data-dropdown="bundle-closed"]');
        if (bundleBtn) {
          bundleBtn.style.backgroundColor = 'transparent';
        }
      }

      if (isOpen) {
        // Закрываем дропдаун
        frequencyDropdown.style.maxHeight = '0px';
        frequencyDropdown.style.opacity = '0';
        frequencyDropdown.style.visibility = 'hidden';
        selectFrequencyBtn.style.backgroundColor = 'transparent';
      } else {
        // Открываем дропдаун
        const scrollHeight = frequencyDropdown.scrollHeight;
        frequencyDropdown.style.maxHeight = scrollHeight + 'px';
        frequencyDropdown.style.opacity = '1';
        frequencyDropdown.style.visibility = 'visible';
        selectFrequencyBtn.style.backgroundColor = '#A9FA63';

        // Проверяем, есть ли уже выбранный interval button при открытии дропдауна
        const selectedIntervalButton = frequencyDropdown.querySelector('.loop-bundle-widget-frequency-interval-button.selected');
        if (selectedIntervalButton) {
          const buttonText = selectedIntervalButton.textContent.trim();
          // Записываем значение в sessionStorage
          sessionStorage.setItem('loop_selected_interval_button', buttonText);
          // При наличии selected interval button, автоматически записываем "Claim an extra 26%" в selling plan
          sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
        }
      }
    }

    // Флаг для предотвращения двойного вызова (touchend + click на iOS)
    let isHandlingTouch = false;
    let lastTouchTime = 0;

    // Обработчик touchend для iOS
    const touchendHandler = function (e) {
      const now = Date.now();
      // Предотвращаем двойной вызов, если click уже обработал событие
      if (isHandlingTouch || (now - lastTouchTime) < 300) {
        return;
      }

      isHandlingTouch = true;
      lastTouchTime = now;

      // Не используем preventDefault, чтобы не блокировать нативные события
      e.stopPropagation();
      toggleFrequencyDropdown(e);

      // Сбрасываем флаг через небольшую задержку
      setTimeout(function () {
        isHandlingTouch = false;
      }, 300);
    };

    // Обработчик click (для десктопа и как fallback)
    const clickHandler = function (e) {
      // Если touchend уже обработал событие, игнорируем click
      if (isHandlingTouch) {
        e.stopPropagation();
        return;
      }
      toggleFrequencyDropdown(e);
    };

    // Добавляем обработчики для click и touchend (для iOS)
    selectFrequencyBtn.addEventListener('click', clickHandler, { passive: true });
    selectFrequencyBtn.addEventListener('touchend', touchendHandler, { passive: true });

    // Сохраняем ссылки для возможного удаления
    selectFrequencyBtn._clickHandler = clickHandler;
    selectFrequencyBtn._touchendHandler = touchendHandler;

    // Удаляем старый outside click handler, если он есть
    if (container._outsideClickHandler) {
      document.removeEventListener('click', container._outsideClickHandler, { passive: true });
    }

    // Закрываем дропдаун при клике вне его
    const outsideClickHandler = function (e) {
      // Проверяем, не является ли клик внутри самого дропдауна (даже если вне container)
      const isClickInsideDropdown = frequencyDropdown.contains(e.target);

      // Проверяем, не является ли клик на selling plan container (особенно второй)
      const clickedSellingPlan = e.target.closest('.loop-bundle-widget-selling-plan-container');
      let isSecondPlanClick = false;
      if (clickedSellingPlan) {
        const allSellingPlans = frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');
        let clickedIndex = Array.from(allSellingPlans).indexOf(clickedSellingPlan);

        // Если не нашли по индексу (элемент был клонирован), ищем по тексту
        if (clickedIndex === -1 && allSellingPlans.length > 0) {
          const clickedText = clickedSellingPlan.textContent.trim();
          for (let i = 0; i < allSellingPlans.length; i++) {
            if (allSellingPlans[i].textContent.trim() === clickedText) {
              clickedIndex = i;
              break;
            }
          }
        }

        isSecondPlanClick = clickedIndex === 1;
      }

      // Не закрываем, если:
      // 1. Клик внутри container
      // 2. Клик внутри dropdown
      // 3. Клик на второй selling plan (даже если он не внутри dropdown из-за клонирования)
      if (!container.contains(e.target) && !isClickInsideDropdown && !isSecondPlanClick && frequencyDropdown.style.maxHeight !== '0px') {

        frequencyDropdown.style.maxHeight = '0px';
        frequencyDropdown.style.opacity = '0';
        frequencyDropdown.style.visibility = 'hidden';
        selectFrequencyBtn.style.backgroundColor = 'transparent';
      }
    };
    document.addEventListener('click', outsideClickHandler, { passive: true });
    container._outsideClickHandler = outsideClickHandler;
  }

  /**
   * Синхронизирует цены loop-discounted-price из loop-products-align-new 
   * в соответствующие продукты в модале корзины (только для мобильной версии)
   */
  function syncPricesFromProductsAlignToModal() {
    // Проверяем, что это мобильная версия (1023px и меньше)
    if (window.innerWidth > 1023) {
      return;
    }

    try {
      // Находим контейнер loop-products-align-new
      const productsAlignNew = document.querySelector('.loop-products-align-new');
      if (!productsAlignNew) {
        return;
      }

      // Находим все loop-discounted-price в loop-products-align-new
      const productsAlignPrices = productsAlignNew.querySelectorAll('.loop-discounted-price');
      if (productsAlignPrices.length === 0) {
        return;
      }

      // Находим контейнер с товарами в модале
      let productsList = document.querySelector('.bottom-sheet-products-list');
      if (!productsList) {
        productsList = document.querySelector('.loop-bottom-sheet-products-list');
      }
      if (!productsList) {
        productsList = document.querySelector('.loop-bottom-sheet-products-inner-container');
      }
      if (!productsList) {
        productsList = document.querySelector('.loop-bottom-sheet-body-products-container-expanded');
      }
      if (!productsList) {
        return;
      }

      // Находим все элементы loop-discounted-price в модале
      const modalPrices = productsList.querySelectorAll('.loop-discounted-price');
      if (modalPrices.length === 0) {
        return;
      }

      // Функция для поиска ближайшего родителя с data-variant-id
      function findParentWithVariantId(element) {
        let current = element;
        while (current && current !== document.body) {
          if (current.hasAttribute && current.hasAttribute('data-variant-id')) {
            return current.getAttribute('data-variant-id');
          }
          current = current.parentElement;
        }
        return null;
      }

      // Создаем карту цен из loop-products-align-new по data-variant-id
      const pricesMap = {};
      productsAlignPrices.forEach(function (productsAlignPrice) {
        const variantId = findParentWithVariantId(productsAlignPrice);
        if (variantId && productsAlignPrice.textContent.trim()) {
          pricesMap[variantId] = productsAlignPrice.textContent.trim();
        }
      });

      // Синхронизируем цены по data-variant-id
      modalPrices.forEach(function (modalPrice) {
        const variantId = findParentWithVariantId(modalPrice);
        if (variantId && pricesMap[variantId]) {
          modalPrice.textContent = pricesMap[variantId];
        }
      });
    } catch (e) {
      // Игнорируем ошибки синхронизации
    }
  }

  /**
   * Запускает синхронизацию цен через 500мс после клика (только если модал открыт и клик в purchase options)
   */
  function triggerPriceSyncAfterClick() {
    // Проверяем, открыт ли модал
    const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
    const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');
    if (!isExpanded) {
      return;
    }

    // Проверяем, что это мобильная версия (1023px и меньше)
    if (window.innerWidth > 1023) {
      return;
    }

    // Очищаем предыдущий таймер, если он есть
    if (window.__priceSyncClickTimeout) {
      clearTimeout(window.__priceSyncClickTimeout);
    }

    // Запускаем синхронизацию через 500мс
    window.__priceSyncClickTimeout = setTimeout(function () {
      syncPricesFromProductsAlignToModal();
      window.__priceSyncClickTimeout = null;
    }, 500);
  }

  /**
   * Перестановка #19: Создать мобильные дропдауны для Select Bundle и Select Frequency
   */
  function createMobilePurchaseOptionsDropdowns() {
    const purchaseOptionsContainer = document.querySelector('.loop-bottom-sheet-purchase-options-container');
    if (!purchaseOptionsContainer) {
      return;
    }

    // Проверяем, не применена ли уже перестройка (чтобы избежать множественных вызовов)
    if (purchaseOptionsContainer.hasAttribute('data-mobile-dropdowns-applied')) {
      // Проверяем, что структура все еще правильная
      const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
      const widgetContainer = purchaseOptionsContainer.querySelector('.loop-bundle-widget-container');
      const frequencyContainer = wrapper ? wrapper.querySelector('.loop-mobile-frequency-container') : null;

      // Если widgetContainer не находится в frequencyContainer, нужно перестроить
      if (widgetContainer && frequencyContainer && !frequencyContainer.contains(widgetContainer)) {
        // Сбрасываем флаг и продолжаем перестройку
        purchaseOptionsContainer.removeAttribute('data-mobile-dropdowns-applied');
      } else if (wrapper && frequencyContainer && (!widgetContainer || frequencyContainer.contains(widgetContainer))) {
        // Структура правильная, просто обновляем обработчики событий
        setupMobileDropdownHandlers(purchaseOptionsContainer);
        return;
      }
    }

    // Всегда проверяем и исправляем структуру, даже если элементы уже существуют
    let wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
    if (!wrapper) {
      // Создаем wrapper
      wrapper = document.createElement('div');
      wrapper.className = 'loop-bottom-sheet-purchase-options-wrapper';
      wrapper.style.display = 'flex';
      wrapper.style.gap = '15px';
      wrapper.style.width = '100%';
      wrapper.style.flexWrap = 'wrap';

      // Вставляем wrapper в начало контейнера
      if (purchaseOptionsContainer.firstChild) {
        purchaseOptionsContainer.insertBefore(wrapper, purchaseOptionsContainer.firstChild);
      } else {
        purchaseOptionsContainer.appendChild(wrapper);
      }
    } else {
      // Если wrapper уже существует, убеждаемся, что он находится в правильном месте
      // Если он не первый дочерний элемент, перемещаем его
      if (purchaseOptionsContainer.firstChild !== wrapper) {
        purchaseOptionsContainer.insertBefore(wrapper, purchaseOptionsContainer.firstChild);
      }
    }

    // Создаем контейнер для кнопки Bundle и ее дропдауна
    let bundleContainer = wrapper.querySelector('.loop-mobile-bundle-container');
    if (!bundleContainer) {
      bundleContainer = document.createElement('div');
      bundleContainer.className = 'loop-mobile-bundle-container';
      bundleContainer.style.cssText = `
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        position: relative;
      `;
      wrapper.appendChild(bundleContainer);
    }

    // Создаем кнопку "Select Bundle"
    let selectBundleBtn = bundleContainer.querySelector('[data-dropdown="bundle"]');
    if (!selectBundleBtn) {
      selectBundleBtn = document.createElement('button');
      selectBundleBtn.className = 'loop-mobile-dropdown-btn';
      selectBundleBtn.setAttribute('data-dropdown', 'bundle');
      selectBundleBtn.textContent = 'Select Bundle';
      selectBundleBtn.style.cssText = `
        width: 100%;
        height: 40px;
        padding: 10px 11px;
        color: #000;
        border: 2px solid #A9FA63;
        border-radius: 10px;
        font-weight: 700;
        cursor: pointer;
        transition: background-color 0.2s;
        line-height: 1;
      `;
      bundleContainer.appendChild(selectBundleBtn);
    }

    // Создаем контейнер для кнопки Frequency и ее дропдауна
    let frequencyContainer = wrapper.querySelector('.loop-mobile-frequency-container');
    if (!frequencyContainer) {
      frequencyContainer = document.createElement('div');
      frequencyContainer.className = 'loop-mobile-frequency-container';
      frequencyContainer.style.cssText = `
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        position: relative;
      `;
      wrapper.appendChild(frequencyContainer);
    } else {
      // Убеждаемся, что position: relative установлен
      if (getComputedStyle(frequencyContainer).position === 'static') {
        frequencyContainer.style.position = 'relative';
      }
    }

    // Создаем кнопку "Select Frequency"
    let selectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency"]');
    if (!selectFrequencyBtn) {
      selectFrequencyBtn = document.createElement('button');
      selectFrequencyBtn.className = 'loop-mobile-dropdown-btn';
      selectFrequencyBtn.setAttribute('data-dropdown', 'frequency');
      selectFrequencyBtn.textContent = 'Select Frequency';
      selectFrequencyBtn.style.cssText = `
        width: 100%;
        height: 40px;
        padding: 10px 11px;
        color: #000;
        border: 2px solid #A9FA63;
        border-radius: 10px;
        font-weight: 700;
        cursor: pointer;
        transition: background-color 0.2s;
        line-height: 1;
      `;
      frequencyContainer.appendChild(selectFrequencyBtn);
    }

    // Находим или создаем дропдаун для Bundle
    let bundleDropdown = bundleContainer.querySelector('.loop-mobile-bundle-dropdown');
    if (!bundleDropdown) {
      // Ищем оригинальный элемент loop-bundle-size-selector-new-wrapper
      const originalSizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
      if (originalSizeSelector) {
        // Клонируем элемент
        bundleDropdown = originalSizeSelector.cloneNode(true);
        bundleDropdown.classList.add('loop-mobile-bundle-dropdown');
        bundleDropdown.style.cssText = `
          width: 100%;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
          margin-top: 10px;
          margin-left: 0px;
          opacity: 0;
          visibility: hidden;
          border: 2px solid #A9FA63;
          border-radius: 10px;
          background-color: #fff;
          padding-top: 7px !important;
          display: block !important;
          position: absolute;
          top: 35px;
        `;
        bundleContainer.appendChild(bundleDropdown);

        // Добавляем обработчики кликов для кнопок размера в клонированном дропдауне
        const bundleSizeButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
        bundleSizeButtons.forEach(function (clonedButton) {
          // Проверяем, не добавлен ли уже обработчик
          if (clonedButton.dataset.clickHandlerAdded) {
            return;
          }
          clonedButton.dataset.clickHandlerAdded = 'true';

          // Получаем текст кнопки для поиска соответствующей кнопки в оригинале
          const buttonText = clonedButton.textContent.trim();

          clonedButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Проверяем, находится ли клик внутри loop-bottom-sheet-purchase-options-wrapper
            const purchaseOptionsWrapper = clonedButton.closest('.loop-bottom-sheet-purchase-options-wrapper');
            if (purchaseOptionsWrapper) {
              // Запускаем синхронизацию цен через 500мс
              triggerPriceSyncAfterClick();
            }

            // Находим соответствующую кнопку в оригинальном селекторе
            const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
            originalButtons.forEach(function (originalButton) {
              if (originalButton.textContent.trim() === buttonText) {
                // Устанавливаем флаг, чтобы предотвратить синхронизацию через observer во время ручного обновления
                bundleDropdown.dataset.manualSyncInProgress = 'true';

                // Сначала обновляем классы на оригинальных кнопках СРАЗУ
                const allOriginalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
                allOriginalButtons.forEach(function (btn) {
                  if (btn.textContent.trim() === buttonText) {
                    btn.classList.add('loop-btn-selected');
                  } else {
                    btn.classList.remove('loop-btn-selected');
                  }
                });

                // Затем обновляем классы на клонированных кнопках СРАЗУ
                const allClonedButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
                allClonedButtons.forEach(function (btn) {
                  if (btn.textContent.trim() === buttonText) {
                    btn.classList.add('loop-btn-selected');
                  } else {
                    btn.classList.remove('loop-btn-selected');
                  }
                });

                // Кликаем по оригинальной кнопке для триггера других обработчиков
                originalButton.click();

                // Обновляем текст кнопки после выбора
                updateBundleButtonText(buttonText);

                // Снимаем флаг после небольшой задержки, чтобы observer мог снова работать
                setTimeout(function () {
                  bundleDropdown.dataset.manualSyncInProgress = 'false';
                }, 150);

                // Закрываем дропдаун после клика
                const selectBundleBtn = bundleContainer.querySelector('[data-dropdown="bundle"]');
                if (selectBundleBtn && bundleDropdown) {
                  bundleDropdown.style.maxHeight = '0px';
                  bundleDropdown.style.opacity = '0';
                  bundleDropdown.style.visibility = 'hidden';
                  selectBundleBtn.style.backgroundColor = 'transparent';
                }
              }
            });
          });
        });

        // Синхронизируем начальное состояние классов
        syncBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);

        // Наблюдаем за изменениями классов на оригинальных кнопках
        observeBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);
      }
    } else if (bundleDropdown) {
      // Если bundleDropdown уже существует, все равно синхронизируем классы и добавляем обработчики
      const originalSizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
      if (originalSizeSelector) {
        // Находим bundleContainer для закрытия дропдауна
        const bundleContainerForClose = bundleDropdown.closest('.loop-mobile-bundle-container');

        // Добавляем обработчики кликов для кнопок размера в существующем дропдауне
        const bundleSizeButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
        bundleSizeButtons.forEach(function (clonedButton) {
          // Проверяем, не добавлен ли уже обработчик
          if (clonedButton.dataset.clickHandlerAdded) {
            return;
          }
          clonedButton.dataset.clickHandlerAdded = 'true';

          // Получаем текст кнопки для поиска соответствующей кнопки в оригинале
          const buttonText = clonedButton.textContent.trim();

          clonedButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Находим соответствующую кнопку в оригинальном селекторе
            const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
            originalButtons.forEach(function (originalButton) {
              if (originalButton.textContent.trim() === buttonText) {
                // Устанавливаем флаг, чтобы предотвратить синхронизацию через observer во время ручного обновления
                bundleDropdown.dataset.manualSyncInProgress = 'true';

                // Сначала обновляем классы на оригинальных кнопках СРАЗУ
                const allOriginalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
                allOriginalButtons.forEach(function (btn) {
                  if (btn.textContent.trim() === buttonText) {
                    btn.classList.add('loop-btn-selected');
                  } else {
                    btn.classList.remove('loop-btn-selected');
                  }
                });

                // Затем обновляем классы на клонированных кнопках СРАЗУ
                const allClonedButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');
                allClonedButtons.forEach(function (btn) {
                  if (btn.textContent.trim() === buttonText) {
                    btn.classList.add('loop-btn-selected');
                  } else {
                    btn.classList.remove('loop-btn-selected');
                  }
                });

                // Кликаем по оригинальной кнопке для триггера других обработчиков
                originalButton.click();

                // Обновляем текст кнопки после выбора
                updateBundleButtonText(buttonText);

                // Снимаем флаг после небольшой задержки, чтобы observer мог снова работать
                setTimeout(function () {
                  bundleDropdown.dataset.manualSyncInProgress = 'false';
                }, 150);

                // Закрываем дропдаун после клика
                const selectBundleBtn = bundleContainerForClose ? bundleContainerForClose.querySelector('[data-dropdown="bundle"]') : null;
                if (selectBundleBtn && bundleDropdown) {
                  bundleDropdown.style.maxHeight = '0px';
                  bundleDropdown.style.opacity = '0';
                  bundleDropdown.style.visibility = 'hidden';
                  selectBundleBtn.style.backgroundColor = 'transparent';
                }
              }
            });
          });
        });

        syncBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);
        observeBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);
      }
    }

    // Находим или перемещаем дропдаун для Frequency
    let frequencyDropdown = frequencyContainer.querySelector('.loop-mobile-frequency-dropdown');
    let widgetContainer = purchaseOptionsContainer.querySelector('.loop-bundle-widget-container');

    // Если widgetContainer не найден в purchaseOptionsContainer, ищем его везде
    if (!widgetContainer) {
      widgetContainer = document.querySelector('.loop-bundle-widget-container');
    }

    // Если widgetContainer существует, но не находится в frequencyContainer, перемещаем его
    if (widgetContainer) {
      // Проверяем, находится ли widgetContainer уже в frequencyContainer
      if (!frequencyContainer.contains(widgetContainer)) {
        // Если widgetContainer уже имеет класс loop-mobile-frequency-dropdown, но находится не в frequencyContainer,
        // значит он был перемещен обратно - перемещаем его снова
        // Удаляем из старого места перед перемещением
        if (widgetContainer.parentNode) {
          try {
            widgetContainer.parentNode.removeChild(widgetContainer);
          } catch (e) {
            // Игнорируем ошибки при удалении
          }
        }

        // Перемещаем widgetContainer в frequencyContainer
        frequencyDropdown = widgetContainer;
        frequencyDropdown.classList.add('loop-mobile-frequency-dropdown');
        frequencyDropdown.style.cssText = `
          width: 100%;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
          margin-top: 10px;
          padding-top: 7px;
          position: absolute;
          top: 35px;
          left: 0;
          z-index: 1000;
          background-color: #fff;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          opacity: 0;
          visibility: hidden;
          border: 2px solid #A9FA63;
        `;
        frequencyContainer.appendChild(frequencyDropdown);

        // Добавляем текст над содержимым дропдауна
        addFrequencyDropdownText(frequencyDropdown);

        // Восстанавливаем сохраненное состояние из sessionStorage
        // Устанавливаем флаг сразу, чтобы предотвратить сохранение дефолтного состояния
        window.__restoringFrequencySelection = true;
        setTimeout(function () {
          restoreFrequencySelectionFromSessionStorage(frequencyDropdown);
        }, 200);
      } else {
        // Уже находится в frequencyContainer, просто обновляем стили
        frequencyDropdown = widgetContainer;
        if (!frequencyDropdown.classList.contains('loop-mobile-frequency-dropdown')) {
          frequencyDropdown.classList.add('loop-mobile-frequency-dropdown');
        }
        frequencyDropdown.style.cssText = `
          width: 100%;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
          margin-top: 10px;
          padding-top: 7px;
          position: absolute;
          top: 35px;
          left: 0;
          z-index: 1000;
          background-color: #fff;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          opacity: 0;
          visibility: hidden;
          border: 2px solid #A9FA63;
        `;

        // Добавляем текст над содержимым дропдауна, если его еще нет
        addFrequencyDropdownText(frequencyDropdown);

        // Восстанавливаем сохраненное состояние из sessionStorage
        // Устанавливаем флаг сразу, чтобы предотвратить сохранение дефолтного состояния
        window.__restoringFrequencySelection = true;
        setTimeout(function () {
          restoreFrequencySelectionFromSessionStorage(frequencyDropdown);
        }, 200);
      }
    } else {
      // Если widgetContainer не найден, но frequencyDropdown существует, проверяем его
      if (frequencyDropdown && !frequencyContainer.contains(frequencyDropdown)) {
        // frequencyDropdown существует, но не в правильном месте - перемещаем его
        if (frequencyDropdown.parentNode) {
          try {
            frequencyDropdown.parentNode.removeChild(frequencyDropdown);
          } catch (e) {
            // Игнорируем ошибки
          }
        }
        frequencyContainer.appendChild(frequencyDropdown);

        // Добавляем текст над содержимым дропдауна
        addFrequencyDropdownText(frequencyDropdown);

        // Восстанавливаем сохраненное состояние из sessionStorage
        // Устанавливаем флаг сразу, чтобы предотвратить сохранение дефолтного состояния
        window.__restoringFrequencySelection = true;
        setTimeout(function () {
          restoreFrequencySelectionFromSessionStorage(frequencyDropdown);
        }, 200);
      }
    }

    // Устанавливаем обработчики
    setupMobileDropdownHandlers(purchaseOptionsContainer);

    // Восстанавливаем текст кнопок на основе текущего выбора
    setTimeout(function () {
      restoreButtonTexts();
    }, 100);

    // Настраиваем отслеживание изменений состояния frequency
    // Задержка нужна, чтобы восстановление успело произойти до начала отслеживания
    setTimeout(function () {
      setupFrequencySelectionTracking();
    }, 50);

    // Помечаем контейнер как обработанный
    purchaseOptionsContainer.setAttribute('data-mobile-dropdowns-applied', 'true');
  }

  /**
   * Синхронизирует классы loop-btn-selected между оригинальными и клонированными кнопками размера бандла
   */
  function syncBundleSizeButtonClasses(originalSizeSelector, bundleDropdown) {
    if (!originalSizeSelector || !bundleDropdown) {
      return;
    }

    const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');
    const clonedButtons = bundleDropdown.querySelectorAll('.loop-bundle-size-selector-btn');

    originalButtons.forEach(function (originalButton) {
      const buttonText = originalButton.textContent.trim();
      const isSelected = originalButton.classList.contains('loop-btn-selected');

      // Находим соответствующую клонированную кнопку
      clonedButtons.forEach(function (clonedButton) {
        if (clonedButton.textContent.trim() === buttonText) {
          if (isSelected) {
            clonedButton.classList.add('loop-btn-selected');
          } else {
            clonedButton.classList.remove('loop-btn-selected');
          }
        }
      });
    });
  }

  /**
   * Наблюдает за изменениями классов на оригинальных кнопках размера бандла и синхронизирует их с клонированными
   */
  function observeBundleSizeButtonClasses(originalSizeSelector, bundleDropdown) {
    if (!originalSizeSelector || !bundleDropdown) {
      return;
    }

    const originalButtons = originalSizeSelector.querySelectorAll('.loop-bundle-size-selector-btn');

    originalButtons.forEach(function (originalButton) {
      // Проверяем, не добавлен ли уже observer для этой кнопки
      if (originalButton.dataset.observerAdded) {
        return;
      }
      originalButton.dataset.observerAdded = 'true';

      // Создаем MutationObserver для отслеживания изменений классов
      let syncTimeout = null;
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Пропускаем синхронизацию, если классы обновляются вручную через флаг
            if (bundleDropdown.dataset.manualSyncInProgress === 'true') {
              return;
            }
            // Используем debounce, чтобы не перезаписывать классы, установленные вручную при клике
            if (syncTimeout) {
              clearTimeout(syncTimeout);
            }
            syncTimeout = setTimeout(function () {
              syncBundleSizeButtonClasses(originalSizeSelector, bundleDropdown);
            }, 100);
          }
        });
      });

      // Начинаем наблюдение за изменениями атрибутов
      observer.observe(originalButton, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  /**
   * Обрезает текст до указанной длины и добавляет "..."
   */
  // function truncateText(text, maxLength) {
  //   if (!text || text.length <= maxLength) {
  //     return text;
  //   }
  //   return text.substring(0, maxLength) + '...';
  // }

  /**
   * Обновляет текст кнопки Bundle в обоих контейнерах
   */
  function updateBundleButtonText(selectedText) {
    // const truncatedText = truncateText(selectedText, 25);

    // Обновляем в loop-closed-modal-dropdowns-wrapper
    const closedModalWrapper = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
    if (closedModalWrapper) {
      const bundleContainer = closedModalWrapper.querySelector('.loop-closed-modal-bundle-container');
      if (bundleContainer) {
        const bundleBtn = bundleContainer.querySelector('[data-dropdown="bundle-closed"]');
        if (bundleBtn) {
          // bundleBtn.textContent = truncatedText;
          bundleBtn.textContent = selectedText;
        }
      }
    }

    // Обновляем в loop-bottom-sheet-purchase-options-container
    const purchaseOptionsContainer = document.querySelector('.loop-bottom-sheet-purchase-options-container');
    if (purchaseOptionsContainer) {
      const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
      if (wrapper) {
        const bundleContainer = wrapper.querySelector('.loop-mobile-bundle-container');
        if (bundleContainer) {
          const bundleBtn = bundleContainer.querySelector('[data-dropdown="bundle"]');
          if (bundleBtn) {
            // frequencyBtn.textContent = truncatedText;
            bundleBtn.textContent = selectedText;
          }
        }
      }
    }
  }

  /**
   * Обновляет текст кнопки Frequency в обоих контейнерах
   */
  function updateFrequencyButtonText(selectedText) {
    // const truncatedText = truncateText(selectedText, 25);

    // Обновляем в loop-closed-modal-dropdowns-wrapper
    const closedModalWrapper = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
    if (closedModalWrapper) {
      const frequencyContainer = closedModalWrapper.querySelector('.loop-closed-modal-frequency-container');
      if (frequencyContainer) {
        const frequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency-closed"]');
        if (frequencyBtn) {
            // frequencyBtn.textContent = truncatedText;
            frequencyBtn.textContent = selectedText;
        }
      }
    }

    // Обновляем в loop-bottom-sheet-purchase-options-container
    const purchaseOptionsContainer = document.querySelector('.loop-bottom-sheet-purchase-options-container');
    if (purchaseOptionsContainer) {
      const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
      if (wrapper) {
        const frequencyContainer = wrapper.querySelector('.loop-mobile-frequency-container');
        if (frequencyContainer) {
          const frequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency"]');
          if (frequencyBtn) {
            // frequencyBtn.textContent = truncatedText;
            frequencyBtn.textContent = selectedText;
          }
        }
      }
    }
  }

  /**
   * Восстанавливает текст кнопок на основе текущего выбора
   */
  function restoreButtonTexts() {
    // Восстанавливаем текст кнопки Bundle
    const originalSizeSelector = document.querySelector('.loop-bundle-size-selector-new-wrapper');
    if (originalSizeSelector) {
      const selectedBundleBtn = originalSizeSelector.querySelector('.loop-bundle-size-selector-btn.loop-btn-selected');
      if (selectedBundleBtn) {
        const selectedText = selectedBundleBtn.textContent.trim();
        updateBundleButtonText(selectedText);
      }
    }

    // Восстанавливаем текст кнопки Frequency
    const selectedIntervalButton = document.querySelector('.loop-bundle-widget-frequency-interval-button.selected');
    const selectedSellingPlan = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');

    if (selectedIntervalButton) {
      const intervalText = selectedIntervalButton.textContent.trim();
      updateFrequencyButtonText(intervalText);
    } else if (selectedSellingPlan) {
      // Проверяем, является ли это "One Time Purchase" (первый элемент в frequency-button-container)
      const frequencyButtonContainer = selectedSellingPlan.closest('.loop-bundle-widget-frequency-button-container');
      if (frequencyButtonContainer) {
        const allSellingPlans = frequencyButtonContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
        const isFirstPlan = allSellingPlans.length > 0 && allSellingPlans[0] === selectedSellingPlan;
        if (isFirstPlan) {
          const sellingPlanText = selectedSellingPlan.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
          updateFrequencyButtonText(sellingPlanText);
        }
      } else {
        const sellingPlanText = selectedSellingPlan.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
        updateFrequencyButtonText(sellingPlanText);
      }
    } else {
      // Если ничего не выбрано, ищем опцию по умолчанию (первый interval button - "Deliver every 1...")
      const firstIntervalButton = document.querySelector('.loop-bundle-widget-frequency-interval-button');
      if (firstIntervalButton) {
        const firstIntervalText = firstIntervalButton.textContent.trim();
        updateFrequencyButtonText(firstIntervalText);
      } else {
        // Если interval button не найден, используем первый selling plan
        const firstSellingPlan = document.querySelector('.loop-bundle-widget-selling-plan-container');
        if (firstSellingPlan) {
          const firstPlanText = firstSellingPlan.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
          updateFrequencyButtonText(firstPlanText);
        }
      }
    }
  }

  /**
   * Сохраняет текущее выбранное состояние frequency в sessionStorage
   */
  function saveFrequencySelectionToSessionStorage() {
    // Не сохраняем, если идет процесс восстановления
    if (window.__restoringFrequencySelection) {
      return;
    }

    try {
      const selectedSellingPlan = document.querySelector('.loop-bundle-widget-selling-plan-container.selected');
      const selectedIntervalButton = document.querySelector('.loop-bundle-widget-frequency-interval-button.selected');

      // Проверяем, есть ли уже сохраненное состояние в sessionStorage
      const savedPlanText = sessionStorage.getItem('loop_selected_selling_plan');
      const savedButtonText = sessionStorage.getItem('loop_selected_interval_button');

      // Если есть сохраненное состояние, но мы еще не восстановили его (флаг не установлен),
      // и текущее состояние - дефолтное, не сохраняем его
      if (savedPlanText || savedButtonText) {
        // Проверяем, является ли текущее состояние дефолтным
        const isDefaultPlan = selectedSellingPlan && (
          selectedSellingPlan.textContent.trim().includes('Claim an extra 26%') ||
          selectedSellingPlan.textContent.trim().includes('Save 30%')
        );
        const isDefaultButton = selectedIntervalButton && (
          selectedIntervalButton.textContent.trim().includes('Deliver every 1 week')
        );

        // Если текущее состояние дефолтное, а в sessionStorage есть сохраненное, не перезаписываем
        if ((isDefaultPlan && savedPlanText && selectedSellingPlan.textContent.trim() !== savedPlanText) ||
          (isDefaultButton && savedButtonText && selectedIntervalButton.textContent.trim() !== savedButtonText)) {
          return;
        }
      }

      if (selectedSellingPlan) {
        const planText = selectedSellingPlan.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
        sessionStorage.setItem('loop_selected_selling_plan', planText);
      }

      if (selectedIntervalButton) {
        const buttonText = selectedIntervalButton.textContent.trim();
        sessionStorage.setItem('loop_selected_interval_button', buttonText);

        // При сохранении interval button, автоматически сохраняем "Claim an extra 26%" в selling plan
        sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
      }
    } catch (e) {
      console.warn('[custom.js] Ошибка при сохранении состояния frequency в sessionStorage:', e);
    }
  }

  /**
   * Восстанавливает состояние frequency из sessionStorage
   */
  function restoreFrequencySelectionFromSessionStorage(widgetContainer) {
    if (!widgetContainer) {
      return false;
    }

    try {
      let restored = false;

      // Восстанавливаем selling plan
      const savedPlanText = sessionStorage.getItem('loop_selected_selling_plan');
      const isOneTimePurchase = savedPlanText && savedPlanText.includes('One Time Purchase');
      let sellingPlanFound = false;

      if (savedPlanText) {
        const sellingPlans = widgetContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
        sellingPlans.forEach(function (plan) {
          const planText = plan.textContent.trim();
          // Используем более гибкое сравнение для "Claim an extra 26%"
          const isMatch = planText === savedPlanText ||
            (savedPlanText.includes('Claim an extra') && planText.includes('Claim an extra')) ||
            (savedPlanText.includes('One Time Purchase') && planText.includes('One Time Purchase'));

          if (isMatch) {
            plan.classList.add('selected');
            // Убираем selected у других
            sellingPlans.forEach(function (otherPlan) {
              if (otherPlan !== plan) {
                otherPlan.classList.remove('selected');
              }
            });
            // Кликаем по элементу, чтобы Loop обновил свое внутреннее состояние
            setTimeout(function () {
              plan.click();
            }, 50);
            restored = true;
            sellingPlanFound = true;
          } else if (!isOneTimePurchase) {
            // Удаляем selected только если это не "One Time Purchase"
            // Если "One Time Purchase" не найден, не трогаем другие планы
            plan.classList.remove('selected');
          }
        });
      }

      // Если выбран "One Time Purchase", убираем selected у всех interval buttons
      if (isOneTimePurchase) {
        const intervalButtons = widgetContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
        intervalButtons.forEach(function (button) {
          button.classList.remove('selected');
        });
      }

      // Восстанавливаем interval button только если:
      // 1. Не выбран "One Time Purchase"
      // 2. И если selling plan найден, то он должен быть "Claim an extra 26%" (совместим с interval button)
      // 3. Или selling plan не найден, но есть interval button (возможно, был выбран только interval button)
      const savedButtonText = sessionStorage.getItem('loop_selected_interval_button');
      const isClaimExtra = savedPlanText && savedPlanText.includes('Claim an extra');
      // Восстанавливаем interval button если:
      // - Не "One Time Purchase" И
      // - (selling plan не найден ИЛИ это "Claim an extra 26%")
      if (savedButtonText && !isOneTimePurchase && (!sellingPlanFound || (sellingPlanFound && isClaimExtra))) {
        const intervalButtons = widgetContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
        intervalButtons.forEach(function (button) {
          const buttonText = button.textContent.trim();
          if (buttonText === savedButtonText) {
            button.classList.add('selected');
            // Убираем selected у других
            intervalButtons.forEach(function (otherButton) {
              if (otherButton !== button) {
                otherButton.classList.remove('selected');
              }
            });
            // Кликаем по кнопке, чтобы Loop обновил свое внутреннее состояние
            setTimeout(function () {
              button.click();
            }, 50);
            restored = true;
          } else {
            button.classList.remove('selected');
          }
        });
      }

      // Снимаем флаг после небольшой задержки, чтобы дать время всем событиям обработаться
      setTimeout(function () {
        window.__restoringFrequencySelection = false;
      }, 500);

      return restored;
    } catch (e) {
      console.warn('[custom.js] Ошибка при восстановлении состояния frequency из sessionStorage:', e);
      window.__restoringFrequencySelection = false;
      return false;
    }
  }

  /**
   * Настраивает отслеживание изменений состояния frequency для сохранения в sessionStorage
   */
  function setupFrequencySelectionTracking() {
    // Проверяем, не настроено ли уже отслеживание
    if (window.__frequencySelectionTrackingSetup) {
      return;
    }
    window.__frequencySelectionTrackingSetup = true;

    // Функция для сохранения состояния
    function saveState() {
      saveFrequencySelectionToSessionStorage();
    }

    // Отслеживаем клики на selling plan containers
    document.addEventListener('click', function (e) {
      // Не сохраняем, если идет процесс восстановления
      if (window.__restoringFrequencySelection) {
        return;
      }

      const sellingPlan = e.target.closest('.loop-bundle-widget-selling-plan-container');
      if (sellingPlan) {
        setTimeout(saveState, 100);

        // Проверяем, является ли это второй элемент (индекс 1)
        // Ищем все selling plans в том же контейнере, где находится кликнутый элемент
        const sellingPlanParentContainer = sellingPlan.closest('.loop-bundle-widget-frequency-button-container') ||
          sellingPlan.closest('.loop-bundle-widget-container');
        const allSellingPlans = sellingPlanParentContainer ? sellingPlanParentContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container') : [];
        const clickedIndex = Array.from(allSellingPlans).indexOf(sellingPlan);
        const isSecondPlan = clickedIndex === 1;

        // Если это второй элемент, используем текст первого interval button
        if (isSecondPlan) {
          const firstIntervalButton = sellingPlanParentContainer ? sellingPlanParentContainer.querySelector('.loop-bundle-widget-frequency-interval-button') :
            document.querySelector('.loop-bundle-widget-frequency-interval-button');
          if (firstIntervalButton) {
            const intervalText = firstIntervalButton.textContent.trim();
            updateFrequencyButtonText(intervalText);
          }
        } else {
          // Обновляем текст кнопки Frequency после выбора
          const planText = sellingPlan.querySelector('.loop-bundle-widget-selling-plan-text').textContent.trim();
          updateFrequencyButtonText(planText);
        }

        // Проверяем, находится ли клик внутри loop-bottom-sheet-purchase-options-wrapper
        const purchaseOptionsWrapper = sellingPlan.closest('.loop-bottom-sheet-purchase-options-wrapper');
        if (purchaseOptionsWrapper) {
          // Запускаем синхронизацию цен через 500мс
          triggerPriceSyncAfterClick();
        }

        // Проверяем, находится ли selling plan внутри frequency-button-container (One Time Purchase)
        const frequencyButtonContainer = sellingPlan.closest('.loop-bundle-widget-frequency-button-container');
        if (frequencyButtonContainer) {
          // Проверяем, что это первый элемент (One Time Purchase), а не второй (Claim an extra 26%)
          // Находим все selling plan containers внутри frequency-button-container
          const allSellingPlans = frequencyButtonContainer.querySelectorAll('.loop-bundle-widget-selling-plan-container');
          const isFirstElement = allSellingPlans.length > 0 && allSellingPlans[0] === sellingPlan;

          // Закрываем дропдаун только если это первый элемент (One Time Purchase)
          if (isFirstElement) {
            // Закрываем frequency dropdown в expanded modal после выбора
            const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
            const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');
            if (isExpanded) {
              const purchaseOptionsContainer = document.querySelector('.loop-bottom-sheet-purchase-options-container');
              if (purchaseOptionsContainer) {
                const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
                if (wrapper) {
                  const frequencyContainer = wrapper.querySelector('.loop-mobile-frequency-container');
                  const frequencyDropdown = frequencyContainer ? frequencyContainer.querySelector('.loop-mobile-frequency-dropdown') : null;
                  const selectFrequencyBtn = frequencyContainer ? frequencyContainer.querySelector('[data-dropdown="frequency"]') : null;

                  if (frequencyDropdown && selectFrequencyBtn && frequencyDropdown.style.maxHeight && frequencyDropdown.style.maxHeight !== '0px') {
                    // Сразу закрываем дропдаун
                    frequencyDropdown.style.maxHeight = '0px';
                    frequencyDropdown.style.opacity = '0';
                    frequencyDropdown.style.visibility = 'hidden';
                    selectFrequencyBtn.style.backgroundColor = 'transparent';
                    // Убираем z-index при закрытии
                    if (frequencyDropdown.classList.contains('loop-mobile-frequency-dropdown')) {
                      frequencyDropdown.style.zIndex = '1000';
                    }
                  }
                }
              }
            }
          }
        }
      }

      const intervalButton = e.target.closest('.loop-bundle-widget-frequency-interval-button');
      if (intervalButton) {
        setTimeout(saveState, 100);

        // Обновляем текст кнопки Frequency после выбора
        const intervalText = intervalButton.textContent.trim();
        updateFrequencyButtonText(intervalText);

        // Проверяем, находится ли клик внутри loop-bottom-sheet-purchase-options-wrapper
        const purchaseOptionsWrapper = intervalButton.closest('.loop-bottom-sheet-purchase-options-wrapper');
        if (purchaseOptionsWrapper) {
          // Запускаем синхронизацию цен через 500мс
          triggerPriceSyncAfterClick();
        }

        // Закрываем frequency dropdown в expanded modal после выбора
        const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
        const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');
        if (isExpanded) {
          const purchaseOptionsContainer = document.querySelector('.loop-bottom-sheet-purchase-options-container');
          if (purchaseOptionsContainer) {
            const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
            if (wrapper) {
              const frequencyContainer = wrapper.querySelector('.loop-mobile-frequency-container');
              const frequencyDropdown = frequencyContainer ? frequencyContainer.querySelector('.loop-mobile-frequency-dropdown') : null;
              const selectFrequencyBtn = frequencyContainer ? frequencyContainer.querySelector('[data-dropdown="frequency"]') : null;

              if (frequencyDropdown && selectFrequencyBtn && frequencyDropdown.style.maxHeight && frequencyDropdown.style.maxHeight !== '0px') {
                // Сразу закрываем дропдаун
                frequencyDropdown.style.maxHeight = '0px';
                frequencyDropdown.style.opacity = '0';
                frequencyDropdown.style.visibility = 'hidden';
                selectFrequencyBtn.style.backgroundColor = 'transparent';
                // Убираем z-index при закрытии
                if (frequencyDropdown.classList.contains('loop-mobile-frequency-dropdown')) {
                  frequencyDropdown.style.zIndex = '1000';
                }
              }
            }
          }
        }
      }
    }, true);

    // Отслеживаем изменения классов через MutationObserver
    const observer = new MutationObserver(function (mutations) {
      // Не сохраняем, если идет процесс восстановления
      if (window.__restoringFrequencySelection) {
        return;
      }

      let shouldSave = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('loop-bundle-widget-selling-plan-container') ||
            target.classList.contains('loop-bundle-widget-frequency-interval-button')) {
            if (target.classList.contains('selected')) {
              shouldSave = true;
            }
          }
        }
      });
      if (shouldSave) {
        setTimeout(saveState, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /**
   * Добавляет текст над содержимым дропдауна "Select Frequency"
   */
  function addFrequencyDropdownText(frequencyDropdown) {
    if (!frequencyDropdown) {
      return;
    }

    // Проверяем, не добавлен ли уже текст
    let textElement = frequencyDropdown.querySelector('.loop-mobile-frequency-dropdown-text');
    if (textElement) {
      return; // Текст уже добавлен
    }

    // Создаем элемент с текстом
    textElement = document.createElement('div');
    textElement.className = 'loop-mobile-frequency-dropdown-text';
    textElement.style.cssText = `
      color: #000;
      font-size: 11px;
      font-weight: 400;
      margin-bottom: 6px;
      line-height: 1.4;
      padding-inline: 6px;
    `;

    // Создаем текст с жирным выделением
    textElement.innerHTML = 'How often would you like us to send them to you? <b>Get extra 26%</b> on subscriptions!';

    // Вставляем текст первым элементом в frequencyDropdown
    if (frequencyDropdown.firstChild) {
      frequencyDropdown.insertBefore(textElement, frequencyDropdown.firstChild);
    } else {
      frequencyDropdown.appendChild(textElement);
    }
  }

  /**
   * Устанавливает обработчики для мобильных дропдаунов
   */
  function setupMobileDropdownHandlers(purchaseOptionsContainer) {
    const wrapper = purchaseOptionsContainer.querySelector('.loop-bottom-sheet-purchase-options-wrapper');
    if (!wrapper) {
      return;
    }

    const bundleContainer = wrapper.querySelector('.loop-mobile-bundle-container');
    const frequencyContainer = wrapper.querySelector('.loop-mobile-frequency-container');
    const selectBundleBtn = bundleContainer ? bundleContainer.querySelector('[data-dropdown="bundle"]') : null;
    const selectFrequencyBtn = frequencyContainer ? frequencyContainer.querySelector('[data-dropdown="frequency"]') : null;
    const bundleDropdown = bundleContainer ? bundleContainer.querySelector('.loop-mobile-bundle-dropdown') : null;
    const frequencyDropdown = frequencyContainer ? frequencyContainer.querySelector('.loop-mobile-frequency-dropdown') : null;

    if (!selectBundleBtn && !selectFrequencyBtn) {
      return;
    }

    // Функция для открытия/закрытия дропдауна
    function toggleDropdown(button, dropdown, otherButton, otherDropdown) {
      if (!dropdown) return;

      const isOpen = dropdown.style.maxHeight && dropdown.style.maxHeight !== '0px';

      // Закрываем другой дропдаун
      if (otherDropdown) {
        otherDropdown.style.maxHeight = '0px';
        otherDropdown.style.opacity = '0';
        otherDropdown.style.visibility = 'hidden';
        if (otherButton) {
          otherButton.style.backgroundColor = 'transparent';
        }
      }

      if (isOpen) {
        // Закрываем текущий дропдаун
        dropdown.style.maxHeight = '0px';
        dropdown.style.opacity = '0';
        dropdown.style.visibility = 'hidden';
        button.style.backgroundColor = 'transparent';
        // Убираем z-index при закрытии
        if (dropdown.classList.contains('loop-mobile-frequency-dropdown')) {
          dropdown.style.zIndex = '1000';
        }
      } else {
        // Открываем текущий дропдаун
        const scrollHeight = dropdown.scrollHeight;
        dropdown.style.maxHeight = scrollHeight + 'px';
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
        button.style.backgroundColor = '#A9FA63';
        // Увеличиваем z-index при открытии для frequency dropdown
        if (dropdown.classList.contains('loop-mobile-frequency-dropdown')) {
          dropdown.style.zIndex = '1001';
          // Настраиваем наблюдение за изменениями высоты контента
          setupFrequencyDropdownHeightObserver(dropdown);
        }
      }
    }

    /**
     * Настраивает наблюдение за изменениями высоты контента в frequency dropdown
     */
    function setupFrequencyDropdownHeightObserver(dropdown) {
      if (!dropdown) {
        return;
      }

      // Проверяем, не добавлен ли уже observer
      if (dropdown.dataset.heightObserverSetup) {
        return;
      }
      dropdown.dataset.heightObserverSetup = 'true';

      // Функция для пересчета высоты дропдауна
      function updateDropdownHeight() {
        if (dropdown.style.maxHeight && dropdown.style.maxHeight !== '0px') {
          // Дропдаун открыт, пересчитываем высоту
          const newScrollHeight = dropdown.scrollHeight;
          dropdown.style.maxHeight = newScrollHeight + 'px';
        }
      }

      // Создаем observer для отслеживания изменений в контенте дропдауна
      const heightObserver = new MutationObserver(function (mutations) {
        let shouldUpdate = false;
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Проверяем, изменился ли контент в loop-bundle-widget-frequency-selling-plans-button-container
            const sellingPlansContainer = dropdown.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
            if (sellingPlansContainer) {
              shouldUpdate = true;
            }
          }
        });
        if (shouldUpdate) {
          // Используем requestAnimationFrame для плавного обновления
          requestAnimationFrame(function () {
            updateDropdownHeight();
          });
        }
      });

      // Наблюдаем за изменениями в дропдауне
      heightObserver.observe(dropdown, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });

      // Также отслеживаем клики на кнопки selling plan, которые могут открыть frequency container
      dropdown.addEventListener('click', function (e) {
        const target = e.target.closest('.loop-bundle-widget-selling-plan-container');
        if (target) {
          // Даем время для обновления DOM, затем пересчитываем высоту
          setTimeout(function () {
            updateDropdownHeight();
          }, 100);
        }
      }, true);
    }

    // Удаляем старые обработчики и добавляем новые
    if (bundleDropdown && selectBundleBtn) {
      // Удаляем старый обработчик, клонируя кнопку
      const newSelectBundleBtn = selectBundleBtn.cloneNode(true);
      selectBundleBtn.parentNode.replaceChild(newSelectBundleBtn, selectBundleBtn);

      newSelectBundleBtn.addEventListener('click', function () {
        const currentBundleDropdown = bundleContainer.querySelector('.loop-mobile-bundle-dropdown');
        const currentFrequencyDropdown = frequencyContainer.querySelector('.loop-mobile-frequency-dropdown');
        const currentSelectFrequencyBtn = frequencyContainer.querySelector('[data-dropdown="frequency"]');
        toggleDropdown(newSelectBundleBtn, currentBundleDropdown, currentSelectFrequencyBtn, currentFrequencyDropdown);
      });
    }

    if (frequencyDropdown && selectFrequencyBtn) {
      // Удаляем старый обработчик, клонируя кнопку
      const newSelectFrequencyBtn = selectFrequencyBtn.cloneNode(true);
      selectFrequencyBtn.parentNode.replaceChild(newSelectFrequencyBtn, selectFrequencyBtn);

      newSelectFrequencyBtn.addEventListener('click', function () {
        const currentBundleDropdown = bundleContainer.querySelector('.loop-mobile-bundle-dropdown');
        const currentFrequencyDropdown = frequencyContainer.querySelector('.loop-mobile-frequency-dropdown');
        const currentSelectBundleBtn = bundleContainer.querySelector('[data-dropdown="bundle"]');
        toggleDropdown(newSelectFrequencyBtn, currentFrequencyDropdown, currentSelectBundleBtn, currentBundleDropdown);
      });
    }
  }

  /**
   * Перестановка #20: Добавить loop-product-metafields после loop-selected-variant-title в мобильном списке
   */
  function addMetafieldsToMobileSelectedVariants() {
    const productsContainer = document.querySelector('.loop-bottom-sheet-body-products-container-expanded');
    if (!productsContainer) {
      return;
    }

    // Находим все контейнеры выбранных вариантов
    const variantContainers = productsContainer.querySelectorAll('.loop-selected-variant-container');

    variantContainers.forEach(function (variantContainer) {
      // Проверяем, не добавлены ли уже метафилды
      if (variantContainer.hasAttribute('data-metafields-added')) {
        return;
      }

      // Получаем handle продукта из контейнера
      const productHandle = variantContainer.getAttribute('data-product-handle');
      if (!productHandle) {
        return;
      }

      // Находим loop-selected-variant-title внутри loop-selected-variant-info
      const variantInfo = variantContainer.querySelector('.loop-selected-variant-info');
      if (!variantInfo) {
        return;
      }

      const variantTitle = variantInfo.querySelector('.loop-selected-variant-title');
      if (!variantTitle) {
        return;
      }

      // Проверяем, не добавлены ли уже метафилды после этого заголовка
      if (variantTitle.nextSibling && variantTitle.nextSibling.classList && variantTitle.nextSibling.classList.contains('loop-product-metafields')) {
        variantContainer.setAttribute('data-metafields-added', 'true');
        return;
      }

      // Функция для получения метафилдов продукта (используем ту же логику, что и в createProductMetafieldsElement)
      async function fetchProductMetafields(handle) {
        try {
          // Пробуем получить через HTML страницу продукта
          const htmlResponse = await fetch(`/products/${handle}`);
          if (htmlResponse.ok) {
            const html = await htmlResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Ищем fp-macros-wrap на странице продукта
            const macrosWrap = doc.querySelector('.fp-macros-wrap');
            if (macrosWrap) {
              const macroItems = macrosWrap.querySelectorAll('.fp-macros__item');
              let calories = '';
              let protein = '';
              let fats = '';

              // Первый элемент - calories (без "g")
              if (macroItems[0]) {
                const caloriesEl = macroItems[0].querySelector('h3');
                if (caloriesEl) {
                  calories = caloriesEl.textContent.trim();
                }
              }
              // Второй элемент - protein (с "g")
              if (macroItems[1]) {
                const proteinEl = macroItems[1].querySelector('h3');
                if (proteinEl) {
                  protein = proteinEl.textContent.trim().replace('g', '').trim();
                }
              }
              // Четвертый элемент - fats (с "g")
              if (macroItems[3]) {
                const fatsEl = macroItems[3].querySelector('h3');
                if (fatsEl) {
                  fats = fatsEl.textContent.trim().replace('g', '').trim();
                }
              }

              if (calories || protein || fats) {
                return { calories, protein, fats };
              }
            }
          }

          // Если не нашли через HTML, пробуем JSON API
          const jsonResponse = await fetch(`/products/${handle}.js`);
          if (jsonResponse.ok) {
            const product = await jsonResponse.json();

            let calories = '';
            let protein = '';
            let fats = '';

            if (product.metafields && Array.isArray(product.metafields)) {
              product.metafields.forEach(function (metafield) {
                if (metafield.namespace === 'custom' && metafield.key === 'calories') {
                  calories = metafield.value || '';
                }
                if (metafield.namespace === 'custom' && metafield.key === 'protein') {
                  protein = metafield.value || '';
                }
                if (metafield.namespace === 'custom' && metafield.key === 'fats') {
                  fats = metafield.value || '';
                }
              });

              if (calories || protein || fats) {
                return { calories, protein, fats };
              }
            }
          }

          return null;
        } catch (e) {
          return null;
        }
      }

      // Создаем элемент метафилдов
      const metafieldsElement = document.createElement('div');
      metafieldsElement.className = 'loop-product-metafields';
      metafieldsElement.style.color = '#560059';

      // Функция для обновления текста элемента метафилдов
      function updateMetafieldsElement(cal, prot, fat) {
        const parts = [];
        if (cal) {
          parts.push(`Kcal: ${cal}`);
        }
        if (prot) {
          parts.push(`Protein: ${prot}g`);
        }
        if (fat) {
          parts.push(`Fat: ${fat}g`);
        }

        if (parts.length > 0) {
          metafieldsElement.textContent = parts.join(' | ');
        } else {
          metafieldsElement.style.display = 'none';
        }
      }

      // Получаем метафилды через API
      fetchProductMetafields(productHandle).then(function (metafields) {
        if (!metafields) {
          metafieldsElement.style.display = 'none';
        } else {
          updateMetafieldsElement(metafields.calories, metafields.protein, metafields.fats);
        }

        // Вставляем элемент после loop-selected-variant-title
        if (variantTitle.parentNode) {
          variantTitle.parentNode.insertBefore(metafieldsElement, variantTitle.nextSibling);
        }
        variantContainer.setAttribute('data-metafields-added', 'true');
      }).catch(function (error) {
        metafieldsElement.style.display = 'none';
        if (variantTitle.parentNode) {
          variantTitle.parentNode.insertBefore(metafieldsElement, variantTitle.nextSibling);
        }
        variantContainer.setAttribute('data-metafields-added', 'true');
      });
    });
  }

  /**
   * Копирует loop-display-product-price перед loop-selected-variant-price-container в мобильной версии
   */
  function copyPriceToMobileSelectedVariants() {
    // Ищем контейнер с выбранными продуктами
    // Пробуем сначала loop-bottom-sheet-products-inner-container, затем loop-bottom-sheet-body-products-container-expanded
    let productsInnerContainer = document.querySelector('.loop-bottom-sheet-products-inner-container');
    if (!productsInnerContainer) {
      productsInnerContainer = document.querySelector('.loop-bottom-sheet-body-products-container-expanded');
    }
    if (!productsInnerContainer) {
      return;
    }

    // Находим все контейнеры с ценами выбранных вариантов
    const priceContainers = productsInnerContainer.querySelectorAll('.loop-selected-variant-price-container');

    priceContainers.forEach(function (priceContainer) {
      // Проверяем, не добавлена ли уже копия цены
      if (priceContainer.hasAttribute('data-price-copied')) {
        return;
      }

      // Находим родительский контейнер варианта
      const variantContainer = priceContainer.closest('.loop-selected-variant-container');
      if (!variantContainer) {
        return;
      }

      // Получаем handle продукта
      const productHandle = variantContainer.getAttribute('data-product-handle');
      if (!productHandle) {
        return;
      }

      // Ищем соответствующий loop-display-product-price из карточки продукта
      // Ищем в основном списке продуктов
      let productWrapper = document.querySelector(`[data-product-handle="${productHandle}"]`);
      if (!productWrapper) {
        // Пробуем найти через loop-bundle-product-wrapper
        const productWrappers = document.querySelectorAll('.loop-bundle-product-wrapper');
        productWrappers.forEach(function (wrapper) {
          const card = wrapper.querySelector(`[data-product-handle="${productHandle}"]`);
          if (card) {
            productWrapper = wrapper;
          }
        });
      }
      if (!productWrapper) {
        return;
      }

      // Ищем loop-display-product-price в карточке продукта
      // Сначала ищем в loop-body-footer-wrapper, затем в самом productWrapper
      let priceElement = productWrapper.querySelector('.loop-body-footer-wrapper .loop-display-product-price');
      if (!priceElement) {
        priceElement = productWrapper.querySelector('.loop-display-product-price');
      }
      if (!priceElement) {
        return;
      }

      // Ищем loop-product-metafields рядом с ценой (в том же loop-body-footer-wrapper или рядом)
      let metafieldsElement = null;
      const footerWrapper = priceElement.closest('.loop-body-footer-wrapper');
      if (footerWrapper) {
        metafieldsElement = footerWrapper.querySelector('.loop-product-metafields');
      }
      if (!metafieldsElement) {
        // Пробуем найти в родителе цены или рядом
        const priceParent = priceElement.parentElement;
        if (priceParent) {
          metafieldsElement = priceParent.querySelector('.loop-product-metafields');
        }
      }

      // Создаем обертку для цены и метафилдов
      const priceWrapper = document.createElement('div');
      priceWrapper.className = 'loop-display-product-wrapper';

      // Клонируем элемент метафилдов, если он найден
      if (metafieldsElement) {
        const clonedMetafields = metafieldsElement.cloneNode(true);
        priceWrapper.appendChild(clonedMetafields);
      }

      // Клонируем элемент цены
      const clonedPrice = priceElement.cloneNode(true);

      // Вставляем клонированную цену в обертку
      priceWrapper.appendChild(clonedPrice);

      // Вставляем обертку с метафилдами и ценой перед loop-selected-variant-price-container
      priceContainer.parentNode.insertBefore(priceWrapper, priceContainer);

      // Помечаем, что цена уже скопирована
      priceContainer.setAttribute('data-price-copied', 'true');
    });
  }

  /**
   * Перестановка #13: Создать блок фильтрации продуктов по коллекциям
   */
  function createCategoryNavigationWrapper() {
    const productsWrapper = document.querySelector('.loop-bundle-products-wrapper');
    if (!productsWrapper || !productsWrapper.parentNode) {
      return;
    }

    // Проверяем, не создан ли уже блок фильтрации
    const existingNav = document.querySelector('.loop-category-navigation-wrapper');
    if (existingNav) {
      return; // Уже создан
    }

    // Создаем контейнер для фильтров
    const navWrapper = document.createElement('div');
    navWrapper.className = 'loop-category-navigation-wrapper';
    navWrapper.style.width = '68%';
    navWrapper.style.display = 'flex';
    navWrapper.style.gap = '50px';
    navWrapper.style.paddingLeft = '30px';
    navWrapper.style.paddingBlock = '17px';
    navWrapper.style.marginBlock = '37px';
    navWrapper.style.flexWrap = 'wrap';

    // Получаем фильтры из настроек темы или используем значения по умолчанию
    const themeFilters = window.theme?.settings?.loopFilters;
    const filters = themeFilters && themeFilters.length > 0
      ? themeFilters.map(function (filter, index) {
        // Генерируем уникальный ID на основе текста и индекса
        const id = filter.text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'filter-' + index;
        // Преобразуем пустую строку в null для коллекции (уже может быть null из настроек)
        const collection = (filter.collection && typeof filter.collection === 'string' && filter.collection.trim() !== '')
          ? filter.collection.trim()
          : null;
        return {
          id: id,
          text: filter.text || '',
          collection: collection,
          isDefault: filter.isDefault || false
        };
      })
      : [
        // Значения по умолчанию, если настройки не найдены
        { id: 'all-meals', text: 'All meals', collection: null, isDefault: true },
        { id: 'lunch-dinner', text: 'Lunch & Dinner', collection: 'frontpage', isDefault: false },
        { id: 'breakfast', text: 'Breakfast', collection: 'breakfast-pots', isDefault: false }
      ];

    filters.forEach(function (filter) {
      const filterButton = document.createElement('button');
      filterButton.className = 'loop-category-filter-btn';
      filterButton.setAttribute('data-filter-id', filter.id);
      filterButton.setAttribute('data-collection', filter.collection || '');
      filterButton.textContent = filter.text;
      filterButton.style.cssText = `
        border: none;
        border-radius: 100px;
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.02em;
        text-align: center;
        cursor: pointer;
        color: #000;
        transition: background-color 0.2s;
      `;

      // Добавляем класс active для дефолтного фильтра
      if (filter.isDefault) {
        filterButton.classList.add('active');
      }

      // Добавляем обработчик клика
      filterButton.addEventListener('click', function () {
        handleFilterClick(filter.id, filter.collection);
      });

      navWrapper.appendChild(filterButton);
    });

    // Вставляем блок фильтрации в начало productsWrapper
    try {
      if (productsWrapper.firstChild) {
        productsWrapper.insertBefore(navWrapper, productsWrapper.firstChild);
      } else {
        productsWrapper.appendChild(navWrapper);
      }

      // Инициализируем observer для фильтрации новых продуктов
      initProductsFilterObserver(productsWrapper);
    } catch (e) {
      console.warn('[custom.js] Перестановка #13: Ошибка при создании блока фильтрации:', e);
    }
  }

  /**
   * Инициализирует observer для автоматической фильтрации новых продуктов
   */
  function initProductsFilterObserver(productsWrapper) {
    // Проверяем, не инициализирован ли уже observer
    if (productsWrapper.hasAttribute('data-filter-observer-init')) {
      return;
    }

    // Отдельный observer для автоматической фильтрации новых продуктов
    const productsFilterObserver = new MutationObserver(function (mutations) {
      // Если выбран фильтр (не "All meals"), применяем фильтрацию к новым продуктам
      if (currentFilter !== null) {
        let hasNewProducts = false;
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('loop-bundle-product-wrapper')) {
                  hasNewProducts = true;
                } else if (node.querySelector && node.querySelector('.loop-bundle-product-wrapper')) {
                  hasNewProducts = true;
                }
              }
            });
          }
        });

        if (hasNewProducts) {
          // Применяем фильтрацию с небольшой задержкой, чтобы продукты успели загрузиться
          setTimeout(function () {
            filterProductsByCollection(currentFilter);
          }, 300);
        }
      }
    });

    // Наблюдаем за изменениями в loop-bundle-products-wrapper
    productsFilterObserver.observe(productsWrapper, {
      childList: true,
      subtree: true
    });

    // Помечаем, что observer инициализирован
    productsWrapper.setAttribute('data-filter-observer-init', 'true');
  }

  /**
   * Обработчик клика на фильтр
   */
  function handleFilterClick(filterId, collectionHandle) {
    // Обновляем активное состояние кнопок
    const allButtons = document.querySelectorAll('.loop-category-filter-btn');
    allButtons.forEach(function (btn) {
      const isActive = btn.getAttribute('data-filter-id') === filterId;
      if (isActive) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Фильтруем продукты
    filterProductsByCollection(collectionHandle);
  }

  // Кэш для результатов проверки коллекций
  const collectionCache = {};

  // Текущий выбранный фильтр
  let currentFilter = null;

  /**
   * Фильтрует продукты по коллекции
   */
  async function filterProductsByCollection(collectionHandle) {
    // Сохраняем текущий фильтр
    currentFilter = collectionHandle;
    const productWrappers = document.querySelectorAll('.loop-bundle-product-wrapper');

    if (!productWrappers.length) {
      return;
    }

    // Если выбрано "All meals", показываем все продукты
    if (!collectionHandle) {
      productWrappers.forEach(function (wrapper) {
        wrapper.style.display = '';
      });
      return;
    }

    // Получаем список продуктов в коллекции одним запросом
    const productsInCollection = await getProductsInCollection(collectionHandle);

    // Фильтруем продукты
    Array.from(productWrappers).forEach(function (wrapper) {
      // Ищем элемент с data-product-handle (более надежный способ)
      const productCard = wrapper.querySelector('[data-product-handle]');
      if (!productCard) {
        // Если не нашли handle, показываем продукт (на всякий случай)
        wrapper.style.display = '';
        return;
      }

      const productHandle = productCard.getAttribute('data-product-handle');
      if (!productHandle) {
        wrapper.style.display = '';
        return;
      }

      // Проверяем, есть ли продукт в коллекции
      const isInCollection = productsInCollection.includes(productHandle);
      wrapper.style.display = isInCollection ? '' : 'none';
    });
  }

  /**
   * Получает список handles продуктов в коллекции
   */
  async function getProductsInCollection(collectionHandle) {
    // Проверяем кэш
    if (collectionCache[collectionHandle]) {
      return collectionCache[collectionHandle];
    }

    try {
      // Пробуем сначала получить через JSON API (если доступен)
      const jsonUrl = `/collections/${collectionHandle}/products.json`;
      let jsonResponse = null;

      try {
        jsonResponse = await fetch(jsonUrl);
        if (jsonResponse.ok) {
          const jsonData = await jsonResponse.json();
          if (jsonData && jsonData.products && Array.isArray(jsonData.products)) {
            const productHandlesArray = jsonData.products.map(function (product) {
              return product.handle;
            });
            collectionCache[collectionHandle] = productHandlesArray;
            return productHandlesArray;
          }
        }
      } catch (jsonError) {
        // JSON API недоступен, продолжаем с HTML
      }

      // Используем Collections API для получения списка продуктов через HTML
      const collectionUrl = `/collections/${collectionHandle}`;
      const response = await fetch(collectionUrl);

      if (!response.ok) {
        console.warn('[custom.js] Коллекция не найдена:', collectionHandle, 'Status:', response.status);
        return [];
      }

      // Получаем HTML страницы коллекции
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Находим все элементы с data-product-handle или ссылки на продукты
      const productHandles = new Set();

      // Ищем элементы с data-product-handle (более надежный способ)
      const productCards = doc.querySelectorAll('[data-product-handle]');
      productCards.forEach(function (card) {
        const handle = card.getAttribute('data-product-handle');
        if (handle) {
          productHandles.add(handle);
        }
      });

      // Также ищем ссылки на продукты (на случай, если data-product-handle нет)
      const productLinks = doc.querySelectorAll('a[href*="/products/"]');
      productLinks.forEach(function (link) {
        const href = link.getAttribute('href');
        const match = href.match(/\/products\/([^\/\?]+)/);
        if (match) {
          productHandles.add(match[1]);
        }
      });

      const productHandlesArray = Array.from(productHandles);

      // Кэшируем результат
      collectionCache[collectionHandle] = productHandlesArray;
      return productHandlesArray;
    } catch (e) {
      console.warn('[custom.js] Ошибка при получении списка продуктов коллекции:', e);
      return [];
    }
  }


  /**
   * Перестановка #11: Переместить первый элемент p из loop-selected-bundle-info в конец loop-selected-bundle-header
   */
  function moveFirstPFromBundleInfoToHeader() {
    const bundleInfo = document.querySelector('.loop-selected-bundle-info');
    const bundleHeader = document.querySelector('.loop-selected-bundle-header');

    if (!bundleInfo || !bundleHeader) {
      return;
    }

    // Находим первый элемент p в loop-selected-bundle-info
    const firstP = bundleInfo.querySelector('p.loop-text-p4.undefined');
    if (!firstP) {
      return;
    }

    // Проверяем, не перемещен ли уже элемент
    if (firstP.parentNode === bundleHeader) {
      return; // Уже перемещен
    }

    try {
      // Перемещаем в конец loop-selected-bundle-header
      if (bundleHeader && bundleHeader.parentNode && firstP && firstP.parentNode) {
        bundleHeader.appendChild(firstP);
      }
    } catch (e) {
      console.warn('[custom.js] Перестановка #10: Ошибка при перемещении элемента:', e);
    }
  }

  /**
   * Применяет все перестановки элементов
   */
  /**
   * Сохраняет HTML контейнера loop-bundle-widget-frequency-selling-plans-button-container
   * для последующего восстановления после возврата из модала
   */
  function saveFrequencySellingPlansContainer() {
    // Ищем контейнер в оригинальном виджете (не в closed modal)
    const originalWidgetContainer = document.querySelector('.loop-bundle-widget-container');
    if (!originalWidgetContainer) {
      return;
    }

    const buttonLayout = originalWidgetContainer.querySelector('.loop-widet-button-layout');
    if (!buttonLayout) {
      return;
    }

    const existingSellingPlansContainer = buttonLayout.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');
    if (!existingSellingPlansContainer) {
      return;
    }

    // Клонируем элемент
    const clonedContainer = existingSellingPlansContainer.cloneNode(true);
    // Убираем selected у всех кнопок в клоне
    const allIntervalButtonsInClone = clonedContainer.querySelectorAll('.loop-bundle-widget-frequency-interval-button');
    allIntervalButtonsInClone.forEach(function (btn) {
      btn.classList.remove('selected');
    });
    // Сохраняем HTML в переменную
    window.__firstPlanSelectedFrequencyContainerHTML = clonedContainer.outerHTML;
  }

  function applyAllRearrangements() {
    moveSizeSelectorUnderBundleInfo();
    moveProductTitleUnderSizeSelector();
    createFrequencyQuestion();
    moveWidgetContainerAndApplyStyles();
    manageProductWrapperSelectedClass();
    createPotsTotalQuestion();
    createSelectedBundleItemsHeader();
    reorganizeAddToCartContainer();
    createDuplicatePriceContainerBeforeSizeSelector();
    moveFirstPFromBundleInfoToHeader();
    updateBundleTitleFromSelectedSize();
    createCategoryNavigationWrapper();
    createMoreInfoBadge();
    setupTotalsUpdateOnProductActions();
    movePriceToFooterWrapperStart();
    createProductMetafieldsElement();
    moveBundleTitleToBottomSheetStart();
    createMobileTotalContainer();
    createFooterTotalContainer();
    createMobilePurchaseOptionsDropdowns();
    copyPriceToMobileSelectedVariants();
    createClosedModalBundleDropdown();

    // Восстанавливаем текст кнопок после загрузки всех элементов
    setTimeout(function () {
      restoreButtonTexts();
    }, 200);

    // Сохраняем контейнер frequency selling plans с задержкой (элемент идет из аппки)
    setTimeout(function () {
      saveFrequencySellingPlansContainer();
    }, 500);
  }

  /**
   * Инициализация: применяем перестановки после загрузки DOM
   */
  function init() {
    // Устанавливаем дефолтные значения в sessionStorage при первой загрузке страницы
    sessionStorage.setItem('loop_selected_selling_plan', 'Claim an extra 26%');
    sessionStorage.setItem('loop_selected_interval_button', 'Deliver every 1 week');

    // Настраиваем отслеживание изменений состояния frequency
    setupFrequencySelectionTracking();

    // Применяем сразу, если DOM уже загружен
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAllRearrangements);
    } else {
      applyAllRearrangements();
    }

    // Отслеживаем динамически добавляемые элементы через MutationObserver
    // Это важно для страниц, создаваемых Loop app, где элементы могут добавляться асинхронно
    let rearrangeTimeout = null;
    const observer = new MutationObserver(function (mutations) {
      let shouldApply = false;
      let hasRemovedNodes = false;

      mutations.forEach(function (mutation) {
        // Проверяем, не удаляются ли элементы, которые мы отслеживаем
        if (mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.classList) {
              if (node.classList.contains('loop-selected-bundle-items') ||
                node.classList.contains('loop-bundle-widget-add-to-cart-container') ||
                node.querySelector('.loop-selected-bundle-items') ||
                node.querySelector('.loop-bundle-widget-add-to-cart-container')) {
                hasRemovedNodes = true;
              }
            }
          });
        }

        if (mutation.addedNodes.length > 0) {
          // Проверяем, добавлен ли один из элементов, которые мы отслеживаем
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('loop-bundle-size-selector-new-wrapper') ||
                node.classList.contains('loop-selected-bundle-info') ||
                node.classList.contains('loop-bundle-select-product-title-new-container') ||
                node.classList.contains('loop-bundle-widget-container') ||
                node.classList.contains('loop-bundle-product-wrapper') ||
                node.classList.contains('loop-h2') ||
                node.classList.contains('loop-selected-bundle-items') ||
                node.classList.contains('loop-bundle-widget-add-to-cart-container') ||
                node.querySelector('.loop-bundle-size-selector-new-wrapper') ||
                node.querySelector('.loop-selected-bundle-info') ||
                node.querySelector('.loop-selected-bundle-header') ||
                node.querySelector('.loop-selected-bundle-title') ||
                node.querySelector('.loop-bundle-select-product-title-new-container') ||
                node.querySelector('.loop-bundle-widget-container') ||
                node.querySelector('.loop-bundle-product-wrapper') ||
                node.querySelector('.loop-h2.loop-bundle-size-selector-label') ||
                node.querySelector('.loop-selected-bundle-items') ||
                node.querySelector('.loop-bundle-widget-add-to-cart-container') ||
                node.classList.contains('loop-bundle-products-wrapper') ||
                node.querySelector('.loop-bundle-products-wrapper') ||
                (node.classList && node.classList.contains('loop-card-header')) ||
                (node.querySelector && node.querySelector('.loop-card-header')) ||
                (node.classList && node.classList.contains('loop-body-footer-wrapper')) ||
                (node.querySelector && node.querySelector('.loop-body-footer-wrapper')) ||
                (node.classList && node.classList.contains('loop-display-product-price')) ||
                (node.querySelector && node.querySelector('.loop-display-product-price')) ||
                (node.classList && node.classList.contains('loop-bottom-sheet-purchase-options-container')) ||
                (node.querySelector && node.querySelector('.loop-bottom-sheet-purchase-options-container')) ||
                (node.classList && node.classList.contains('loop-selected-variant-container')) ||
                (node.querySelector && node.querySelector('.loop-selected-variant-container')) ||
                (node.classList && node.classList.contains('loop-bottom-sheet-body-products-container-expanded')) ||
                (node.querySelector && node.querySelector('.loop-bottom-sheet-body-products-container-expanded')) ||
                (node.classList && node.classList.contains('loop-bottom-sheet-products-inner-container')) ||
                (node.querySelector && node.querySelector('.loop-bottom-sheet-products-inner-container')) ||
                (node.classList && node.classList.contains('loop-selected-variant-price-container')) ||
                (node.querySelector && node.querySelector('.loop-selected-variant-price-container'))
              )) {
                shouldApply = true;
              }
            }
          });
        }
      });

      // Не применяем перестановки, если удаляются важные элементы
      if (hasRemovedNodes) {
        return;
      }

      if (shouldApply) {
        // Debounce для предотвращения множественных срабатываний
        if (rearrangeTimeout) {
          clearTimeout(rearrangeTimeout);
        }
        rearrangeTimeout = setTimeout(function () {
          try {
            applyAllRearrangements();
            // Дополнительно сохраняем контейнер, если виджет появился
            const widgetContainer = document.querySelector('.loop-bundle-widget-container');
            if (widgetContainer) {
              setTimeout(function () {
                saveFrequencySellingPlansContainer();
              }, 500);
            }
          } catch (e) {
            console.warn('[custom.js] Ошибка при применении перестановок:', e);
          }
        }, 150);
      }
    });

    // Начинаем наблюдение за изменениями в DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Отдельный observer для отслеживания изменений в loop-card-footer
    // Это нужно для немедленного обновления класса selected при клике на кнопки
    const cardFooterObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // Проверяем, связано ли изменение с loop-card-footer
          const target = mutation.target;
          if (target.classList && target.classList.contains('loop-card-footer')) {
            // Находим родительский loop-bundle-product-wrapper
            const wrapper = target.closest('.loop-bundle-product-wrapper');
            if (wrapper) {
              // Обновляем класс selected для этого wrapper
              const hasQuantityControls = target.querySelector('.loop-bundle-product-quantity-controls') !== null;
              const hasAddButton = target.querySelector('.loop-add-product-btn') !== null;

              if (hasQuantityControls && !hasAddButton) {
                wrapper.classList.add('selected');
              } else if (hasAddButton && !hasQuantityControls) {
                wrapper.classList.remove('selected');
              }
            }
          }
        }
      });
    });

    // Начинаем наблюдение за изменениями в loop-card-footer элементах
    cardFooterObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Также периодически проверяем все существующие wrappers (на случай, если observer пропустил изменения)
    setInterval(function () {
      const productWrappers = document.querySelectorAll('.loop-bundle-product-wrapper');
      productWrappers.forEach(function (wrapper) {
        const cardFooter = wrapper.querySelector('.loop-card-footer');
        if (cardFooter) {
          const hasQuantityControls = cardFooter.querySelector('.loop-bundle-product-quantity-controls') !== null;
          const hasAddButton = cardFooter.querySelector('.loop-add-product-btn') !== null;

          if (hasQuantityControls && !hasAddButton) {
            wrapper.classList.add('selected');
          } else if (hasAddButton && !hasQuantityControls) {
            wrapper.classList.remove('selected');
          }
        }
      });
    }, 500); // Проверяем каждые 500мс

    // Observer для отслеживания открытия модального окна react-modal-sheet
    let modalSheetObserver = null;
    let lastModalState = null;
    let modalSheetCheckTimeout = null;

    function setupModalSheetObserver() {
      const modalSheetRoot = document.querySelector('.react-modal-sheet-root');
      if (!modalSheetRoot) {
        return;
      }

      // Проверяем текущее состояние
      const currentState = modalSheetRoot.getAttribute('data-sheet-state');
      if (currentState === 'open' && lastModalState !== 'open') {
        // Модальное окно только что открылось
        // Устанавливаем флаг сразу, чтобы предотвратить сохранение дефолтного состояния
        window.__restoringFrequencySelection = true;

        if (modalSheetCheckTimeout) {
          clearTimeout(modalSheetCheckTimeout);
        }
        modalSheetCheckTimeout = setTimeout(function () {
          createMobilePurchaseOptionsDropdowns();
          createMobileTotalContainer();
          createFooterTotalContainer();
          moveBundleTitleToBottomSheetStart();
          createClosedModalBundleDropdown();
        }, 150);
      }
      lastModalState = currentState;

      // Если observer уже существует, отключаем его
      if (modalSheetObserver) {
        modalSheetObserver.disconnect();
      }

      // Создаем новый observer
      modalSheetObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-sheet-state') {
            const newState = modalSheetRoot.getAttribute('data-sheet-state');
            if (newState === 'open' && lastModalState !== 'open') {
              // Модальное окно только что открылось
              // Устанавливаем флаг сразу, чтобы предотвратить сохранение дефолтного состояния
              window.__restoringFrequencySelection = true;

              if (modalSheetCheckTimeout) {
                clearTimeout(modalSheetCheckTimeout);
              }
              modalSheetCheckTimeout = setTimeout(function () {
                createMobilePurchaseOptionsDropdowns();
                createMobileTotalContainer();
                createFooterTotalContainer();
                moveBundleTitleToBottomSheetStart();
              }, 150);
            }
            lastModalState = newState;
          }
        });
      });

      // Начинаем наблюдение
      modalSheetObserver.observe(modalSheetRoot, {
        attributes: true,
        attributeFilter: ['data-sheet-state']
      });

      // Также наблюдаем за классом expanded у react-modal-sheet-container
      const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
      if (modalSheetContainer) {
        // Создаем observer для класса expanded, если его еще нет
        if (!window.__expandedObserver) {
          // Debounce для предотвращения слишком частых вызовов
          let expandedObserverTimeout = null;
          // Отслеживаем предыдущее состояние expanded (используем window для сохранения между вызовами)
          if (window.__previousExpandedState === undefined) {
            window.__previousExpandedState = modalSheetContainer.classList.contains('expanded');

          }
          window.__expandedObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // Проверяем, не выполняется ли уже обновление
                const existingContainer = document.querySelector('.loop-closed-modal-dropdowns-wrapper');
                if (existingContainer && existingContainer.dataset.updating === 'true') {
                  return;
                }

                // Проверяем, был ли удален класс expanded (модал закрылся)
                const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
                const isExpanded = modalSheetContainer && modalSheetContainer.classList.contains('expanded');
                const wasExpanded = window.__previousExpandedState;
                const modalCollapsed = wasExpanded && !isExpanded;
                const modalOpened = !wasExpanded && isExpanded;
                // Обновляем предыдущее состояние
                window.__previousExpandedState = isExpanded;

                // Если модал открылся, настраиваем observer для синхронизации цен (только для мобильной версии)
                if (modalOpened && window.innerWidth <= 1023) {
                  setTimeout(function () {
                    setupPriceSyncObserver();
                  }, 200);
                }

                // Если модал закрылся, останавливаем observer синхронизации цен
                if (modalCollapsed) {
                  if (window.__priceSyncObserver) {
                    window.__priceSyncObserver.disconnect();
                    window.__priceSyncObserver = null;
                  }
                  if (window.__priceSyncTimeout) {
                    clearTimeout(window.__priceSyncTimeout);
                    window.__priceSyncTimeout = null;
                  }
                }

                updateFooterTotalContainer();

                // Используем debounce для createClosedModalBundleDropdown
                if (expandedObserverTimeout) {
                  clearTimeout(expandedObserverTimeout);
                }
                expandedObserverTimeout = setTimeout(function () {
                  createClosedModalBundleDropdown();

                  // Восстанавливаем текст кнопок после создания closed modal dropdowns
                  setTimeout(function () {
                    restoreButtonTexts();
                  }, 200);

                  // Если модал закрылся и есть сохраненный HTML, восстанавливаем контейнер
                  // Используем дополнительную задержку, чтобы DOM успел обновиться после createClosedModalBundleDropdown
                  if (modalCollapsed && window.__firstPlanSelectedFrequencyContainerHTML) {
                    setTimeout(function () {

                      // Ищем контейнер заново после создания, так как createClosedModalBundleDropdown мог его пересоздать
                      const existingContainer = document.querySelector('.loop-closed-modal-dropdowns-wrapper');


                      const frequencyContainer = existingContainer ? existingContainer.querySelector('.loop-closed-modal-frequency-container') : null;


                      if (frequencyContainer) {
                        const frequencyDropdown = frequencyContainer.querySelector('.loop-closed-modal-frequency-dropdown');



                        if (frequencyDropdown) {
                          // Ищем все loop-widet-button-layout в документе для отладки
                          const allButtonLayouts = document.querySelectorAll('.loop-widet-button-layout');

                          allButtonLayouts.forEach(function (layout, index) {
                            const parent = layout.closest('.loop-closed-modal-frequency-dropdown');

                          });

                          const buttonLayout = frequencyDropdown.querySelector('.loop-widet-button-layout');





                          if (buttonLayout) {
                            // Проверяем, выбран ли первый элемент
                            const allSellingPlans = frequencyDropdown.querySelectorAll('.loop-bundle-widget-selling-plan-container');


                            if (allSellingPlans.length > 0) {
                              const firstSellingPlan = allSellingPlans[0];
                              const isFirstSelected = firstSellingPlan.classList.contains('selected');


                              // Если первый элемент выбран и контейнер отсутствует, восстанавливаем его
                              if (isFirstSelected) {
                                const existingSellingPlansContainer = buttonLayout.querySelector('.loop-bundle-widget-frequency-selling-plans-button-container');


                                if (!existingSellingPlansContainer) {

                                  // Создаем элемент из сохраненного HTML
                                  const tempDiv = document.createElement('div');
                                  tempDiv.innerHTML = window.__firstPlanSelectedFrequencyContainerHTML;
                                  const restoredContainer = tempDiv.firstElementChild;


                                  if (restoredContainer) {
                                    // Устанавливаем max-height: 0 для пересоздаваемого элемента
                                    restoredContainer.style.maxHeight = '0px';




                                    // Добавляем как последний элемент в loop-widet-button-layout
                                    buttonLayout.appendChild(restoredContainer);





                                    // Добавляем стили для улучшения кликабельности
                                    const interactiveElements = restoredContainer.querySelectorAll(
                                      '.loop-bundle-widget-frequency-interval-button, button, [role="button"]'
                                    );

                                    interactiveElements.forEach(function (element) {
                                      element.style.cssText = (element.style.cssText || '') +
                                        '; -webkit-tap-highlight-color: rgba(169, 250, 99, 0.3); touch-action: manipulation; user-select: none;';
                                    });

                                  }
                                } else {

                                }
                              } else {

                              }
                            } else {

                            }
                          } else {

                          }
                        } else {

                        }
                      } else {

                      }
                    }, 100); // Дополнительная задержка для обновления DOM
                  } else {

                  }

                  expandedObserverTimeout = null;
                }, 200);
              }
            });
          });
        }
        window.__expandedObserver.observe(modalSheetContainer, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    /**
     * Настраивает MutationObserver для синхронизации цен при открытии модала (только для мобильной версии)
     * Отслеживает изменения цен в loop-products-align-new и синхронизирует их в модал корзины
     */
    function setupPriceSyncObserver() {
      // Проверяем, что это мобильная версия (1023px и меньше)
      if (window.innerWidth > 1023) {
        return;
      }

      const modalSheetContainer = document.querySelector('.react-modal-sheet-container');
      if (!modalSheetContainer) {
        return;
      }

      // Проверяем, не создан ли уже observer
      if (window.__priceSyncObserver) {
        return;
      }

      // Находим контейнер loop-products-align-new
      const productsAlignNew = document.querySelector('.loop-products-align-new');
      if (!productsAlignNew) {
        return;
      }

      // Создаем observer для синхронизации цен
      window.__priceSyncObserver = new MutationObserver(function (mutations) {
        // Проверяем, открыт ли модал
        const isExpanded = modalSheetContainer.classList.contains('expanded');
        if (!isExpanded) {
          return;
        }

        // Проверяем, есть ли изменения в ценах loop-discounted-price в loop-products-align-new
        let shouldSync = false;
        mutations.forEach(function (mutation) {
          // Проверяем изменения в тексте (characterData) или добавление/удаление элементов
          if (mutation.type === 'characterData') {
            // Проверяем, является ли измененный узел ценой или его родителем
            const target = mutation.target;
            if (target.nodeType === Node.TEXT_NODE) {
              const parent = target.parentElement;
              if (parent && parent.classList && parent.classList.contains('loop-discounted-price')) {
                shouldSync = true;
              }
            }
          } else if (mutation.type === 'childList') {
            // Проверяем, были ли добавлены или удалены элементы с классом loop-discounted-price
            const addedNodes = Array.from(mutation.addedNodes);
            const removedNodes = Array.from(mutation.removedNodes);
            const hasPriceChanges = addedNodes.some(function (node) {
              return node.nodeType === Node.ELEMENT_NODE &&
                (node.classList && node.classList.contains('loop-discounted-price') ||
                  node.querySelector && node.querySelector('.loop-discounted-price'));
            }) || removedNodes.some(function (node) {
              return node.nodeType === Node.ELEMENT_NODE &&
                (node.classList && node.classList.contains('loop-discounted-price') ||
                  node.querySelector && node.querySelector('.loop-discounted-price'));
            });
            if (hasPriceChanges) {
              shouldSync = true;
            }
          } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Проверяем изменения классов, которые могут влиять на отображение цен
            const target = mutation.target;
            if (target && target.classList && target.classList.contains('loop-discounted-price')) {
              shouldSync = true;
            }
          }
        });

        if (shouldSync) {
          // Используем debounce для предотвращения слишком частых вызовов
          if (window.__priceSyncTimeout) {
            clearTimeout(window.__priceSyncTimeout);
          }
          window.__priceSyncTimeout = setTimeout(function () {
            syncPricesFromProductsAlignToModal();
            window.__priceSyncTimeout = null;
          }, 100);
        }
      });

      // Начинаем наблюдение только за изменениями в loop-products-align-new
      window.__priceSyncObserver.observe(productsAlignNew, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // Выполняем начальную синхронизацию, если модал уже открыт
      if (modalSheetContainer.classList.contains('expanded')) {
        setTimeout(function () {
          syncPricesFromProductsAlignToModal();
        }, 300);
      }

      // Обрабатываем изменение размера окна
      function handleResize() {
        if (window.innerWidth > 1023) {
          // Если размер окна стал больше 1023px, останавливаем observer
          if (window.__priceSyncObserver) {
            window.__priceSyncObserver.disconnect();
            window.__priceSyncObserver = null;
          }
          if (window.__priceSyncTimeout) {
            clearTimeout(window.__priceSyncTimeout);
            window.__priceSyncTimeout = null;
          }
        }
      }

      // Добавляем обработчик изменения размера окна (только один раз)
      if (!window.__priceSyncResizeHandler) {
        window.__priceSyncResizeHandler = handleResize;
        window.addEventListener('resize', handleResize, { passive: true });
      }
    }


    // Инициализируем observer сразу, если элемент уже существует
    setupModalSheetObserver();

    // Также проверяем периодически, если элемент еще не существует
    const modalSheetCheckInterval = setInterval(function () {
      const modalSheetRoot = document.querySelector('.react-modal-sheet-root');
      if (modalSheetRoot) {
        setupModalSheetObserver();
        clearInterval(modalSheetCheckInterval);
      }
    }, 200);

    // Также отслеживаем появление модального окна через основной observer
    const modalObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('react-modal-sheet-root')) {
              setupModalSheetObserver();
            } else if (node.querySelector && node.querySelector('.react-modal-sheet-root')) {
              setupModalSheetObserver();
            }
            // Также отслеживаем появление purchase-options-container (только если модальное окно открыто)
            const modalSheetRoot = document.querySelector('.react-modal-sheet-root');
            if (modalSheetRoot && modalSheetRoot.getAttribute('data-sheet-state') === 'open') {
              const purchaseOptionsContainer = node.classList && node.classList.contains('loop-bottom-sheet-purchase-options-container')
                ? node
                : (node.querySelector && node.querySelector('.loop-bottom-sheet-purchase-options-container'));

              if (purchaseOptionsContainer && !purchaseOptionsContainer.hasAttribute('data-mobile-dropdowns-applied')) {
                setTimeout(function () {
                  createMobilePurchaseOptionsDropdowns();
                }, 100);
              }
            }
          }
        });
      });
    });

    modalObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Дополнительный observer специально для purchase-options-container
    let purchaseOptionsObserverTimeout = null;
    const purchaseOptionsObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              const purchaseOptionsContainer = node.classList && node.classList.contains('loop-bottom-sheet-purchase-options-container')
                ? node
                : (node.querySelector && node.querySelector('.loop-bottom-sheet-purchase-options-container'));

              if (purchaseOptionsContainer && !purchaseOptionsContainer.hasAttribute('data-mobile-dropdowns-applied')) {
                // Проверяем, есть ли в нем widget-container, который нужно переместить
                const widgetContainer = purchaseOptionsContainer.querySelector('.loop-bundle-widget-container');
                const modalSheetRoot = document.querySelector('.react-modal-sheet-root');
                if (widgetContainer && modalSheetRoot && modalSheetRoot.getAttribute('data-sheet-state') === 'open') {
                  if (purchaseOptionsObserverTimeout) {
                    clearTimeout(purchaseOptionsObserverTimeout);
                  }
                  purchaseOptionsObserverTimeout = setTimeout(function () {
                    createMobilePurchaseOptionsDropdowns();
                  }, 100);
                }
              }
            }
          });
        }
      });
    });

    purchaseOptionsObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Переопределяем removeChild для безопасной обработки удаления элементов
  // Это предотвращает ошибки, когда фреймворк пытается удалить элемент,
  // который уже был перемещен или удален
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    try {
      // Проверяем, что элемент действительно является дочерним элементом
      if (child && child.parentNode === this) {
        return originalRemoveChild.call(this, child);
      } else if (child && child.parentNode) {
        // Элемент уже был перемещен, удаляем его из текущего родителя
        return originalRemoveChild.call(child.parentNode, child);
      } else {
        // Элемент уже удален, просто возвращаем его
        return child;
      }
    } catch (e) {
      // Если все равно возникает ошибка, просто возвращаем элемент
      return child;
    }
  };

  // Запускаем инициализацию
  init();

})();